import { api } from './emptyApi'

export const addTagTypes = [
  'Charger Destinations',
  'Charger Basic Auth',
  'Tariff',
  'Charger Commissioning Events',
  'Smart Charging',
  'Sites (Depots)',
  'Chargers',
  'Charging Nodes',
  'Transaction Summary Reassembly',
  'Transaction Auth Tag Backfill',
  'OCPP Authorization Rules',
  'Chargers Composite Schedule',
  'BYD Charger Mappings',
  'Admin Lifecycle States',
  'Admin Diagnostics',
  'Authorization Tags',
  'OCPP Configurations API',
  'Cost Display',
  'Reservations',
  'Chargers Data Transfer',
  'trigger-message-api',
  'OcppDestination',
  'Charger Diagnostics',
  'Transaction OCPP Tag Override',
  'Sites (v1)',
  'Charger Configurations',
  'Charger Configuration Changes',
  'Charger Connection Events',
  'BYD Raw Events',
  'Admin Message Activity',
  'Admin Fleet Connectivity',
  'Admin Charger Attention',
  'Charging Transactions',
  'Transaction Cost Calculations',
  'Reports',
  'Meter Value Interval Data',
  'Gateway Request Activity',
  'OCPP Logs',
  'Utilization',
  'Charger/Connector Summary',
  'Energy Over Time',
  'Charger Faults',
  'Baseline',
  'Profile History Records',
  'Charger Capabilities',
  'Charger Diagnostics Audit'
] as const
const injectedRtkApi = api
  .enhanceEndpoints({
    addTagTypes
  })
  .injectEndpoints({
    endpoints: (build) => ({
      getChargerDestination: build.query<GetChargerDestinationResponse, GetChargerDestinationArgs>({
        query: (queryArg) => ({ url: `/api/v1/chargers/${queryArg.chargerId}/destination` }),
        providesTags: ['Charger Destinations']
      }),
      assignChargerDestination: build.mutation<AssignChargerDestinationResponse, AssignChargerDestinationArgs>({
        query: (queryArg) => ({
          url: `/api/v1/chargers/${queryArg.chargerId}/destination`,
          method: 'PUT',
          body: queryArg.chargerDestinationUpdateModel
        }),
        invalidatesTags: ['Charger Destinations']
      }),
      setRequired: build.mutation<SetRequiredResponse, SetRequiredArgs>({
        query: (queryArg) => ({
          url: `/api/v1/chargers/${queryArg.chargerId}/basic-auth/required`,
          method: 'PUT',
          body: queryArg.basicAuthRequiredRequest
        }),
        invalidatesTags: ['Charger Basic Auth']
      }),
      setCredentials: build.mutation<SetCredentialsResponse, SetCredentialsArgs>({
        query: (queryArg) => ({
          url: `/api/v1/chargers/${queryArg.chargerId}/basic-auth/credentials`,
          method: 'PUT',
          body: queryArg.basicAuthCredentialsRequest
        }),
        invalidatesTags: ['Charger Basic Auth']
      }),
      updateTariffAssociation: build.mutation<UpdateTariffAssociationResponse, UpdateTariffAssociationArgs>({
        query: (queryArg) => ({ url: `/api/utility-tariffs`, method: 'PUT', body: queryArg.tariffAssociation }),
        invalidatesTags: ['Tariff']
      }),
      cancelTariffAssociation: build.mutation<CancelTariffAssociationResponse, CancelTariffAssociationArgs>({
        query: (queryArg) => ({
          url: `/api/utility-tariffs`,
          method: 'DELETE',
          body: queryArg.cancelTariffAssociationRequestParams
        }),
        invalidatesTags: ['Tariff']
      }),
      getServiceEvent: build.query<GetServiceEventResponse, GetServiceEventArgs>({
        query: (queryArg) => ({ url: `/api/service-events/${queryArg.eventId}` }),
        providesTags: ['Charger Commissioning Events']
      }),
      updateServiceEvent: build.mutation<UpdateServiceEventResponse, UpdateServiceEventArgs>({
        query: (queryArg) => ({
          url: `/api/service-events/${queryArg.eventId}`,
          method: 'PUT',
          body: queryArg.updateServiceEventModel
        }),
        invalidatesTags: ['Charger Commissioning Events']
      }),
      deleteServiceEvent: build.mutation<DeleteServiceEventResponse, DeleteServiceEventArgs>({
        query: (queryArg) => ({ url: `/api/service-events/${queryArg.eventId}`, method: 'DELETE' }),
        invalidatesTags: ['Charger Commissioning Events']
      }),
      getChargeProfiles: build.query<GetChargeProfilesResponse, GetChargeProfilesArgs>({
        query: (queryArg) => ({
          url: `/api/profiles`,
          params: {
            fleetId: queryArg.fleetId,
            depotId: queryArg.depotId,
            effectiveAfter: queryArg.effectiveAfter,
            orgDepth: queryArg.orgDepth,
            page: queryArg.page,
            count: queryArg.count
          }
        }),
        providesTags: ['Smart Charging']
      }),
      updateChargeProfile: build.mutation<UpdateChargeProfileResponse, UpdateChargeProfileArgs>({
        query: (queryArg) => ({
          url: `/api/profiles`,
          method: 'PUT',
          body: queryArg.chargeProfileUpdateModel,
          params: {
            force: queryArg.force,
            fleetId: queryArg.fleetId
          }
        }),
        invalidatesTags: ['Smart Charging']
      }),
      saveChargeProfile: build.mutation<SaveChargeProfileResponse, SaveChargeProfileArgs>({
        query: (queryArg) => ({
          url: `/api/profiles`,
          method: 'POST',
          body: queryArg.chargeProfileCreateModel,
          params: {
            fleetId: queryArg.fleetId
          }
        }),
        invalidatesTags: ['Smart Charging']
      }),
      clearChargingProfile: build.mutation<ClearChargingProfileResponse, ClearChargingProfileArgs>({
        query: (queryArg) => ({
          url: `/api/profiles`,
          method: 'DELETE',
          body: queryArg.chargeProfileActionRequest,
          params: {
            fleetId: queryArg.fleetId
          }
        }),
        invalidatesTags: ['Smart Charging']
      }),
      getDepots: build.query<GetDepotsResponse, GetDepotsArgs>({
        query: (queryArg) => ({
          url: `/api/depots`,
          params: {
            fleetId: queryArg.fleetId,
            organizationId: queryArg.organizationId,
            organizationIds: queryArg.organizationIds,
            siteIds: queryArg.siteIds,
            createdSince: queryArg.createdSince,
            updatedSince: queryArg.updatedSince,
            page: queryArg.page,
            count: queryArg.count,
            skipEnhanceData: queryArg.skipEnhanceData
          }
        }),
        providesTags: ['Sites (Depots)']
      }),
      updateDepot: build.mutation<UpdateDepotResponse, UpdateDepotArgs>({
        query: (queryArg) => ({ url: `/api/depots`, method: 'PUT', body: queryArg.depotMetaDataUpdateModel }),
        invalidatesTags: ['Sites (Depots)']
      }),
      createDepot: build.mutation<CreateDepotResponse, CreateDepotArgs>({
        query: (queryArg) => ({ url: `/api/depots`, method: 'POST', body: queryArg.depotCreationModel }),
        invalidatesTags: ['Sites (Depots)']
      }),
      getDepotEnergyLimits: build.query<GetDepotEnergyLimitsResponse, GetDepotEnergyLimitsArgs>({
        query: (queryArg) => ({ url: `/api/depots/${queryArg.depotId}/limits` }),
        providesTags: ['Sites (Depots)']
      }),
      updateDepotEnergyLimits: build.mutation<UpdateDepotEnergyLimitsResponse, UpdateDepotEnergyLimitsArgs>({
        query: (queryArg) => ({
          url: `/api/depots/${queryArg.depotId}/limits`,
          method: 'PUT',
          body: queryArg.depotEnergyLimitsUpdateModel
        }),
        invalidatesTags: ['Sites (Depots)']
      }),
      getChargers: build.query<GetChargersResponse, GetChargersArgs>({
        query: (queryArg) => ({
          url: `/api/chargers`,
          params: {
            fleetId: queryArg.fleetId,
            organizationId: queryArg.organizationId,
            depotId: queryArg.depotId,
            siteIds: queryArg.siteIds,
            groupIds: queryArg.groupIds,
            nodeIds: queryArg.nodeIds,
            chargerIds: queryArg.chargerIds,
            minimumPower: queryArg.minimumPower,
            availableFrom: queryArg.availableFrom,
            availableTo: queryArg.availableTo,
            createdSince: queryArg.createdSince,
            updatedSince: queryArg.updatedSince,
            chargerStatus: queryArg.chargerStatus,
            operationalStatus: queryArg.operationalStatus,
            connectivityStatus: queryArg.connectivityStatus,
            hasConnectorsPreparing: queryArg.hasConnectorsPreparing,
            hasConnectorsCharging: queryArg.hasConnectorsCharging,
            hasConnectorsFaulted: queryArg.hasConnectorsFaulted,
            hasConnectorsUnavailable: queryArg.hasConnectorsUnavailable,
            hasConnectorsAvailable: queryArg.hasConnectorsAvailable,
            hasConnectorsFinishing: queryArg.hasConnectorsFinishing,
            hasConnectorsSuspendedEV: queryArg.hasConnectorsSuspendedEv,
            hasConnectorsSuspendedEVSE: queryArg.hasConnectorsSuspendedEvse,
            heardSince: queryArg.heardSince,
            notHeardSince: queryArg.notHeardSince,
            searchString: queryArg.searchString,
            commissioningStates: queryArg.commissioningStates,
            makeModelIds: queryArg.makeModelIds,
            makeModelNames: queryArg.makeModelNames,
            manufacturerIds: queryArg.manufacturerIds,
            manufacturerNames: queryArg.manufacturerNames,
            includeDiagnosticStatus: queryArg.includeDiagnosticStatus,
            orgDepth: queryArg.orgDepth,
            page: queryArg.page,
            count: queryArg.count,
            sortBy: queryArg.sortBy,
            order: queryArg.order,
            skipEnhanceData: queryArg.skipEnhanceData
          }
        }),
        providesTags: ['Chargers']
      }),
      updateCharger: build.mutation<UpdateChargerResponse, UpdateChargerArgs>({
        query: (queryArg) => ({ url: `/api/chargers`, method: 'PUT', body: queryArg.chargerUpdateModel }),
        invalidatesTags: ['Chargers', 'Charging Nodes']
      }),
      createCharger: build.mutation<CreateChargerResponse, CreateChargerArgs>({
        query: (queryArg) => ({ url: `/api/chargers`, method: 'POST', body: queryArg.chargerCreationModel }),
        invalidatesTags: ['Chargers', 'Charging Nodes']
      }),
      reassemble: build.mutation<ReassembleResponse, ReassembleArgs>({
        query: (queryArg) => ({ url: `/api/v1/transaction-summaries/${queryArg.id}/reassemble`, method: 'POST' }),
        invalidatesTags: ['Transaction Summary Reassembly']
      }),
      listBackfillsForCharger: build.query<ListBackfillsForChargerResponse, ListBackfillsForChargerArgs>({
        query: (queryArg) => ({
          url: `/api/v1/transaction-auth-tag-backfills`,
          params: {
            chargerId: queryArg.chargerId,
            page: queryArg.page,
            size: queryArg.size,
            sort: queryArg.sort
          }
        }),
        providesTags: ['Transaction Auth Tag Backfill']
      }),
      startBackfill: build.mutation<StartBackfillResponse, StartBackfillArgs>({
        query: (queryArg) => ({
          url: `/api/v1/transaction-auth-tag-backfills`,
          method: 'POST',
          body: queryArg.startTransactionAuthTagBackfillRequest
        }),
        invalidatesTags: ['Transaction Auth Tag Backfill']
      }),
      listRules: build.query<ListRulesResponse, ListRulesArgs>({
        query: (queryArg) => ({
          url: `/api/v1/ocpp-authorization-rule`,
          params: {
            idTag: queryArg.idTag,
            entityType: queryArg.entityType,
            entityId: queryArg.entityId,
            page: queryArg.page,
            count: queryArg.count
          }
        }),
        providesTags: ['OCPP Authorization Rules']
      }),
      createRule: build.mutation<CreateRuleResponse, CreateRuleArgs>({
        query: (queryArg) => ({
          url: `/api/v1/ocpp-authorization-rule`,
          method: 'POST',
          body: queryArg.ocppAuthorizationRuleCreateRequest
        }),
        invalidatesTags: ['OCPP Authorization Rules']
      }),
      assignChargersToDestination: build.mutation<AssignChargersToDestinationResponse, AssignChargersToDestinationArgs>(
        {
          query: (queryArg) => ({
            url: `/api/v1/destinations/${queryArg.destinationId}/assign-chargers`,
            method: 'POST',
            body: queryArg.destinationAssignChargersRequestModel
          }),
          invalidatesTags: ['Charger Destinations']
        }
      ),
      submitGetCompositeSchedule: build.mutation<SubmitGetCompositeScheduleResponse, SubmitGetCompositeScheduleArgs>({
        query: (queryArg) => ({
          url: `/api/v1/chargers/${queryArg.chargerId}/composite-schedule`,
          method: 'POST',
          body: queryArg.getCompositeScheduleRequest
        }),
        invalidatesTags: ['Chargers Composite Schedule']
      }),
      updatePassword: build.mutation<UpdatePasswordResponse, UpdatePasswordArgs>({
        query: (queryArg) => ({
          url: `/api/v1/chargers/${queryArg.chargerId}/basic-auth/update-password`,
          method: 'POST'
        }),
        invalidatesTags: ['Charger Basic Auth']
      }),
      createMapping: build.mutation<CreateMappingResponse, CreateMappingArgs>({
        query: (queryArg) => ({
          url: `/api/v1/byd-charger-mappings`,
          method: 'POST',
          body: queryArg.bydChargerMappingCreateRequest
        }),
        invalidatesTags: ['BYD Charger Mappings']
      }),
      getSiteLifecycleStates: build.mutation<GetSiteLifecycleStatesResponse, GetSiteLifecycleStatesArgs>({
        query: (queryArg) => ({
          url: `/api/v1/admin/sites/lifecycle-states`,
          method: 'POST',
          body: queryArg.siteLifecycleStatesRequest
        }),
        invalidatesTags: ['Admin Lifecycle States']
      }),
      uploadDiagnostics: build.mutation<UploadDiagnosticsResponse, UploadDiagnosticsArgs>({
        query: (queryArg) => ({
          url: `/api/v1/admin/chargers/${queryArg.chargerId}/upload-diagnostics`,
          method: 'POST',
          body: queryArg.adminUploadDiagnosticsRequestModel
        }),
        invalidatesTags: ['Admin Diagnostics']
      }),
      getChargerLifecycleStates: build.mutation<GetChargerLifecycleStatesResponse, GetChargerLifecycleStatesArgs>({
        query: (queryArg) => ({
          url: `/api/v1/admin/chargers/lifecycle-states`,
          method: 'POST',
          body: queryArg.chargerLifecycleStatesRequest
        }),
        invalidatesTags: ['Admin Lifecycle States']
      }),
      getServiceEvents: build.query<GetServiceEventsResponse, GetServiceEventsArgs>({
        query: (queryArg) => ({
          url: `/api/service-events`,
          params: {
            chargerIds: queryArg.chargerIds,
            from: queryArg['from'],
            to: queryArg.to,
            page: queryArg.page,
            count: queryArg.count,
            sortBy: queryArg.sortBy,
            order: queryArg.order
          }
        }),
        providesTags: ['Charger Commissioning Events']
      }),
      createServiceEvent: build.mutation<CreateServiceEventResponse, CreateServiceEventArgs>({
        query: (queryArg) => ({ url: `/api/service-events`, method: 'POST', body: queryArg.createServiceEventModel }),
        invalidatesTags: ['Charger Commissioning Events']
      }),
      bulkCommissionDecommissionChargers: build.mutation<
        BulkCommissionDecommissionChargersResponse,
        BulkCommissionDecommissionChargersArgs
      >({
        query: (queryArg) => ({
          url: `/api/service-events/bulk-commission`,
          method: 'POST',
          body: queryArg.bulkCommissionActionRequestModel
        }),
        invalidatesTags: ['Charger Commissioning Events']
      }),
      setChargeProfile: build.mutation<SetChargeProfileResponse, SetChargeProfileArgs>({
        query: (queryArg) => ({
          url: `/api/profiles/set`,
          method: 'POST',
          body: queryArg.chargeProfileActionRequest,
          params: {
            fleetId: queryArg.fleetId
          }
        }),
        invalidatesTags: ['Smart Charging']
      }),
      cmsOcppTagsGetTags: build.query<CmsOcppTagsGetTagsResponse, CmsOcppTagsGetTagsArgs>({
        query: (queryArg) => ({
          url: `/api/organizations/tags`,
          params: {
            organizationId: queryArg.organizationId,
            orgDepth: queryArg.orgDepth,
            page: queryArg.page,
            count: queryArg.count
          }
        }),
        providesTags: ['Authorization Tags']
      }),
      cmsOcppTagsAddTags: build.mutation<CmsOcppTagsAddTagsResponse, CmsOcppTagsAddTagsArgs>({
        query: (queryArg) => ({ url: `/api/organizations/tags`, method: 'POST', body: queryArg.addTagsInputModel }),
        invalidatesTags: ['Authorization Tags']
      }),
      cmsOcppTagsRemoveTags: build.mutation<CmsOcppTagsRemoveTagsResponse, CmsOcppTagsRemoveTagsArgs>({
        query: (queryArg) => ({
          url: `/api/organizations/tags/block`,
          method: 'POST',
          body: queryArg.tagCollectionInputModel
        }),
        invalidatesTags: ['Authorization Tags']
      }),
      cmsOcppTagsAuthorizeTags: build.mutation<CmsOcppTagsAuthorizeTagsResponse, CmsOcppTagsAuthorizeTagsArgs>({
        query: (queryArg) => ({
          url: `/api/organizations/tags/authorize`,
          method: 'POST',
          body: queryArg.tagCollectionInputModel
        }),
        invalidatesTags: ['Authorization Tags']
      }),
      cmsOcppConfigurationChangeConfiguration: build.mutation<
        CmsOcppConfigurationChangeConfigurationResponse,
        CmsOcppConfigurationChangeConfigurationArgs
      >({
        query: (queryArg) => ({
          url: `/api/ocpp-configurations/${queryArg.chargerId}/change-configuration`,
          method: 'POST',
          body: queryArg.changeConfigurationKeyRequestModel
        }),
        invalidatesTags: ['OCPP Configurations API']
      }),
      cmsOcppConfigurationRefreshConfigurations: build.mutation<
        CmsOcppConfigurationRefreshConfigurationsResponse,
        CmsOcppConfigurationRefreshConfigurationsArgs
      >({
        query: (queryArg) => ({
          url: `/api/ocpp-configurations/refresh`,
          method: 'POST',
          body: queryArg.refreshChargerConfigurationParams
        }),
        invalidatesTags: ['OCPP Configurations API']
      }),
      cmsChargersGetChargingNodes: build.query<CmsChargersGetChargingNodesResponse, CmsChargersGetChargingNodesArgs>({
        query: (queryArg) => ({
          url: `/api/nodes`,
          params: {
            organizationId: queryArg.organizationId,
            organizationIds: queryArg.organizationIds,
            orgDepth: queryArg.orgDepth,
            siteIds: queryArg.siteIds,
            page: queryArg.page,
            count: queryArg.count,
            sortBy: queryArg.sortBy,
            order: queryArg.order
          }
        }),
        providesTags: ['Charging Nodes']
      }),
      cmsChargersCreateChargingNode: build.mutation<
        CmsChargersCreateChargingNodeResponse,
        CmsChargersCreateChargingNodeArgs
      >({
        query: (queryArg) => ({ url: `/api/nodes`, method: 'POST', body: queryArg.chargingNodeCreateModel }),
        invalidatesTags: ['Chargers', 'Charging Nodes']
      }),
      cmsChargersAddToNode: build.mutation<CmsChargersAddToNodeResponse, CmsChargersAddToNodeArgs>({
        query: (queryArg) => ({
          url: `/api/nodes/${queryArg.id}/chargers`,
          method: 'POST',
          body: queryArg.chargingNodeMoveChargersRequestModel
        }),
        invalidatesTags: ['Chargers', 'Charging Nodes']
      }),
      cmsChargersGetChargingNodes1: build.query<CmsChargersGetChargingNodes1Response, CmsChargersGetChargingNodes1Args>(
        {
          query: (queryArg) => ({
            url: `/api/groups`,
            params: {
              organizationId: queryArg.organizationId,
              organizationIds: queryArg.organizationIds,
              orgDepth: queryArg.orgDepth,
              siteIds: queryArg.siteIds,
              page: queryArg.page,
              count: queryArg.count,
              sortBy: queryArg.sortBy,
              order: queryArg.order
            }
          }),
          providesTags: ['Charging Nodes']
        }
      ),
      cmsChargersCreateChargingNode1: build.mutation<
        CmsChargersCreateChargingNode1Response,
        CmsChargersCreateChargingNode1Args
      >({
        query: (queryArg) => ({ url: `/api/groups`, method: 'POST', body: queryArg.chargingNodeCreateModel }),
        invalidatesTags: ['Chargers', 'Charging Nodes']
      }),
      cmsChargersAddToNode1: build.mutation<CmsChargersAddToNode1Response, CmsChargersAddToNode1Args>({
        query: (queryArg) => ({
          url: `/api/groups/${queryArg.id}/chargers`,
          method: 'POST',
          body: queryArg.chargingNodeMoveChargersRequestModel
        }),
        invalidatesTags: ['Chargers', 'Charging Nodes']
      }),
      updateFirmware: build.mutation<UpdateFirmwareResponse, UpdateFirmwareArgs>({
        query: (queryArg) => ({
          url: `/api/chargers/${queryArg.chargerId}/update-firmware`,
          method: 'POST',
          body: queryArg.updateFirmwareRequest
        }),
        invalidatesTags: ['Chargers']
      }),
      stopChargingTransaction: build.mutation<StopChargingTransactionResponse, StopChargingTransactionArgs>({
        query: (queryArg) => ({
          url: `/api/chargers/${queryArg.chargerId}/stop`,
          method: 'POST',
          params: {
            chargingSessionId: queryArg.chargingSessionId,
            chargingTransactionId: queryArg.chargingTransactionId
          }
        }),
        invalidatesTags: ['Chargers']
      }),
      startChargingTransaction: build.mutation<StartChargingTransactionResponse, StartChargingTransactionArgs>({
        query: (queryArg) => ({
          url: `/api/chargers/${queryArg.chargerId}/start`,
          method: 'POST',
          body: queryArg.chargingTransactionRequest
        }),
        invalidatesTags: ['Chargers']
      }),
      setUserPrice: build.mutation<SetUserPriceResponse, SetUserPriceArgs>({
        query: (queryArg) => ({
          url: `/api/chargers/${queryArg.chargerId}/set-user-price`,
          method: 'POST',
          body: queryArg.setUserPriceRequestInputModel
        }),
        invalidatesTags: ['Cost Display']
      }),
      sendRunningCost: build.mutation<SendRunningCostResponse, SendRunningCostArgs>({
        query: (queryArg) => ({
          url: `/api/chargers/${queryArg.chargerId}/send-running-cost`,
          method: 'POST',
          body: queryArg.sendRunningCostRequestInputModel
        }),
        invalidatesTags: ['Cost Display']
      }),
      sendFinalCost: build.mutation<SendFinalCostResponse, SendFinalCostArgs>({
        query: (queryArg) => ({
          url: `/api/chargers/${queryArg.chargerId}/send-final-cost`,
          method: 'POST',
          body: queryArg.sendFinalCostRequestInputModel
        }),
        invalidatesTags: ['Cost Display']
      }),
      resetCharger: build.mutation<ResetChargerResponse, ResetChargerArgs>({
        query: (queryArg) => ({
          url: `/api/chargers/${queryArg.chargerId}/reset`,
          method: 'POST',
          params: {
            type: queryArg['type']
          }
        }),
        invalidatesTags: ['Chargers']
      }),
      reserveNow: build.mutation<ReserveNowResponse, ReserveNowArgs>({
        query: (queryArg) => ({
          url: `/api/chargers/${queryArg.chargerId}/reserve-now`,
          method: 'POST',
          body: queryArg.reserveNowRequest
        }),
        invalidatesTags: ['Reservations']
      }),
      modifyWebsocketConnection: build.mutation<ModifyWebsocketConnectionResponse, ModifyWebsocketConnectionArgs>({
        query: (queryArg) => ({
          url: `/api/chargers/${queryArg.chargerId}/modify-websocket-connection`,
          method: 'POST',
          body: queryArg.modifyWebsocketConnectionRequest
        }),
        invalidatesTags: ['Chargers']
      }),
      getDataTransferResult: build.query<GetDataTransferResultResponse, GetDataTransferResultArgs>({
        query: (queryArg) => ({
          url: `/api/chargers/${queryArg.chargerId}/data-transfer`,
          params: {
            requestId: queryArg.requestId
          }
        }),
        providesTags: ['Chargers Data Transfer']
      }),
      sendDataTransfer: build.mutation<SendDataTransferResponse, SendDataTransferArgs>({
        query: (queryArg) => ({
          url: `/api/chargers/${queryArg.chargerId}/data-transfer`,
          method: 'POST',
          body: queryArg.dataTransferRequestModel
        }),
        invalidatesTags: ['Chargers Data Transfer']
      }),
      cancelReservation: build.mutation<CancelReservationResponse, CancelReservationArgs>({
        query: (queryArg) => ({
          url: `/api/chargers/${queryArg.chargerId}/cancel-reservation`,
          method: 'POST',
          body: queryArg.cancelReservationRequest
        }),
        invalidatesTags: ['Reservations']
      }),
      unlockConnector: build.mutation<UnlockConnectorResponse, UnlockConnectorArgs>({
        query: (queryArg) => ({
          url: `/api/chargers/unlock-connector`,
          method: 'POST',
          body: queryArg.unlockConnectorRequest
        }),
        invalidatesTags: ['Chargers']
      }),
      triggerConnectorMessage: build.mutation<TriggerConnectorMessageResponse, TriggerConnectorMessageArgs>({
        query: (queryArg) => ({
          url: `/api/chargers/trigger-connector-message`,
          method: 'POST',
          body: queryArg.triggerConnectorMessageRequest
        }),
        invalidatesTags: ['trigger-message-api']
      }),
      triggerChargerMessage: build.mutation<TriggerChargerMessageResponse, TriggerChargerMessageArgs>({
        query: (queryArg) => ({
          url: `/api/chargers/trigger-charger-message`,
          method: 'POST',
          body: queryArg.triggerChargerMessageRequest
        }),
        invalidatesTags: ['trigger-message-api']
      }),
      cmsOcppDestinationGetMultipleOcppDestinations: build.query<
        CmsOcppDestinationGetMultipleOcppDestinationsResponse,
        CmsOcppDestinationGetMultipleOcppDestinationsArgs
      >({
        query: (queryArg) => ({
          url: `/api/chargers/ocpp-destination`,
          params: {
            ids: queryArg.ids,
            destinationIds: queryArg.destinationIds,
            page: queryArg.page,
            count: queryArg.count
          }
        }),
        providesTags: ['OcppDestination']
      }),
      cmsOcppDestinationCreateOcppDestination: build.mutation<
        CmsOcppDestinationCreateOcppDestinationResponse,
        CmsOcppDestinationCreateOcppDestinationArgs
      >({
        query: (queryArg) => ({
          url: `/api/chargers/ocpp-destination`,
          method: 'POST',
          body: queryArg.createOcppDestinationModel
        }),
        invalidatesTags: ['OcppDestination']
      }),
      changeAvailability: build.mutation<ChangeAvailabilityResponse, ChangeAvailabilityArgs>({
        query: (queryArg) => ({
          url: `/api/chargers/change-availability`,
          method: 'POST',
          body: queryArg.changeAvailabilityRequest
        }),
        invalidatesTags: ['Chargers']
      }),
      getDiagnosticsRequests: build.query<GetDiagnosticsRequestsResponse, GetDiagnosticsRequestsArgs>({
        query: (queryArg) => ({
          url: `/api/charger-diagnostics`,
          params: {
            chargerId: queryArg.chargerId,
            requestedFrom: queryArg.requestedFrom,
            requestedTo: queryArg.requestedTo,
            page: queryArg.page,
            count: queryArg.count,
            sortBy: queryArg.sortBy,
            order: queryArg.order
          }
        }),
        providesTags: ['Charger Diagnostics']
      }),
      requestDiagnostics: build.mutation<RequestDiagnosticsResponse, RequestDiagnosticsArgs>({
        query: (queryArg) => ({
          url: `/api/charger-diagnostics`,
          method: 'POST',
          body: queryArg.chargerDiagnosticsRequestModel
        }),
        invalidatesTags: ['Charger Diagnostics']
      }),
      overrideOcppTag: build.mutation<OverrideOcppTagResponse, OverrideOcppTagArgs>({
        query: (queryArg) => ({
          url: `/api/v1/transaction-summaries/${queryArg.id}/ocpp-tag`,
          method: 'PATCH',
          body: queryArg.updateTransactionOcppTagRequest
        }),
        invalidatesTags: ['Transaction OCPP Tag Override']
      }),
      getRule: build.query<GetRuleResponse, GetRuleArgs>({
        query: (queryArg) => ({
          url: `/api/v1/ocpp-authorization-rule/${queryArg.idTag}/${queryArg.entityType}/${queryArg.entityId}`
        }),
        providesTags: ['OCPP Authorization Rules']
      }),
      deleteRule: build.mutation<DeleteRuleResponse, DeleteRuleArgs>({
        query: (queryArg) => ({
          url: `/api/v1/ocpp-authorization-rule/${queryArg.idTag}/${queryArg.entityType}/${queryArg.entityId}`,
          method: 'DELETE'
        }),
        invalidatesTags: ['OCPP Authorization Rules']
      }),
      updateRule: build.mutation<UpdateRuleResponse, UpdateRuleArgs>({
        query: (queryArg) => ({
          url: `/api/v1/ocpp-authorization-rule/${queryArg.idTag}/${queryArg.entityType}/${queryArg.entityId}`,
          method: 'PATCH',
          body: queryArg.ocppAuthorizationRuleUpdateRequest
        }),
        invalidatesTags: ['OCPP Authorization Rules']
      }),
      getMappings: build.query<GetMappingsResponse, GetMappingsArgs>({
        query: (queryArg) => ({
          url: `/api/v1/byd-charger-mappings/${queryArg.chargerId}`,
          params: {
            connectorId: queryArg.connectorId
          }
        }),
        providesTags: ['BYD Charger Mappings']
      }),
      deleteMapping: build.mutation<DeleteMappingResponse, DeleteMappingArgs>({
        query: (queryArg) => ({
          url: `/api/v1/byd-charger-mappings/${queryArg.chargerId}`,
          method: 'DELETE',
          params: {
            connectorId: queryArg.connectorId
          }
        }),
        invalidatesTags: ['BYD Charger Mappings']
      }),
      updateMapping: build.mutation<UpdateMappingResponse, UpdateMappingArgs>({
        query: (queryArg) => ({
          url: `/api/v1/byd-charger-mappings/${queryArg.chargerId}`,
          method: 'PATCH',
          body: queryArg.bydChargerMappingUpdateRequest
        }),
        invalidatesTags: ['BYD Charger Mappings']
      }),
      cmsChargersGetChargingNode: build.query<CmsChargersGetChargingNodeResponse, CmsChargersGetChargingNodeArgs>({
        query: (queryArg) => ({ url: `/api/nodes/${queryArg.id}` }),
        providesTags: ['Charging Nodes']
      }),
      cmsChargersDeleteChargingNode: build.mutation<
        CmsChargersDeleteChargingNodeResponse,
        CmsChargersDeleteChargingNodeArgs
      >({
        query: (queryArg) => ({ url: `/api/nodes/${queryArg.id}`, method: 'DELETE' }),
        invalidatesTags: ['Chargers', 'Charging Nodes']
      }),
      cmsChargersUpdateChargingNode: build.mutation<
        CmsChargersUpdateChargingNodeResponse,
        CmsChargersUpdateChargingNodeArgs
      >({
        query: (queryArg) => ({
          url: `/api/nodes/${queryArg.id}`,
          method: 'PATCH',
          body: queryArg.chargingNodeUpdateModel
        }),
        invalidatesTags: ['Chargers', 'Charging Nodes']
      }),
      cmsChargersGetChargingNode1: build.query<CmsChargersGetChargingNode1Response, CmsChargersGetChargingNode1Args>({
        query: (queryArg) => ({ url: `/api/groups/${queryArg.id}` }),
        providesTags: ['Charging Nodes']
      }),
      cmsChargersDeleteChargingNode1: build.mutation<
        CmsChargersDeleteChargingNode1Response,
        CmsChargersDeleteChargingNode1Args
      >({
        query: (queryArg) => ({ url: `/api/groups/${queryArg.id}`, method: 'DELETE' }),
        invalidatesTags: ['Chargers', 'Charging Nodes']
      }),
      cmsChargersUpdateChargingNode1: build.mutation<
        CmsChargersUpdateChargingNode1Response,
        CmsChargersUpdateChargingNode1Args
      >({
        query: (queryArg) => ({
          url: `/api/groups/${queryArg.id}`,
          method: 'PATCH',
          body: queryArg.chargingNodeUpdateModel
        }),
        invalidatesTags: ['Chargers', 'Charging Nodes']
      }),
      cmsOcppDestinationGetOcppDestination: build.query<
        CmsOcppDestinationGetOcppDestinationResponse,
        CmsOcppDestinationGetOcppDestinationArgs
      >({
        query: (queryArg) => ({ url: `/api/chargers/ocpp-destination/${queryArg.id}` }),
        providesTags: ['OcppDestination']
      }),
      cmsOcppDestinationDeleteOcppDestination: build.mutation<
        CmsOcppDestinationDeleteOcppDestinationResponse,
        CmsOcppDestinationDeleteOcppDestinationArgs
      >({
        query: (queryArg) => ({ url: `/api/chargers/ocpp-destination/${queryArg.id}`, method: 'DELETE' }),
        invalidatesTags: ['OcppDestination']
      }),
      cmsOcppDestinationUpdateOcppDestination: build.mutation<
        CmsOcppDestinationUpdateOcppDestinationResponse,
        CmsOcppDestinationUpdateOcppDestinationArgs
      >({
        query: (queryArg) => ({
          url: `/api/chargers/ocpp-destination/${queryArg.id}`,
          method: 'PATCH',
          body: queryArg.updateOcppDestinationModel
        }),
        invalidatesTags: ['OcppDestination']
      }),
      listOverrides: build.query<ListOverridesResponse, ListOverridesArgs>({
        query: (queryArg) => ({
          url: `/api/v1/transaction-ocpp-tag-overrides`,
          params: {
            chargerId: queryArg.chargerId,
            from: queryArg['from'],
            to: queryArg.to,
            page: queryArg.page,
            count: queryArg.count
          }
        }),
        providesTags: ['Transaction OCPP Tag Override']
      }),
      getBackfillStatus: build.query<GetBackfillStatusResponse, GetBackfillStatusArgs>({
        query: (queryArg) => ({ url: `/api/v1/transaction-auth-tag-backfills/${queryArg.backfillId}` }),
        providesTags: ['Transaction Auth Tag Backfill']
      }),
      getSites: build.query<GetSitesResponse, GetSitesArgs>({
        query: (queryArg) => ({
          url: `/api/v1/sites`,
          params: {
            organizationIds: queryArg.organizationIds,
            siteIds: queryArg.siteIds,
            createdSince: queryArg.createdSince,
            updatedSince: queryArg.updatedSince,
            page: queryArg.page,
            count: queryArg.count
          }
        }),
        providesTags: ['Sites (v1)']
      }),
      getSite: build.query<GetSiteResponse, GetSiteArgs>({
        query: (queryArg) => ({ url: `/api/v1/sites/${queryArg.siteId}` }),
        providesTags: ['Sites (v1)']
      }),
      getOcppConfigurationHistory: build.query<GetOcppConfigurationHistoryResponse, GetOcppConfigurationHistoryArgs>({
        query: (queryArg) => ({
          url: `/api/v1/chargers/${queryArg.chargerId}/configurations`,
          params: {
            latest: queryArg.latest,
            from: queryArg['from'],
            to: queryArg.to,
            page: queryArg.page,
            count: queryArg.count
          }
        }),
        providesTags: ['Charger Configurations']
      }),
      getConfigurationChanges: build.query<GetConfigurationChangesResponse, GetConfigurationChangesArgs>({
        query: (queryArg) => ({
          url: `/api/v1/chargers/${queryArg.chargerId}/configuration-changes`,
          params: {
            from: queryArg['from'],
            to: queryArg.to,
            page: queryArg.page,
            count: queryArg.count
          }
        }),
        providesTags: ['Charger Configuration Changes']
      }),
      getEvents: build.query<GetEventsResponse, GetEventsArgs>({
        query: (queryArg) => ({
          url: `/api/v1/chargers/${queryArg.chargerId}/basic-auth/events`,
          params: {
            from: queryArg['from'],
            to: queryArg.to,
            page: queryArg.page,
            count: queryArg.count
          }
        }),
        providesTags: ['Charger Basic Auth']
      }),
      getConfig: build.query<GetConfigResponse, GetConfigArgs>({
        query: (queryArg) => ({ url: `/api/v1/chargers/${queryArg.chargerId}/basic-auth-config` }),
        providesTags: ['Charger Basic Auth']
      }),
      getConnectionEvents: build.query<GetConnectionEventsResponse, GetConnectionEventsArgs>({
        query: (queryArg) => ({
          url: `/api/v1/charger-connection-events`,
          params: {
            chargerIds: queryArg.chargerIds,
            nodeId: queryArg.nodeId,
            siteId: queryArg.siteId,
            organizationId: queryArg.organizationId,
            from: queryArg['from'],
            to: queryArg.to,
            latestOnly: queryArg.latestOnly,
            page: queryArg.page,
            count: queryArg.count
          }
        }),
        providesTags: ['Charger Connection Events']
      }),
      getRawEvents: build.query<GetRawEventsResponse, GetRawEventsArgs>({
        query: (queryArg) => ({
          url: `/api/v1/byd-raw-events/${queryArg.chargerId}`,
          params: {
            from: queryArg['from'],
            to: queryArg.to,
            page: queryArg.page,
            count: queryArg.count,
            direction: queryArg.direction
          }
        }),
        providesTags: ['BYD Raw Events']
      }),
      getMessageActivity: build.query<GetMessageActivityResponse, GetMessageActivityArgs>({
        query: (queryArg) => ({
          url: `/api/v1/admin/chargers/message-activity`,
          params: {
            from: queryArg['from'],
            to: queryArg.to,
            minMessages: queryArg.minMessages,
            limit: queryArg.limit,
            organizationIds: queryArg.organizationIds,
            organizationId: queryArg.organizationId,
            orgDepth: queryArg.orgDepth,
            siteIds: queryArg.siteIds,
            nodeIds: queryArg.nodeIds
          }
        }),
        providesTags: ['Admin Message Activity']
      }),
      getFleetOnline: build.query<GetFleetOnlineResponse, GetFleetOnlineArgs>({
        query: (queryArg) => ({
          url: `/api/v1/admin/chargers/connectivity`,
          params: {
            from: queryArg['from'],
            to: queryArg.to,
            interval: queryArg.interval,
            organizationIds: queryArg.organizationIds,
            organizationId: queryArg.organizationId,
            orgDepth: queryArg.orgDepth,
            siteIds: queryArg.siteIds
          }
        }),
        providesTags: ['Admin Fleet Connectivity']
      }),
      getAttentionWorklist: build.query<GetAttentionWorklistResponse, GetAttentionWorklistArgs>({
        query: (queryArg) => ({
          url: `/api/v1/admin/chargers/attention`,
          params: {
            from: queryArg['from'],
            to: queryArg.to,
            limit: queryArg.limit,
            organizationIds: queryArg.organizationIds,
            organizationId: queryArg.organizationId,
            orgDepth: queryArg.orgDepth,
            siteIds: queryArg.siteIds,
            reasonCodes: queryArg.reasonCodes,
            sortBy: queryArg.sortBy,
            order: queryArg.order
          }
        }),
        providesTags: ['Admin Charger Attention']
      }),
      getSiteTariffMappings: build.query<GetSiteTariffMappingsResponse, GetSiteTariffMappingsArgs>({
        query: (queryArg) => ({
          url: `/api/utility-tariffs/site-mappings`,
          params: {
            siteIds: queryArg.siteIds,
            startTime: queryArg.startTime,
            endTime: queryArg.endTime
          }
        }),
        providesTags: ['Tariff']
      }),
      getAssetTariffMappings: build.query<GetAssetTariffMappingsResponse, GetAssetTariffMappingsArgs>({
        query: (queryArg) => ({
          url: `/api/utility-tariffs/asset-mappings`,
          params: {
            chargerIds: queryArg.chargerIds
          }
        }),
        providesTags: ['Tariff']
      }),
      getChargingTransactions: build.query<GetChargingTransactionsResponse, GetChargingTransactionsArgs>({
        query: (queryArg) => ({
          url: `/api/transactions`,
          params: {
            chargerId: queryArg.chargerId,
            depotId: queryArg.depotId,
            depotIds: queryArg.depotIds,
            organizationId: queryArg.organizationId,
            orgDepth: queryArg.orgDepth,
            nodeId: queryArg.nodeId,
            nodeIds: queryArg.nodeIds,
            commissioningStates: queryArg.commissioningStates,
            tagId: queryArg.tagId,
            tagIds: queryArg.tagIds,
            startTimeFrom: queryArg.startTimeFrom,
            startTimeTo: queryArg.startTimeTo,
            stopTimeFrom: queryArg.stopTimeFrom,
            stopTimeTo: queryArg.stopTimeTo,
            status: queryArg.status,
            updatedSince: queryArg.updatedSince,
            page: queryArg.page,
            count: queryArg.count,
            order: queryArg.order,
            includeCosts: queryArg.includeCosts
          }
        }),
        providesTags: ['Charging Transactions']
      }),
      getTransactionById: build.query<GetTransactionByIdResponse, GetTransactionByIdArgs>({
        query: (queryArg) => ({ url: `/api/transactions/${queryArg.id}` }),
        providesTags: ['Charging Transactions']
      }),
      getTransactionMeterValues: build.query<GetTransactionMeterValuesResponse, GetTransactionMeterValuesArgs>({
        query: (queryArg) => ({
          url: `/api/transactions/${queryArg.id}/meter-values`,
          params: {
            page: queryArg.page,
            count: queryArg.count,
            from: queryArg['from'],
            to: queryArg.to,
            includeSignedData: queryArg.includeSignedData
          }
        }),
        providesTags: ['Charging Transactions']
      }),
      cmsChargingTransactionsGetMeterValueIntervalData: build.query<
        CmsChargingTransactionsGetMeterValueIntervalDataResponse,
        CmsChargingTransactionsGetMeterValueIntervalDataArgs
      >({
        query: (queryArg) => ({
          url: `/api/transactions/${queryArg.id}/meter-data`,
          params: {
            from: queryArg['from'],
            to: queryArg.to,
            intervalPeriod: queryArg.intervalPeriod,
            measureNames: queryArg.measureNames,
            truncateToTxnBounds: queryArg.truncateToTxnBounds
          }
        }),
        providesTags: ['Charging Transactions']
      }),
      cmsChargingTransactionsInferStop: build.query<
        CmsChargingTransactionsInferStopResponse,
        CmsChargingTransactionsInferStopArgs
      >({
        query: (queryArg) => ({ url: `/api/transactions/${queryArg.id}/infer-stop` }),
        providesTags: ['Charging Transactions']
      }),
      getCostCalculationForTransaction: build.query<
        GetCostCalculationForTransactionResponse,
        GetCostCalculationForTransactionArgs
      >({
        query: (queryArg) => ({ url: `/api/transaction-costs/${queryArg.transactionId}` }),
        providesTags: ['Transaction Cost Calculations']
      }),
      getServiceEventAudit: build.query<GetServiceEventAuditResponse, GetServiceEventAuditArgs>({
        query: (queryArg) => ({
          url: `/api/service-events-audit/${queryArg.eventId}`,
          params: {
            from: queryArg['from'],
            to: queryArg.to,
            page: queryArg.page,
            count: queryArg.count,
            sortBy: queryArg.sortBy,
            order: queryArg.order
          }
        }),
        providesTags: ['Charger Commissioning Events']
      }),
      getTransactionsReport: build.query<GetTransactionsReportResponse, GetTransactionsReportArgs>({
        query: (queryArg) => ({
          url: `/api/reports/transactions`,
          params: {
            from: queryArg['from'],
            to: queryArg.to,
            organizationId: queryArg.organizationId,
            siteId: queryArg.siteId,
            nodeIds: queryArg.nodeIds,
            chargerId: queryArg.chargerId,
            commissioningStates: queryArg.commissioningStates,
            orgDepth: queryArg.orgDepth
          }
        }),
        providesTags: ['Reports']
      }),
      cmsReportsGetStatusOfTransactionReport: build.query<
        CmsReportsGetStatusOfTransactionReportResponse,
        CmsReportsGetStatusOfTransactionReportArgs
      >({
        query: (queryArg) => ({ url: `/api/reports/transactions/${queryArg.id}/status` }),
        providesTags: ['Reports']
      }),
      getMeterValueIntervalsReport: build.query<GetMeterValueIntervalsReportResponse, GetMeterValueIntervalsReportArgs>(
        {
          query: (queryArg) => ({
            url: `/api/reports/meter-value-intervals`,
            params: {
              nodeIds: queryArg.nodeIds,
              siteId: queryArg.siteId,
              commissioningStates: queryArg.commissioningStates,
              intervalPeriod: queryArg.intervalPeriod,
              from: queryArg['from'],
              to: queryArg.to
            }
          }),
          providesTags: ['Reports']
        }
      ),
      getMeterValueIntervalsReportStatus: build.query<
        GetMeterValueIntervalsReportStatusResponse,
        GetMeterValueIntervalsReportStatusArgs
      >({
        query: (queryArg) => ({ url: `/api/reports/meter-value-intervals/${queryArg.id}/status` }),
        providesTags: ['Reports']
      }),
      getChargeProfile: build.query<GetChargeProfileResponse, GetChargeProfileArgs>({
        query: (queryArg) => ({
          url: `/api/profiles/${queryArg.profileId}`,
          params: {
            fleetId: queryArg.fleetId
          }
        }),
        providesTags: ['Smart Charging']
      }),
      cmsOcppTagsFilterTags: build.query<CmsOcppTagsFilterTagsResponse, CmsOcppTagsFilterTagsArgs>({
        query: (queryArg) => ({
          url: `/api/organizations/tags/filter`,
          params: {
            organizationIds: queryArg.organizationIds,
            idTagName: queryArg.idTagName,
            isBlocked: queryArg.isBlocked,
            page: queryArg.page,
            count: queryArg.count,
            direction: queryArg.direction,
            sortBy: queryArg.sortBy
          }
        }),
        providesTags: ['Authorization Tags']
      }),
      cmsOcppConfigurationGetLatestConfigurations: build.query<
        CmsOcppConfigurationGetLatestConfigurationsResponse,
        CmsOcppConfigurationGetLatestConfigurationsArgs
      >({
        query: (queryArg) => ({
          url: `/api/ocpp-configurations`,
          params: {
            chargerIds: queryArg.chargerIds,
            siteIds: queryArg.siteIds,
            orgId: queryArg.orgId,
            orgDepth: queryArg.orgDepth
          }
        }),
        providesTags: ['OCPP Configurations API']
      }),
      cmsOcppConfigurationGetLatestConfigurationsForCharger: build.query<
        CmsOcppConfigurationGetLatestConfigurationsForChargerResponse,
        CmsOcppConfigurationGetLatestConfigurationsForChargerArgs
      >({
        query: (queryArg) => ({ url: `/api/ocpp-configurations/${queryArg.chargerId}` }),
        providesTags: ['OCPP Configurations API']
      }),
      cmsOcppConfigurationGetRefreshStatusForCharger: build.query<
        CmsOcppConfigurationGetRefreshStatusForChargerResponse,
        CmsOcppConfigurationGetRefreshStatusForChargerArgs
      >({
        query: (queryArg) => ({ url: `/api/ocpp-configurations/${queryArg.chargerId}/refresh-status` }),
        providesTags: ['OCPP Configurations API']
      }),
      cmsOcppConfigurationGetRefreshStatus: build.query<
        CmsOcppConfigurationGetRefreshStatusResponse,
        CmsOcppConfigurationGetRefreshStatusArgs
      >({
        query: (queryArg) => ({ url: `/api/ocpp-configurations/refresh-status/${queryArg.id}` }),
        providesTags: ['OCPP Configurations API']
      }),
      cmsNodeUtilization: build.query<CmsNodeUtilizationResponse, CmsNodeUtilizationArgs>({
        query: (queryArg) => ({
          url: `/api/nodes/${queryArg.id}/utilization`,
          params: {
            from: queryArg['from'],
            to: queryArg.to,
            intervalPeriod: queryArg.intervalPeriod,
            maxOnly: queryArg.maxOnly,
            measureNames: queryArg.measureNames
          }
        }),
        providesTags: ['Charging Nodes']
      }),
      cmsGetChargingNodeAudit: build.query<CmsGetChargingNodeAuditResponse, CmsGetChargingNodeAuditArgs>({
        query: (queryArg) => ({
          url: `/api/nodes/audit`,
          params: {
            organizationIds: queryArg.organizationIds,
            orgDepth: queryArg.orgDepth,
            siteIds: queryArg.siteIds,
            nodeIds: queryArg.nodeIds,
            chargerIds: queryArg.chargerIds,
            destinationIds: queryArg.destinationIds,
            userIds: queryArg.userIds,
            operations: queryArg.operations,
            fromTs: queryArg.fromTs,
            toTs: queryArg.toTs,
            page: queryArg.page,
            count: queryArg.count
          }
        }),
        providesTags: ['Charging Nodes']
      }),
      getMeterDataIntervalsBySite: build.query<GetMeterDataIntervalsBySiteResponse, GetMeterDataIntervalsBySiteArgs>({
        query: (queryArg) => ({
          url: `/api/meter-data-intervals`,
          params: {
            from: queryArg['from'],
            to: queryArg.to,
            intervalPeriod: queryArg.intervalPeriod,
            siteId: queryArg.siteId
          }
        }),
        providesTags: ['Charging Transactions', 'Meter Value Interval Data']
      }),
      cmsNodeUtilization1: build.query<CmsNodeUtilization1Response, CmsNodeUtilization1Args>({
        query: (queryArg) => ({
          url: `/api/groups/${queryArg.id}/utilization`,
          params: {
            from: queryArg['from'],
            to: queryArg.to,
            intervalPeriod: queryArg.intervalPeriod,
            maxOnly: queryArg.maxOnly,
            measureNames: queryArg.measureNames
          }
        }),
        providesTags: ['Charging Nodes']
      }),
      cmsGetChargingNodeAudit1: build.query<CmsGetChargingNodeAudit1Response, CmsGetChargingNodeAudit1Args>({
        query: (queryArg) => ({
          url: `/api/groups/audit`,
          params: {
            organizationIds: queryArg.organizationIds,
            orgDepth: queryArg.orgDepth,
            siteIds: queryArg.siteIds,
            nodeIds: queryArg.nodeIds,
            chargerIds: queryArg.chargerIds,
            destinationIds: queryArg.destinationIds,
            userIds: queryArg.userIds,
            operations: queryArg.operations,
            fromTs: queryArg.fromTs,
            toTs: queryArg.toTs,
            page: queryArg.page,
            count: queryArg.count
          }
        }),
        providesTags: ['Charging Nodes']
      }),
      getActivity: build.query<GetActivityResponse, GetActivityArgs>({
        query: (queryArg) => ({
          url: `/api/gateway-requests/${queryArg.entityId}`,
          params: {
            from: queryArg['from'],
            to: queryArg.to,
            requestType: queryArg.requestType,
            page: queryArg.page,
            count: queryArg.count
          }
        }),
        providesTags: ['Gateway Request Activity']
      }),
      getDepot: build.query<GetDepotResponse, GetDepotArgs>({
        query: (queryArg) => ({
          url: `/api/depots/${queryArg.depotId}`,
          params: {
            include: queryArg.include
          }
        }),
        providesTags: ['Sites (Depots)']
      }),
      deleteDepot: build.mutation<DeleteDepotResponse, DeleteDepotArgs>({
        query: (queryArg) => ({ url: `/api/depots/${queryArg.depotId}`, method: 'DELETE' }),
        invalidatesTags: ['Sites (Depots)']
      }),
      getDepotUtilization: build.query<GetDepotUtilizationResponse, GetDepotUtilizationArgs>({
        query: (queryArg) => ({
          url: `/api/depots/${queryArg.depotId}/utilization`,
          params: {
            from: queryArg['from'],
            to: queryArg.to,
            intervalPeriod: queryArg.intervalPeriod,
            maxOnly: queryArg.maxOnly,
            measureNames: queryArg.measureNames
          }
        }),
        providesTags: ['Sites (Depots)']
      }),
      getDepotUptime: build.query<GetDepotUptimeResponse, GetDepotUptimeArgs>({
        query: (queryArg) => ({
          url: `/api/depots/${queryArg.depotId}/uptime`,
          params: {
            from: queryArg['from'],
            to: queryArg.to
          }
        }),
        providesTags: ['Sites (Depots)']
      }),
      getDepotStatus: build.query<GetDepotStatusResponse, GetDepotStatusArgs>({
        query: (queryArg) => ({ url: `/api/depots/${queryArg.depotId}/status` }),
        providesTags: ['Sites (Depots)']
      }),
      getCharger: build.query<GetChargerResponse, GetChargerArgs>({
        query: (queryArg) => ({ url: `/api/chargers/${queryArg.chargerId}` }),
        providesTags: ['Chargers']
      }),
      deleteCharger: build.mutation<DeleteChargerResponse, DeleteChargerArgs>({
        query: (queryArg) => ({ url: `/api/chargers/${queryArg.chargerId}`, method: 'DELETE' }),
        invalidatesTags: ['Chargers', 'Charging Nodes']
      }),
      getChargerUtilizationTimeline: build.query<
        GetChargerUtilizationTimelineResponse,
        GetChargerUtilizationTimelineArgs
      >({
        query: (queryArg) => ({
          url: `/api/chargers/${queryArg.chargerId}/utilization`,
          params: {
            from: queryArg['from'],
            to: queryArg.to,
            intervalPeriod: queryArg.intervalPeriod,
            maxOnly: queryArg.maxOnly,
            measureNames: queryArg.measureNames
          }
        }),
        providesTags: ['Chargers']
      }),
      getChargerUtilizationTimelineByConnector: build.query<
        GetChargerUtilizationTimelineByConnectorResponse,
        GetChargerUtilizationTimelineByConnectorArgs
      >({
        query: (queryArg) => ({
          url: `/api/chargers/${queryArg.chargerId}/utilization/by-connector`,
          params: {
            from: queryArg['from'],
            to: queryArg.to,
            intervalPeriod: queryArg.intervalPeriod,
            maxOnly: queryArg.maxOnly,
            measureNames: queryArg.measureNames
          }
        }),
        providesTags: ['Chargers']
      }),
      getChargerUptime: build.query<GetChargerUptimeResponse, GetChargerUptimeArgs>({
        query: (queryArg) => ({
          url: `/api/chargers/${queryArg.chargerId}/uptime`,
          params: {
            from: queryArg['from'],
            to: queryArg.to
          }
        }),
        providesTags: ['Chargers']
      }),
      getMappedChargerProfiles: build.query<GetMappedChargerProfilesResponse, GetMappedChargerProfilesArgs>({
        query: (queryArg) => ({
          url: `/api/chargers/${queryArg.chargerId}/profiles`,
          params: {
            connectorId: queryArg.connectorId
          }
        }),
        providesTags: ['Chargers', 'Smart Charging']
      }),
      getChargerLogsReport: build.query<GetChargerLogsReportResponse, GetChargerLogsReportArgs>({
        query: (queryArg) => ({
          url: `/api/chargers/${queryArg.chargerId}/ocpp-logs`,
          params: {
            from: queryArg['from'],
            to: queryArg.to,
            ocppMessageTypes: queryArg.ocppMessageTypes
          }
        }),
        providesTags: ['OCPP Logs']
      }),
      getChargerLogEntries: build.query<GetChargerLogEntriesResponse, GetChargerLogEntriesArgs>({
        query: (queryArg) => ({
          url: `/api/chargers/${queryArg.chargerId}/ocpp-log-entries`,
          params: {
            from: queryArg['from'],
            to: queryArg.to,
            actions: queryArg.actions,
            excludeHeartbeats: queryArg.excludeHeartbeats,
            page: queryArg.page,
            count: queryArg.count,
            sortBy: queryArg.sortBy,
            order: queryArg.order
          }
        }),
        providesTags: ['OCPP Logs']
      }),
      getChargerFaults: build.query<GetChargerFaultsResponse, GetChargerFaultsArgs>({
        query: (queryArg) => ({
          url: `/api/chargers/${queryArg.chargerId}/faults`,
          params: {
            from: queryArg['from'],
            to: queryArg.to,
            page: queryArg.page,
            count: queryArg.count
          }
        }),
        providesTags: ['Chargers']
      }),
      getChargerConnectors: build.query<GetChargerConnectorsResponse, GetChargerConnectorsArgs>({
        query: (queryArg) => ({ url: `/api/chargers/${queryArg.chargerId}/connectors` }),
        providesTags: ['Chargers']
      }),
      getCapabilitySet: build.query<GetCapabilitySetResponse, GetCapabilitySetArgs>({
        query: (queryArg) => ({ url: `/api/chargers/${queryArg.chargerId}/capability-set` }),
        providesTags: ['Chargers']
      }),
      cmsUtilizationGetUtilization: build.query<CmsUtilizationGetUtilizationResponse, CmsUtilizationGetUtilizationArgs>(
        {
          query: (queryArg) => ({
            url: `/api/chargers/utilization`,
            params: {
              organizationId: queryArg.organizationId,
              siteIds: queryArg.siteIds,
              nodeIds: queryArg.nodeIds,
              orgDepth: queryArg.orgDepth
            }
          }),
          providesTags: ['Utilization']
        }
      ),
      getChargersTableData: build.query<GetChargersTableDataResponse, GetChargersTableDataArgs>({
        query: (queryArg) => ({
          url: `/api/chargers/timespan/table-data`,
          params: {
            organizationId: queryArg.organizationId,
            orgDepth: queryArg.orgDepth,
            siteIds: queryArg.siteIds,
            nodeIds: queryArg.nodeIds,
            fromTs: queryArg.fromTs,
            toTs: queryArg.toTs,
            page: queryArg.page,
            count: queryArg.count,
            order: queryArg.order,
            sortBy: queryArg.sortBy,
            searchString: queryArg.searchString
          }
        }),
        providesTags: ['Charger/Connector Summary']
      }),
      getSummaryData: build.query<GetSummaryDataResponse, GetSummaryDataArgs>({
        query: (queryArg) => ({
          url: `/api/chargers/timespan/summary-data`,
          params: {
            organizationId: queryArg.organizationId,
            orgDepth: queryArg.orgDepth,
            siteIds: queryArg.siteIds,
            nodeIds: queryArg.nodeIds,
            fromTs: queryArg.fromTs,
            toTs: queryArg.toTs
          }
        }),
        providesTags: ['Charger/Connector Summary']
      }),
      cmsTimespanGetHistoricalStatuses: build.query<
        CmsTimespanGetHistoricalStatusesResponse,
        CmsTimespanGetHistoricalStatusesArgs
      >({
        query: (queryArg) => ({
          url: `/api/chargers/timespan/statuses`,
          params: {
            organizationId: queryArg.organizationId,
            siteIds: queryArg.siteIds,
            nodeIds: queryArg.nodeIds,
            chargerIds: queryArg.chargerIds,
            orgDepth: queryArg.orgDepth,
            fromTs: queryArg.fromTs,
            toTs: queryArg.toTs
          }
        }),
        providesTags: ['Charger/Connector Summary']
      }),
      getEnergyOverTime: build.query<GetEnergyOverTimeResponse, GetEnergyOverTimeArgs>({
        query: (queryArg) => ({
          url: `/api/chargers/timespan/bucketed-stats`,
          params: {
            organizationId: queryArg.organizationId,
            orgDepth: queryArg.orgDepth,
            siteIds: queryArg.siteIds,
            nodeIds: queryArg.nodeIds,
            fromTs: queryArg.fromTs,
            toTs: queryArg.toTs,
            intervalPeriod: queryArg.intervalPeriod
          }
        }),
        providesTags: ['Energy Over Time']
      }),
      cmsChargersGetChargerStatus: build.query<CmsChargersGetChargerStatusResponse, CmsChargersGetChargerStatusArgs>({
        query: (queryArg) => ({
          url: `/api/chargers/status`,
          params: {
            organizationIds: queryArg.organizationIds,
            siteIds: queryArg.siteIds,
            organizationId: queryArg.organizationId,
            orgDepth: queryArg.orgDepth,
            chargerIds: queryArg.chargerIds,
            connectorIds: queryArg.connectorIds,
            statuses: queryArg.statuses,
            from: queryArg['from'],
            to: queryArg.to,
            includeBoundaries: queryArg.includeBoundaries,
            page: queryArg.page,
            count: queryArg.count,
            sortBy: queryArg.sortBy,
            order: queryArg.order
          }
        }),
        providesTags: ['Chargers']
      }),
      cmsOcppLogsGetStatusOfOcppLogsRequest: build.query<
        CmsOcppLogsGetStatusOfOcppLogsRequestResponse,
        CmsOcppLogsGetStatusOfOcppLogsRequestArgs
      >({
        query: (queryArg) => ({ url: `/api/chargers/ocpp-logs/${queryArg.id}/status` }),
        providesTags: ['OCPP Logs']
      }),
      cmsMeterDataIntervals: build.query<CmsMeterDataIntervalsResponse, CmsMeterDataIntervalsArgs>({
        query: (queryArg) => ({
          url: `/api/chargers/meter-data/intervals`,
          params: {
            from: queryArg['from'],
            to: queryArg.to,
            siteIds: queryArg.siteIds,
            organizationId: queryArg.organizationId,
            orgDepth: queryArg.orgDepth
          }
        }),
        providesTags: ['Charging Transactions']
      }),
      getLatestStatusSummary: build.query<GetLatestStatusSummaryResponse, GetLatestStatusSummaryArgs>({
        query: (queryArg) => ({
          url: `/api/chargers/latest-statuses`,
          params: {
            organizationId: queryArg.organizationId,
            siteIds: queryArg.siteIds,
            nodeIds: queryArg.nodeIds,
            orgDepth: queryArg.orgDepth,
            includeConnectorsByCharger: queryArg.includeConnectorsByCharger,
            includeConnectorsBySite: queryArg.includeConnectorsBySite,
            includeChargersBySite: queryArg.includeChargersBySite,
            includeConnectorsByNode: queryArg.includeConnectorsByNode,
            includeChargersByNode: queryArg.includeChargersByNode,
            commissioningStates: queryArg.commissioningStates
          }
        }),
        providesTags: ['Chargers']
      }),
      cmsChargerFaultsGetFaults: build.query<CmsChargerFaultsGetFaultsResponse, CmsChargerFaultsGetFaultsArgs>({
        query: (queryArg) => ({
          url: `/api/chargers/faults`,
          params: {
            chargerIds: queryArg.chargerIds,
            siteIds: queryArg.siteIds,
            nodeIds: queryArg.nodeIds,
            organizationId: queryArg.organizationId,
            occurredAfter: queryArg.occurredAfter,
            occurredBefore: queryArg.occurredBefore,
            searchString: queryArg.searchString,
            commissioningStates: queryArg.commissioningStates,
            page: queryArg.page,
            count: queryArg.count,
            sortBy: queryArg.sortBy,
            order: queryArg.order,
            includeEpisodes: queryArg.includeEpisodes
          }
        }),
        providesTags: ['Charger Faults']
      }),
      getBaselineSeries: build.query<GetBaselineSeriesResponse, GetBaselineSeriesArgs>({
        query: (queryArg) => ({
          url: `/api/chargers-baseline`,
          params: {
            siteId: queryArg.siteId,
            from: queryArg['from'],
            to: queryArg.to
          }
        }),
        providesTags: ['Baseline']
      }),
      getBaselineDaily: build.query<GetBaselineDailyResponse, GetBaselineDailyArgs>({
        query: (queryArg) => ({
          url: `/api/chargers-baseline/daily`,
          params: {
            siteIds: queryArg.siteIds,
            from: queryArg['from'],
            to: queryArg.to
          }
        }),
        providesTags: ['Baseline']
      }),
      getBaselineDailyCycles: build.query<GetBaselineDailyCyclesResponse, GetBaselineDailyCyclesArgs>({
        query: (queryArg) => ({
          url: `/api/chargers-baseline/daily/cycles`,
          params: {
            siteId: queryArg.siteId,
            count: queryArg.count,
            before: queryArg.before
          }
        }),
        providesTags: ['Baseline']
      }),
      getProfileHistories: build.query<GetProfileHistoriesResponse, GetProfileHistoriesArgs>({
        query: (queryArg) => ({
          url: `/api/charger-profile-history/${queryArg.chargerId}`,
          params: {
            latest: queryArg.latest,
            from: queryArg['from'],
            to: queryArg.to,
            page: queryArg.page,
            count: queryArg.count
          }
        }),
        providesTags: ['Profile History Records']
      }),
      getManufacturers: build.query<GetManufacturersResponse, GetManufacturersArgs>({
        query: (queryArg) => ({
          url: `/api/charger-manufacturers`,
          params: {
            page: queryArg.page,
            count: queryArg.count
          }
        }),
        providesTags: ['Charger Capabilities']
      }),
      getManufacturerMakeModels: build.query<GetManufacturerMakeModelsResponse, GetManufacturerMakeModelsArgs>({
        query: (queryArg) => ({
          url: `/api/charger-manufacturers/${queryArg.manufacturerId}/make-models`,
          params: {
            page: queryArg.page,
            count: queryArg.count
          }
        }),
        providesTags: ['Charger Capabilities']
      }),
      getDiagnosticsStatus: build.query<GetDiagnosticsStatusResponse, GetDiagnosticsStatusArgs>({
        query: (queryArg) => ({ url: `/api/charger-diagnostics/${queryArg.id}` }),
        providesTags: ['Charger Diagnostics']
      }),
      cancelDiagnosticsRequest: build.mutation<CancelDiagnosticsRequestResponse, CancelDiagnosticsRequestArgs>({
        query: (queryArg) => ({ url: `/api/charger-diagnostics/${queryArg.id}`, method: 'DELETE' }),
        invalidatesTags: ['Charger Diagnostics']
      }),
      getDiagnosticsAudit: build.query<GetDiagnosticsAuditResponse, GetDiagnosticsAuditArgs>({
        query: (queryArg) => ({
          url: `/api/charger-diagnostics-audit/${queryArg.requestId}`,
          params: {
            from: queryArg['from'],
            to: queryArg.to,
            page: queryArg.page,
            count: queryArg.count,
            sortBy: queryArg.sortBy,
            order: queryArg.order
          }
        }),
        providesTags: ['Charger Diagnostics Audit']
      }),
      clearAllConnectorProfiles: build.mutation<ClearAllConnectorProfilesResponse, ClearAllConnectorProfilesArgs>({
        query: (queryArg) => ({
          url: `/api/profiles/clear`,
          method: 'DELETE',
          body: queryArg.clearConnectorProfilesRequest,
          params: {
            fleetId: queryArg.fleetId
          }
        }),
        invalidatesTags: ['Smart Charging']
      })
    }),
    overrideExisting: false
  })
export { injectedRtkApi as enhancedApi }
export type GetChargerDestinationResponse = /** status 200 OK */ ChargerDestinationResponseModel
export type GetChargerDestinationArgs = {
  /** The charger identifier */
  chargerId: string
}
export type AssignChargerDestinationResponse = /** status 200 OK */ ChargerDestinationResponseModel
export type AssignChargerDestinationArgs = {
  /** The charger identifier */
  chargerId: string
  chargerDestinationUpdateModel: ChargerDestinationUpdateModel
}
export type SetRequiredResponse = /** status 200 OK */ BasicAuthUpdateResponse
export type SetRequiredArgs = {
  /** The charger identifier */
  chargerId: string
  basicAuthRequiredRequest: BasicAuthRequiredRequest
}
export type SetCredentialsResponse = /** status 200 OK */ BasicAuthUpdateResponse
export type SetCredentialsArgs = {
  /** The charger identifier */
  chargerId: string
  basicAuthCredentialsRequest: BasicAuthCredentialsRequest
}
export type UpdateTariffAssociationResponse = /** status 200 OK */ AssetTariffMappingModel
export type UpdateTariffAssociationArgs = {
  tariffAssociation: TariffAssociation
}
export type CancelTariffAssociationResponse = /** status 200 OK */ AssetTariffMappingModel
export type CancelTariffAssociationArgs = {
  cancelTariffAssociationRequestParams: CancelTariffAssociationRequestParams
}
export type GetServiceEventResponse = /** status 200 OK */ ServiceEventModel
export type GetServiceEventArgs = {
  /** The ID of the service event to retrieve. */
  eventId: string
}
export type UpdateServiceEventResponse = /** status 200 OK */ ServiceEventModel
export type UpdateServiceEventArgs = {
  /** The ID of the service event to update. */
  eventId: string
  updateServiceEventModel: UpdateServiceEventModel
}
export type DeleteServiceEventResponse = /** status 200 OK */ ServiceEventModel
export type DeleteServiceEventArgs = {
  /** The ID of the service event to delete. */
  eventId: string
}
export type GetChargeProfilesResponse = /** status 200 OK */ PagedResponseV0ChargeProfileModel
export type GetChargeProfilesArgs = {
  /** An identifier of a fleet by which to filter charging profiles. */
  fleetId?: string
  /** An identifier of a site (depot) by which to filter charging profiles. */
  depotId?: string
  /** An optional time-bound to filter charging profiles that start after the provided time.
    
     The filter is performed on the field effectiveFrom in the chargingProfile model, and is different from validFrom and validTo. */
  effectiveAfter?: string
  /** The amount of levels of child organizations to search and include charging profiles for. */
  orgDepth?: number
  /** An index used to retrieve the next page of charging profiles. */
  page?: number
  /** The number of charging profiles to be returned in a page. */
  count?: number
}
export type UpdateChargeProfileResponse = /** status 200 OK */ ChargeProfileModel
export type UpdateChargeProfileArgs = {
  force?: boolean
  fleetId?: string
  chargeProfileUpdateModel: ChargeProfileUpdateModel
}
export type SaveChargeProfileResponse = /** status 200 OK */ ChargeProfileModel
export type SaveChargeProfileArgs = {
  fleetId?: string
  chargeProfileCreateModel: ChargeProfileCreateModel
}
export type ClearChargingProfileResponse = /** status 200 OK */ BooleanModel
export type ClearChargingProfileArgs = {
  fleetId?: string
  chargeProfileActionRequest: ChargeProfileActionRequest
}
export type GetDepotsResponse = /** status 200 OK */ PagedResponseV0DepotModel
export type GetDepotsArgs = {
  /** [DEPRECATED] An identifier of an organization (formerly 'fleet') by which to filter sites. NOTE: this param is deprecated. Please use `organizationId` instead */
  fleetId?: string
  /** An identifier of an organization by which to filter sites. */
  organizationId?: string[]
  /** Identifier(s) of an organization (or organizations) by which to filter chargers. If passing multiple organization IDs, separate with commas. */
  organizationIds?: string[]
  /** Filter sites by a list of provided site ids */
  siteIds?: string[]
  /** Filter for sites that have been created since the provided UTC timestamp. */
  createdSince?: string
  /** Filter for sites that have been updated since the provided UTC timestamp. */
  updatedSince?: string
  /** An index used to retrieve the next page of sites. */
  page?: number
  /** The number of chargers to be returned in a page. */
  count?: number
  /** When true, skips enhanced/derived data and returns a minimal site representation. */
  skipEnhanceData?: boolean
}
export type UpdateDepotResponse = /** status 200 OK */ DepotModel
export type UpdateDepotArgs = {
  depotMetaDataUpdateModel: DepotMetaDataUpdateModel
}
export type CreateDepotResponse = /** status 200 OK */ DepotModel
export type CreateDepotArgs = {
  depotCreationModel: DepotCreationModel
}
export type GetDepotEnergyLimitsResponse = /** status 200 OK */ DepotEnergyLimitsModel
export type GetDepotEnergyLimitsArgs = {
  depotId: string
}
export type UpdateDepotEnergyLimitsResponse = /** status 200 OK */ DepotEnergyLimitsModel
export type UpdateDepotEnergyLimitsArgs = {
  depotId: string
  depotEnergyLimitsUpdateModel: DepotEnergyLimitsUpdateModel
}
export type GetChargersResponse = /** status 200 OK */ PagedResponseV0ChargerModelRead
export type GetChargersArgs = {
  /** [DEPRECATED] An identifier of an organization (formerly 'fleet') by which to filter chargers. NOTE: this param is deprecated. Please use `organizationId` instead */
  fleetId?: string
  /** Identifier(s) of an organization (or organizations) by which to filter chargers. If passing multiple organization IDs, separate with commas. */
  organizationId?: string[]
  /** [DEPRECATED] An identifier of a site (formerly 'depot') by which to filter chargers. NOTE: this param is deprecated. Please use `siteIds` instead */
  depotId?: string
  /** Filter chargers by a list of provided site ids, if provided, the depotId parameter will be ignored */
  siteIds?: string[]
  /** [DEPRECATED - Will be removed after 7/1/2025] Please use nodeIds. Filter chargers by a list of node ids. */
  groupIds?: string[]
  /** Filter chargers by a list of node ids. */
  nodeIds?: string[]
  /** Filter chargers by a list of charger ids. If this parameter is passed, this will take precedence over other parameters, including organizationIds, siteIds, and those parameters (if passed) will be ignored */
  chargerIds?: string[]
  /** Filter chargers with a power rating greater than or equal to the value provided */
  minimumPower?: number
  /** Filter for chargers that are available from the provided UTC timestamp. */
  availableFrom?: string
  /** Filter for chargers that are available to the provided UTC timestamp. */
  availableTo?: string
  /** Filter for chargers that have been created since the provided UTC timestamp. */
  createdSince?: string
  /** Filter for chargers that have been updated since the provided UTC timestamp. */
  updatedSince?: string
  /** Filter chargers by their charger status. Status values can be separated by a comma. */
  chargerStatus?: ('Operative' | 'PartiallyFaulted' | 'Faulted' | 'Unavailable' | 'Unknown' | 'Offline')[]
  /** Filter chargers by their operational status. */
  operationalStatus?: ('Operative' | 'Inoperative' | 'Unknown')[]
  /** Filter chargers by their connectivity status. */
  connectivityStatus?: 'Online' | 'Offline'
  /** Filter chargers on whether or not there are any connectors currently in the `Preparing` state. */
  hasConnectorsPreparing?: boolean
  /** Filter chargers on whether or not there are any connectors currently in the `Charging` state. */
  hasConnectorsCharging?: boolean
  /** Filter chargers on whether or not there are any connectors currently in the `Faulted` state. */
  hasConnectorsFaulted?: boolean
  /** Filter chargers on whether or not there are any connectors currently in the `Unavailable` state. */
  hasConnectorsUnavailable?: boolean
  /** Filter chargers on whether or not there are any connectors currently in the `Available` state. */
  hasConnectorsAvailable?: boolean
  /** Filter chargers on whether or not there are any connectors currently in the `Finishing` state. */
  hasConnectorsFinishing?: boolean
  /** Filter chargers on whether or not there are any connectors currently in the `SuspendedEV` state. */
  hasConnectorsSuspendedEv?: boolean
  /** Filter chargers on whether or not there are any connectors currently in the `SuspendedEVSE` state. */
  hasConnectorsSuspendedEvse?: boolean
  /** Filter for chargers that have communicated with the OCPP server since the provided timestamp. */
  heardSince?: string
  /** Filter for chargers that have *not* communicated with the OCPP server since the provided timestamp. */
  notHeardSince?: string
  /** Search (case insensitive) for chargers by their chargerID, siteName, chargerName, or a connector's EVSE ID. */
  searchString?: string
  /** List of commissioning states to filter chargers by. */
  commissioningStates?: ('PRECOMMISSIONED' | 'COMMISSIONED' | 'DECOMMISSIONED')[]
  /** Filter chargers by a list of make/model IDs */
  makeModelIds?: string[]
  /** Filter chargers by a list of make/model names */
  makeModelNames?: string[]
  /** Filter chargers by a list of manufacturer IDs */
  manufacturerIds?: string[]
  /** Filter chargers by a list of manufacturer names */
  manufacturerNames?: string[]
  /** Flag to indicate whether to include diagnostic status information in the response. */
  includeDiagnosticStatus?: boolean
  /** Depth of 'child organizations' to include in the search for chargers. Pass 0 to exclude all child organizations, and only include chargers of the specific organization being queried with organizationId. */
  orgDepth?: number
  /** An index used to retrieve the next page of chargers. */
  page?: number
  /** The number of chargers to be returned in a page. */
  count?: number
  /** A value to sort your collection of chargers by */
  sortBy?:
    | 'depotId'
    | 'chargerName'
    | 'created'
    | 'updated'
    | 'lastHeartbeatTimestamp'
    | 'externalId'
    | 'diagnosticsTimestamp'
  /** The order in which to sort your collection of chargers by. */
  order?: 'ASC' | 'DESC'
  /** When true, skips enhanced/derived data and returns a minimal charger representation. */
  skipEnhanceData?: boolean
}
export type UpdateChargerResponse = /** status 200 OK */ ChargerDetailModelRead
export type UpdateChargerArgs = {
  chargerUpdateModel: ChargerUpdateModel
}
export type CreateChargerResponse = /** status 200 OK */ ChargerDetailModelRead
export type CreateChargerArgs = {
  chargerCreationModel: ChargerCreationModel
}
export type ReassembleResponse = unknown
export type ReassembleArgs = {
  /** External transaction id. */
  id: string
}
export type ListBackfillsForChargerResponse = /** status 200 OK */ PagedResponseV0TransactionAuthTagBackfillResponse
export type ListBackfillsForChargerArgs = {
  /** Charger ID to list backfills for. */
  chargerId: string
  /** Zero-based page index (0..N) */
  page?: number
  /** The size of the page to be returned */
  size?: number
  /** Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported. */
  sort?: string[]
}
export type StartBackfillResponse = /** status 200 OK */ TransactionAuthTagBackfillResponse
export type StartBackfillArgs = {
  startTransactionAuthTagBackfillRequest: StartTransactionAuthTagBackfillRequest
}
export type ListRulesResponse = /** status 200 OK */ PagedResponseV0OcppAuthorizationRuleResponse
export type ListRulesArgs = {
  /** Filter by OCPP id tag */
  idTag?: string
  /** Filter by entity type (CHARGER, SITE, ORG, GLOBAL) */
  entityType?: string
  /** Filter by entity id; requires entityType when set */
  entityId?: string
  /** Page index (0-based). */
  page?: number
  /** Number of rules to return in a page. */
  count?: number
}
export type CreateRuleResponse = /** status 201 Created */ OcppAuthorizationRuleResponse
export type CreateRuleArgs = {
  ocppAuthorizationRuleCreateRequest: OcppAuthorizationRuleCreateRequest
}
export type AssignChargersToDestinationResponse = /** status 200 OK */ DestinationAssignChargersResponseModel
export type AssignChargersToDestinationArgs = {
  /** The target destination identifier */
  destinationId: string
  destinationAssignChargersRequestModel: DestinationAssignChargersRequestModel
}
export type SubmitGetCompositeScheduleResponse = /** status 200 OK */ GetCompositeScheduleSubmitResponse
export type SubmitGetCompositeScheduleArgs = {
  /** The identifier for the charger to query. */
  chargerId: string
  getCompositeScheduleRequest: GetCompositeScheduleRequest
}
export type UpdatePasswordResponse = /** status 200 OK */ BasicAuthPasswordUpdateResponse
export type UpdatePasswordArgs = {
  /** The charger identifier */
  chargerId: string
}
export type CreateMappingResponse = /** status 201 Created */ BydChargerMappingResponse
export type CreateMappingArgs = {
  bydChargerMappingCreateRequest: BydChargerMappingCreateRequest
}
export type GetSiteLifecycleStatesResponse = /** status 200 OK */ SiteLifecycleStatesResponse
export type GetSiteLifecycleStatesArgs = {
  siteLifecycleStatesRequest: SiteLifecycleStatesRequest
}
export type UploadDiagnosticsResponse = /** status 200 OK */ AdminUploadDiagnosticsResponseModel
export type UploadDiagnosticsArgs = {
  chargerId: string
  adminUploadDiagnosticsRequestModel: AdminUploadDiagnosticsRequestModel
}
export type GetChargerLifecycleStatesResponse = /** status 200 OK */ ChargerLifecycleStatesResponse
export type GetChargerLifecycleStatesArgs = {
  chargerLifecycleStatesRequest: ChargerLifecycleStatesRequest
}
export type GetServiceEventsResponse = /** status 200 OK */ PagedResponseV0ServiceEventModel
export type GetServiceEventsArgs = {
  /** The list of charger IDs to retrieve service events for. */
  chargerIds: string[]
  /** An optional lower time-bound to filter on the serviceEvents effectiveAsOf date. */
  from?: string
  /** An optional upper time-bound to filter on the serviceEvents effectiveAsOf date. */
  to?: string
  /** An index used to retrieve the next page of charger service events. */
  page: number
  /** The number of charger service events to be returned in a page. */
  count: number
  /** A value to sort your collection of charger service events by */
  sortBy?: 'effectiveAsOf'
  /** The order in which to sort your collection of charger service events by. */
  order?: 'ASC' | 'DESC'
}
export type CreateServiceEventResponse = /** status 200 OK */ ServiceEventModel
export type CreateServiceEventArgs = {
  createServiceEventModel: CreateServiceEventModel
}
export type BulkCommissionDecommissionChargersResponse = /** status 200 OK */ BulkCommissionActionResponseModel
export type BulkCommissionDecommissionChargersArgs = {
  bulkCommissionActionRequestModel: BulkCommissionActionRequestModel
}
export type SetChargeProfileResponse = /** status 200 OK */ SetProfileResponseModel
export type SetChargeProfileArgs = {
  fleetId?: string
  chargeProfileActionRequest: ChargeProfileActionRequest
}
export type CmsOcppTagsGetTagsResponse = /** status 200 OK */ PagedResponseV0TagResponseModel
export type CmsOcppTagsGetTagsArgs = {
  /** An identifier of a fleet by which to filter OCPP tags by, use this to filter down to one organization. */
  organizationId?: string
  /** The amount of levels of child organizations to search and include when searching for OCPP tags. */
  orgDepth?: number
  /** An index used to retrieve the next page of OCPP tags. */
  page?: number
  /** The number OCPP tags to be returned in a page. */
  count?: number
}
export type CmsOcppTagsAddTagsResponse = /** status 201 Created */ TagResponseModel[]
export type CmsOcppTagsAddTagsArgs = {
  addTagsInputModel: AddTagsInputModel
}
export type CmsOcppTagsRemoveTagsResponse = /** status 200 OK */ OcppTagCollectionModel
export type CmsOcppTagsRemoveTagsArgs = {
  tagCollectionInputModel: TagCollectionInputModel
}
export type CmsOcppTagsAuthorizeTagsResponse = /** status 200 OK */ OcppTagCollectionModel
export type CmsOcppTagsAuthorizeTagsArgs = {
  tagCollectionInputModel: TagCollectionInputModel
}
export type CmsOcppConfigurationChangeConfigurationResponse = /** status 200 OK */ ChangeConfigurationApiResponseModel
export type CmsOcppConfigurationChangeConfigurationArgs = {
  /** The unique identifier of the charger to update the configuration for */
  chargerId: string
  changeConfigurationKeyRequestModel: ChangeConfigurationKeyRequestModel
}
export type CmsOcppConfigurationRefreshConfigurationsResponse = /** status 200 OK */ RefreshConfigurationStatusModel
export type CmsOcppConfigurationRefreshConfigurationsArgs = {
  refreshChargerConfigurationParams: RefreshChargerConfigurationParams
}
export type CmsChargersGetChargingNodesResponse = /** status 200 OK */ PagedResponseV0ChargingNodeResponseModel
export type CmsChargersGetChargingNodesArgs = {
  /** The identifier of an organization by which to filter charging groups. Note: If organizationId is passed and 'organizationIds' is empty, the organizationId will be used along with orgDepth to retrieve charging groups from your organization and all child organizations. */
  organizationId?: string
  /** The identifiers of a set of organizations by which to filter charging groups. Note: If organizationIds is empty and 'organizationId' is empty, the requester's organizationId and an orgDepth of 0 will be used. */
  organizationIds?: string[]
  /** Depth of 'child organizations' to include in the search for charging groups. Pass 0 to exclude all child organizations, and only include charging groups of the specific organization being queried with organizationId. */
  orgDepth?: number
  /** A list of unique siteIds to filter your results by. */
  siteIds?: string[]
  /** An index used to retrieve the next page of charging groups. */
  page?: number
  /** The number of charging groups to be returned in a page. */
  count?: number
  /** The field by which to sort the charging groups. */
  sortBy?: 'name'
  /** The order in which to sort the charging groups. */
  order?: 'ASC' | 'DESC'
}
export type CmsChargersCreateChargingNodeResponse = /** status 200 OK */ ModifyChargingNodeResponseModel
export type CmsChargersCreateChargingNodeArgs = {
  chargingNodeCreateModel: ChargingNodeCreateModel
}
export type CmsChargersAddToNodeResponse = /** status 200 OK */ ChargingNodeMoveChargersResponseModel
export type CmsChargersAddToNodeArgs = {
  id: string
  chargingNodeMoveChargersRequestModel: ChargingNodeMoveChargersRequestModel
}
export type CmsChargersGetChargingNodes1Response = /** status 200 OK */ PagedResponseV0ChargingNodeResponseModel
export type CmsChargersGetChargingNodes1Args = {
  /** The identifier of an organization by which to filter charging groups. Note: If organizationId is passed and 'organizationIds' is empty, the organizationId will be used along with orgDepth to retrieve charging groups from your organization and all child organizations. */
  organizationId?: string
  /** The identifiers of a set of organizations by which to filter charging groups. Note: If organizationIds is empty and 'organizationId' is empty, the requester's organizationId and an orgDepth of 0 will be used. */
  organizationIds?: string[]
  /** Depth of 'child organizations' to include in the search for charging groups. Pass 0 to exclude all child organizations, and only include charging groups of the specific organization being queried with organizationId. */
  orgDepth?: number
  /** A list of unique siteIds to filter your results by. */
  siteIds?: string[]
  /** An index used to retrieve the next page of charging groups. */
  page?: number
  /** The number of charging groups to be returned in a page. */
  count?: number
  /** The field by which to sort the charging groups. */
  sortBy?: 'name'
  /** The order in which to sort the charging groups. */
  order?: 'ASC' | 'DESC'
}
export type CmsChargersCreateChargingNode1Response = /** status 200 OK */ ModifyChargingNodeResponseModel
export type CmsChargersCreateChargingNode1Args = {
  chargingNodeCreateModel: ChargingNodeCreateModel
}
export type CmsChargersAddToNode1Response = /** status 200 OK */ ChargingNodeMoveChargersResponseModel
export type CmsChargersAddToNode1Args = {
  id: string
  chargingNodeMoveChargersRequestModel: ChargingNodeMoveChargersRequestModel
}
export type UpdateFirmwareResponse = /** status 200 OK */ UpdateFirmwareResponseModel
export type UpdateFirmwareArgs = {
  /** The identifier for the charger you wish to update */
  chargerId: string
  updateFirmwareRequest: UpdateFirmwareRequest
}
export type StopChargingTransactionResponse = /** status 200 OK */ BooleanModel
export type StopChargingTransactionArgs = {
  /** The identifier for the charger you wish to stop */
  chargerId: string
  chargingSessionId?: string
  chargingTransactionId?: string
}
export type StartChargingTransactionResponse = /** status 200 OK */ TransactionStartResponseModel
export type StartChargingTransactionArgs = {
  chargerId: string
  chargingTransactionRequest: ChargingTransactionRequest
}
export type SetUserPriceResponse = /** status 200 OK */ string
export type SetUserPriceArgs = {
  /** The identifier for the charger. */
  chargerId: string
  setUserPriceRequestInputModel: SetUserPriceRequestInputModel
}
export type SendRunningCostResponse = /** status 200 OK */ string
export type SendRunningCostArgs = {
  /** The identifier for the charger. */
  chargerId: string
  sendRunningCostRequestInputModel: SendRunningCostRequestInputModel
}
export type SendFinalCostResponse = /** status 200 OK */ string
export type SendFinalCostArgs = {
  /** The identifier for the charger. */
  chargerId: string
  sendFinalCostRequestInputModel: SendFinalCostRequestInputModel
}
export type ResetChargerResponse = /** status 200 OK */ BooleanModel
export type ResetChargerArgs = {
  /** The identifier for the charger you wish to reset */
  chargerId: string
  /** Type of reset to do. A hard reset may lead to more downtime as a full power cycle is performed whereas a soft resetwill perform a software reset. */
  type?: string
}
export type ReserveNowResponse = /** status 200 OK */ ReserveNowResponseModel
export type ReserveNowArgs = {
  chargerId: string
  reserveNowRequest: ReserveNowRequest
}
export type ModifyWebsocketConnectionResponse = /** status 200 OK */ BooleanModel
export type ModifyWebsocketConnectionArgs = {
  /** The identifier for the charger whose connection should be modified */
  chargerId: string
  modifyWebsocketConnectionRequest: ModifyWebsocketConnectionRequest
}
export type GetDataTransferResultResponse = /** status 200 OK */ DataTransferResultModel
export type GetDataTransferResultArgs = {
  /** The identifier for the charger you wish to query. */
  chargerId: string
  /** The identifier for the data transfer request. */
  requestId: string
}
export type SendDataTransferResponse = /** status 200 OK */ string
export type SendDataTransferArgs = {
  /** The identifier for the charger to which you wish to send data. */
  chargerId: string
  dataTransferRequestModel: DataTransferRequestModel
}
export type CancelReservationResponse = /** status 200 OK */ CancelReservationResponseModel
export type CancelReservationArgs = {
  chargerId: string
  cancelReservationRequest: CancelReservationRequest
}
export type UnlockConnectorResponse = /** status 200 OK */ UnlockConnectorResponseModel
export type UnlockConnectorArgs = {
  unlockConnectorRequest: UnlockConnectorRequest
}
export type TriggerConnectorMessageResponse = /** status 200 OK */ TriggerMessageResponse
export type TriggerConnectorMessageArgs = {
  triggerConnectorMessageRequest: TriggerConnectorMessageRequest
}
export type TriggerChargerMessageResponse = /** status 200 OK */ TriggerMessageResponse
export type TriggerChargerMessageArgs = {
  triggerChargerMessageRequest: TriggerChargerMessageRequest
}
export type CmsOcppDestinationGetMultipleOcppDestinationsResponse =
  /** status 200 OK */ PagedResponseV0OcppDestinationResponseModel
export type CmsOcppDestinationGetMultipleOcppDestinationsArgs = {
  /** A list of unique destinationIds to filter your results by. */
  ids?: string[]
  /** A list of unique IoT destinationIds to filter your results by. */
  destinationIds?: string[]
  /** An index used to retrieve the next page of OCPP destinations. */
  page?: number
  /** The number OCPP destinations to be returned in a page. */
  count?: number
}
export type CmsOcppDestinationCreateOcppDestinationResponse = /** status 200 OK */ OcppDestinationResponseModel
export type CmsOcppDestinationCreateOcppDestinationArgs = {
  createOcppDestinationModel: CreateOcppDestinationModel
}
export type ChangeAvailabilityResponse = /** status 200 OK */ ChangeAvailabilityResponseModel
export type ChangeAvailabilityArgs = {
  changeAvailabilityRequest: ChangeAvailabilityRequest
}
export type GetDiagnosticsRequestsResponse = /** status 200 OK */ PagedResponseV0ChargerDiagnosticsResponseModel
export type GetDiagnosticsRequestsArgs = {
  /** Filter by charger ID */
  chargerId: string
  /** Filter by requests created after this timestamp */
  requestedFrom?: string
  /** Filter by requests created before this timestamp */
  requestedTo?: string
  /** Page number (0-based) */
  page?: string
  /** Number of items per page */
  count?: string
  /** Sort diagnostics requests by request time */
  sortBy?: 'requestedAt'
  /** The order in which to sort diagnostics requests */
  order?: 'ASC' | 'DESC'
}
export type RequestDiagnosticsResponse = /** status 200 OK */ ChargerDiagnosticsResponseModel
export type RequestDiagnosticsArgs = {
  chargerDiagnosticsRequestModel: ChargerDiagnosticsRequestModel
}
export type OverrideOcppTagResponse = /** status 200 OK */ UpdateTransactionOcppTagResponse
export type OverrideOcppTagArgs = {
  /** External transaction id. */
  id: string
  updateTransactionOcppTagRequest: UpdateTransactionOcppTagRequest
}
export type GetRuleResponse = /** status 200 OK */ OcppAuthorizationRuleResponse
export type GetRuleArgs = {
  /** OCPP id tag */
  idTag: string
  /** Entity type */
  entityType: 'CHARGER' | 'SITE' | 'ORG' | 'GLOBAL'
  /** Entity id */
  entityId: string
}
export type DeleteRuleResponse = unknown
export type DeleteRuleArgs = {
  /** OCPP id tag */
  idTag: string
  /** Entity type */
  entityType: 'CHARGER' | 'SITE' | 'ORG' | 'GLOBAL'
  /** Entity id */
  entityId: string
}
export type UpdateRuleResponse = /** status 200 OK */ OcppAuthorizationRuleResponse
export type UpdateRuleArgs = {
  /** OCPP id tag */
  idTag: string
  /** Entity type */
  entityType: 'CHARGER' | 'SITE' | 'ORG' | 'GLOBAL'
  /** Entity id */
  entityId: string
  ocppAuthorizationRuleUpdateRequest: OcppAuthorizationRuleUpdateRequest
}
export type GetMappingsResponse = /** status 200 OK */ BydChargerMappingResponse[]
export type GetMappingsArgs = {
  /** Charger ID */
  chargerId: string
  /** Optional connector ID filter */
  connectorId?: number
}
export type DeleteMappingResponse = unknown
export type DeleteMappingArgs = {
  /** Charger ID */
  chargerId: string
  /** Optional connector ID filter */
  connectorId?: number
}
export type UpdateMappingResponse = /** status 200 OK */ BydChargerMappingResponse
export type UpdateMappingArgs = {
  /** Charger ID */
  chargerId: string
  bydChargerMappingUpdateRequest: BydChargerMappingUpdateRequest
}
export type CmsChargersGetChargingNodeResponse = /** status 200 OK */ ChargingNodeResponseModel
export type CmsChargersGetChargingNodeArgs = {
  id: string
}
export type CmsChargersDeleteChargingNodeResponse = /** status 200 OK */ ChargingNodeDeleteResponseModel
export type CmsChargersDeleteChargingNodeArgs = {
  id: string
}
export type CmsChargersUpdateChargingNodeResponse = /** status 200 OK */ ModifyChargingNodeResponseModel
export type CmsChargersUpdateChargingNodeArgs = {
  id: string
  chargingNodeUpdateModel: ChargingNodeUpdateModel
}
export type CmsChargersGetChargingNode1Response = /** status 200 OK */ ChargingNodeResponseModel
export type CmsChargersGetChargingNode1Args = {
  id: string
}
export type CmsChargersDeleteChargingNode1Response = /** status 200 OK */ ChargingNodeDeleteResponseModel
export type CmsChargersDeleteChargingNode1Args = {
  id: string
}
export type CmsChargersUpdateChargingNode1Response = /** status 200 OK */ ModifyChargingNodeResponseModel
export type CmsChargersUpdateChargingNode1Args = {
  id: string
  chargingNodeUpdateModel: ChargingNodeUpdateModel
}
export type CmsOcppDestinationGetOcppDestinationResponse = /** status 200 OK */ OcppDestinationResponseModel
export type CmsOcppDestinationGetOcppDestinationArgs = {
  /** OCPP destination ID */
  id: string
}
export type CmsOcppDestinationDeleteOcppDestinationResponse = /** status 200 OK */ OcppDestinationResponseModel
export type CmsOcppDestinationDeleteOcppDestinationArgs = {
  /** The unique identifier of an OCPP Destination. */
  id: string
}
export type CmsOcppDestinationUpdateOcppDestinationResponse = /** status 200 OK */ OcppDestinationResponseModel
export type CmsOcppDestinationUpdateOcppDestinationArgs = {
  /** The unique identifier of an OCPP Destination. */
  id: string
  updateOcppDestinationModel: UpdateOcppDestinationModel
}
export type ListOverridesResponse = /** status 200 OK */ PagedResponseV0TransactionOcppTagOverrideModel
export type ListOverridesArgs = {
  /** Charger ID whose override history to list. */
  chargerId: string
  /** Start of time range (ISO-8601). Defaults to 30 days before 'to'. */
  from?: string
  /** End of time range (ISO-8601). Defaults to now. */
  to?: string
  /** Page index (0-based). */
  page?: number
  /** Page size (items per page). */
  count?: number
}
export type GetBackfillStatusResponse = /** status 200 OK */ TransactionAuthTagBackfillResponse
export type GetBackfillStatusArgs = {
  /** Backfill job ID. */
  backfillId: string
}
export type GetSitesResponse = /** status 200 OK */ PagedResponseV2SiteModel
export type GetSitesArgs = {
  /** Identifier(s) of an organization (or organizations) by which to filter sites. If passing multiple organization IDs, separate with commas. */
  organizationIds?: string[]
  /** Filter sites by a list of provided site ids. */
  siteIds?: string[]
  /** Filter for sites that have been created since the provided UTC timestamp. */
  createdSince?: string
  /** Filter for sites that have been updated since the provided UTC timestamp. */
  updatedSince?: string
  /** An index used to retrieve the next page of sites. */
  page?: number
  /** The number of sites to be returned in a page. */
  count?: number
}
export type GetSiteResponse = /** status 200 OK */ SiteModel
export type GetSiteArgs = {
  siteId: string
}
export type GetOcppConfigurationHistoryResponse = /** status 200 OK */ PagedResponseV0OcppConfigurationResponseModel
export type GetOcppConfigurationHistoryArgs = {
  /** Charger id */
  chargerId: string
  /** When true, return only the latest configuration snapshot. */
  latest?: boolean
  /** Inclusive lower bound on configuration retrieval time. */
  from?: string
  /** Inclusive upper bound on configuration retrieval time. */
  to?: string
  /** Page index (0-based). */
  page?: number
  /** Page size (items per page). */
  count?: number
}
export type GetConfigurationChangesResponse = /** status 200 OK */ PagedResponseV0ConfigurationChangeRecordModel
export type GetConfigurationChangesArgs = {
  /** Charger id */
  chargerId: string
  /** Inclusive lower bound on request time (ISO-8601). Defaults to now minus 1 day. The range between from and to may be at most 7 days. */
  from?: string
  /** Inclusive upper bound on request time (ISO-8601). Defaults to now. The range between from and to may be at most 7 days. */
  to?: string
  /** Page index (0-based). */
  page?: number
  /** Page size (items per page). */
  count?: number
}
export type GetEventsResponse = /** status 200 OK */ PagedResponseV0BasicAuthEventModel
export type GetEventsArgs = {
  /** The charger identifier */
  chargerId: string
  /** Start of time range (ISO-8601). Defaults to 30 days before 'to'. */
  from?: string
  /** End of time range (ISO-8601). Defaults to now. */
  to?: string
  /** Page index (0-based). */
  page?: number
  /** Page size (items per page). */
  count?: number
}
export type GetConfigResponse = /** status 200 OK */ BasicAuthConfigResponse
export type GetConfigArgs = {
  /** The charger identifier */
  chargerId: string
}
export type GetConnectionEventsResponse = /** status 200 OK */ PagedResponseV0ChargerConnectionEventModel
export type GetConnectionEventsArgs = {
  /** The list of charger IDs to retrieve connection events for. */
  chargerIds?: string[]
  /** The node ID to retrieve connection events for. */
  nodeId?: string
  /** The site ID to retrieve connection events for. */
  siteId?: string
  /** The organization ID to retrieve connection events for. */
  organizationId?: string
  /** The start time for the time range to filter events (defaults to 'to' minus 1 day). Must be within 14 days of 'to'. */
  from?: string
  /** The end time for the time range to filter events (defaults to now). The from/to range must not exceed 14 days. */
  to?: string
  /** If true, returns only the latest event per charger. Defaults to false. */
  latestOnly?: boolean
  /** An index used to retrieve the next page of connection events. */
  page: number
  /** The number of connection events to be returned in a page. */
  count: number
}
export type GetRawEventsResponse = /** status 200 OK */ PagedResponseV0BydRawEventItem
export type GetRawEventsArgs = {
  /** Charger ID */
  chargerId: string
  /** Inclusive lower bound on event time (defaults to 'to' minus 1 day). */
  from?: string
  /** Inclusive upper bound on event time (defaults to now). */
  to?: string
  /** Page index (0-based). */
  page?: number
  /** Page size (items per page, max 100). */
  count?: number
  /** Filter by direction: 'received' or 'sent'. Omit to return both. */
  direction?: 'received' | 'sent'
}
export type GetMessageActivityResponse = /** status 200 OK */ FleetMessageActivityResponse
export type GetMessageActivityArgs = {
  /** Start of the window, inclusive. ISO-8601 UTC timestamp with milliseconds. Rounded down to the hour, since the table stores hourly totals. */
  from: string
  /** End of the window, exclusive. ISO-8601 UTC timestamp with milliseconds. Rounded up to the hour, since the table stores hourly totals. */
  to: string
  /** Messages a charger has to send inside one hour to count as active and to appear in the table. Summed across every gateway node the charger used in that hour, so a charger split between two nodes is judged on what it sent, not on either half. Echoed back in the response, because "active" is a definition rather than a fact. */
  minMessages?: number
  /** How many chargers to return, chattiest first. */
  limit?: number
  /** Restrict to exactly these organizations, without expanding any of them. Omit for the whole operated fleet. */
  organizationIds?: string[]
  /** Restrict to this organization and its child organizations, down to orgDepth. Ignored when organizationIds is given. Omit for the whole operated fleet. */
  organizationId?: string
  /** How far down the organization tree organizationId reaches. Pass 0 to restrict to that organization alone. */
  orgDepth?: number
  /** Restrict to these sites. Omit for the whole operated fleet. */
  siteIds?: string[]
  /** Restrict to these gateway nodes. Omit for the whole operated fleet. */
  nodeIds?: string[]
}
export type GetFleetOnlineResponse = /** status 200 OK */ FleetOnlineResponse
export type GetFleetOnlineArgs = {
  /** Start of the window, inclusive. ISO-8601 UTC timestamp with milliseconds. */
  from: string
  /** End of the window, exclusive. ISO-8601 UTC timestamp with milliseconds. */
  to: string
  /** Rollup interval. One of 60m, 6h, 1d. Omitted, this resolves to 60m for windows up to 7 days and 1d for wider ones. Nothing finer than an hour is offered, because nothing finer is stored. */
  interval?: '60m' | '6h' | '1d'
  /** Restrict to exactly these organizations, without expanding any of them. Omit for the whole fleet. */
  organizationIds?: string[]
  /** Restrict to this organization and its child organizations, down to orgDepth. Ignored when organizationIds is given. Omit for the whole fleet. */
  organizationId?: string
  /** How far down the organization tree organizationId reaches. Pass 0 to restrict to that organization alone. */
  orgDepth?: number
  /** Restrict to these sites. Omit for the whole fleet. */
  siteIds?: string[]
}
export type GetAttentionWorklistResponse = /** status 200 OK */ ChargerAttentionResponse
export type GetAttentionWorklistArgs = {
  /** Start of the window, inclusive. ISO-8601 instant, UTC. Rounded down to the hour, since the table stores hourly totals. */
  from: string
  /** End of the window, exclusive. ISO-8601 instant, UTC. Rounded up to the hour, since the table stores hourly totals. */
  to: string
  /** How many chargers to return, most reasons first. */
  limit?: number
  /** Restrict to exactly these organizations, without expanding any of them. Omit for the whole operated fleet. */
  organizationIds?: string[]
  /** Restrict to this organization and its child organizations, down to orgDepth. Ignored when organizationIds is given. Omit for the whole operated fleet. */
  organizationId?: string
  /** How far down the organization tree organizationId reaches. Pass 0 to restrict to that organization alone. */
  orgDepth?: number
  /** Restrict to these sites. Applied alongside the organization filter rather than instead of it. Omit for the whole operated fleet. */
  siteIds?: string[]
  /** Restrict to chargers carrying at least one of these reasons. Several are an OR. A kept charger still reports every reason it carries, not only the requested ones. Omit for every flagged charger. */
  reasonCodes?: string[]
  /** What to rank by. Defaults to the reason count, most reasons first. */
  sortBy?: 'reasonCount' | 'chargerId'
  /** Sort direction. Defaults to DESC for the reason count, so the worst chargers lead, and to ASC for the charger id, where alphabetical is what a reader expects. */
  order?: 'ASC' | 'DESC'
}
export type GetSiteTariffMappingsResponse = /** status 200 OK */ SiteTariffMappingsResponseModel
export type GetSiteTariffMappingsArgs = {
  /** List of site IDs to query for tariff mappings. */
  siteIds: string[]
  /** Start time for the query range. */
  startTime: string
  /** End time for the query range. */
  endTime: string
}
export type GetAssetTariffMappingsResponse = /** status 200 OK */ {
  [key: string]: AssetTariffMappingModel
}
export type GetAssetTariffMappingsArgs = {
  chargerIds: string[]
}
export type GetChargingTransactionsResponse = /** status 200 Success */ PagedResponseV0TransactionSummaryModel
export type GetChargingTransactionsArgs = {
  /** The identifier of a charger by which to filter charging transactions.
    
    NOTE: If a chargerId is passed, the depotId and organizationId params will be ignored. */
  chargerId?: string
  /** An identifier of a site (depot) by which to filter charging transactions. */
  depotId?: string
  /** A list of site (depot) identifiers by which to filter charging transactions. Combined with `depotId` (deduplicated union) when both are provided. */
  depotIds?: string[]
  /** An identifier of a organization by which to filter charging transactions. */
  organizationId?: string
  /** The amount of levels of child organizations to search and include data for. */
  orgDepth?: number
  /** An identifier of a node by which to filter charging transactions. */
  nodeId?: string
  /** A list of node identifiers by which to filter charging transactions. Combined with `nodeId` (deduplicated union) when both are provided. */
  nodeIds?: string[]
  /** A list of commissioning states by which to filter charging transactions. Allowed values are PRECOMMISSION, COMMISSION, and DECOMMISSION. */
  commissioningStates?: ('PRECOMMISSION' | 'COMMISSION' | 'DECOMMISSION')[]
  /** An identifier of an OCPP ID tag by which to filter charging transactions. */
  tagId?: string
  /** A list of OCPP ID tags by which to filter charging transactions. */
  tagIds?: string[]
  /** An optional lower time-bound to filter on the transaction's start_timestamp. */
  startTimeFrom?: string
  /** An optional upper time-bound to filter on the transaction's start_timestamp. */
  startTimeTo?: string
  /** An optional lower time-bound to filter on the transaction's stop_timestamp. */
  stopTimeFrom?: string
  /** An optional upper time-bound to filter on the transaction's stop_timestamp. */
  stopTimeTo?: string
  /** A list of transaction statuses to be filtered on. Can be "in progress" or "ended". Filtering for in progress transactions will include those which do not have a `stopTimestamp`. Filtering for ended transactions will include those which do have a `stopTimestamp`. */
  status?: ('inProgress' | 'ended')[]
  /** An optional inclusive lower time-bound to filter on the last time the transaction was updated in Synop.
    
    For example, a charger can go offline and backfill transactions at a later date, leading to a more recent updated_timestamp than stop_timestamp */
  updatedSince?: string
  /** An index used to retrieve the next page of charging transactions. */
  page?: number
  /** The number of charging transactions to be returned in a page. */
  count?: number
  /** An order direction of the charging transactions to be returned (uses start_timestamp) */
  order?: 'ASC' | 'DESC'
  /** When true, include cost data (currency, total cost, cost components, and anomaly flag) for each transaction.  */
  includeCosts?: boolean
}
export type GetTransactionByIdResponse = /** status 200 Success */ TransactionSummaryModel
export type GetTransactionByIdArgs = {
  /** Identifier of the charging session. Cannot be empty. */
  id: string
}
export type GetTransactionMeterValuesResponse = /** status 200 Success */ TransactionMeterValuesModel[]
export type GetTransactionMeterValuesArgs = {
  /** Identifier of the transaction. Cannot be empty. */
  id: string
  /** Page number (0-based indexing) */
  page?: number
  /** Number of items per page */
  count?: number
  /** Optional lower time-bound (inclusive) filtering meter values on measuredAt. */
  from?: string
  /** Optional upper time-bound (exclusive) filtering meter values on measuredAt. */
  to?: string
  /** When true, include OCPP signed meter values (SignedData) for each timestamp under the signedData list. Defaults to false. */
  includeSignedData?: boolean
}
export type CmsChargingTransactionsGetMeterValueIntervalDataResponse =
  /** status 200 OK */ JsonApiObjectMeterValueCollectionIntervalModelMeterValueCollectionMetaAttributeModel
export type CmsChargingTransactionsGetMeterValueIntervalDataArgs = {
  /** Identifier of the transaction. Cannot be empty. */
  id: string
  /** A optional lower time-bound to filter on transaction-based meter value interval data from and including the provided UTC timestamp.
    If not provided, it will default to the first interval period that contains the start timestamp of the transaction.
    For example, with a 15 minute interval period, if the transaction start timestamp is 2020-01-01T12:07:00Z, the `from` timestamp will be rounded down and defaulted to 2020-01-01T12:00:00Z */
  from?: string
  /** An optional upper time-bound to filter on transaction-based meter value interval data ending at provided UTC timestamp.
     If not provided, it will default to the current timestamp of the request if a transaction is in progress, or to the stop timestamp of a transaction if it has completed.
    The `to` timestamp will be rounded up to the closest supported interval period to be inclusive of the interval in your request.
    For example, with a 15 minute interval period, if the `to` timestamp is 2020-01-01T12:07:00Z, the `to` timestamp will be rounded up to and defaulted to 2020-01-01T12:15:00Z */
  to?: string
  /** A time interval to group meter value data by. */
  intervalPeriod?: '15m' | '5m'
  /** A list of measure names to include in the response. If not provided, all default measures will be included  */
  measureNames?: ('maxPowerImport' | 'meanPowerImport' | 'totalEnergyImport')[]
  /** A boolean to truncate the first and last intervals of the response, respectively, to the transaction's start and stop timestamps.
     If not provided, the response will include the full interval period from the 'from' timestamp to the last interval period of the 'to' timestamp.
    For example, if truncateToTxnBounds is true, and the transaction start timestamp is 2020-01-01T12:07:00Z and the stop timestamp is 2020-01-01T12:22:00Z,
     the response will include first interval period will be [2020-01-01T12:07:00Z, 2020-01-01T12:15:00Z] and the last interval will be [2020-01-01T12:15:00Z, 2020-01-01T12:22:00Z].
    If truncateToTxnBounds if false (the default behavior), the first interval period will be [2020-01-01T12:00:00Z, 2020-01-01T12:15:00Z] and the last interval will be [2020-01-01T12:15:00Z, 2020-01-01T12:30:00Z]. */
  truncateToTxnBounds?: boolean
}
export type CmsChargingTransactionsInferStopResponse = /** status 200 OK */ BooleanModel
export type CmsChargingTransactionsInferStopArgs = {
  /** Internal identifier (transactionPk) of the transaction. Cannot be empty. (param has to be called id for API spec consistency) */
  id: number
}
export type GetCostCalculationForTransactionResponse = /** status 200 Success */ TransactionCostCalculation
export type GetCostCalculationForTransactionArgs = {
  /** Identifier of the charging session. Cannot be empty. */
  transactionId: string
}
export type GetServiceEventAuditResponse = /** status 200 OK */ PagedResponseV0ServiceEventAuditModel
export type GetServiceEventAuditArgs = {
  /** The ID of the service event to retrieve audit history for. */
  eventId: string
  /** An optional lower time-bound to filter on the serviceEventAudits timestamp. */
  from?: string
  /** An optional lower time-bound to filter on the serviceEventAudits timestamp. */
  to?: string
  /** An index used to retrieve the next page of charger service event audits. */
  page: number
  /** The number of charger service event audits to be returned in a page. */
  count: number
  /** A value to sort your collection of charger service event audits by */
  sortBy?: 'auditTime'
  /** The order in which to sort your collection of charger service event audits by. */
  order?: 'ASC' | 'DESC'
}
export type GetTransactionsReportResponse = /** status 200 OK */ ReportGenerationStatusModel
export type GetTransactionsReportArgs = {
  from: string
  to?: string
  organizationId?: string
  siteId?: string[]
  nodeIds?: string[]
  chargerId?: string
  commissioningStates?: ('PRECOMMISSION' | 'COMMISSION' | 'DECOMMISSION')[]
  orgDepth?: number
}
export type CmsReportsGetStatusOfTransactionReportResponse = /** status 200 OK */ ReportGenerationStatusModel
export type CmsReportsGetStatusOfTransactionReportArgs = {
  id: string
}
export type GetMeterValueIntervalsReportResponse = /** status 200 OK */ ReportGenerationStatusModel
export type GetMeterValueIntervalsReportArgs = {
  /** The node IDs for which the Meter Value Interval Report is to be generated. Must be within the site */
  nodeIds?: string[]
  /** The site ID for which the Meter Value Interval Report is to be generated. */
  siteId: string
  /** List of commissioning states to filter the Meter Value Interval Report. */
  commissioningStates?: ('PRECOMMISSIONED' | 'COMMISSIONED' | 'DECOMMISSIONED')[]
  /** The interval period for the Meter Value Interval Report. */
  intervalPeriod?: '15m' | '1h'
  /** The start time for the Meter Value Interval Report. */
  from: string
  /** The end time for the Meter Value Interval Report. If not provided, it defaults to 3 months from 'from' time or the current time if 3 months from 'from' time is in the future. */
  to?: string
}
export type GetMeterValueIntervalsReportStatusResponse = /** status 200 OK */ ReportGenerationStatusModel
export type GetMeterValueIntervalsReportStatusArgs = {
  id: string
}
export type GetChargeProfileResponse = /** status 200 OK */ ChargeProfileModel
export type GetChargeProfileArgs = {
  /** Profile identifier. Cannot be empty. */
  profileId: string
  fleetId?: string
}
export type CmsOcppTagsFilterTagsResponse = /** status 200 OK */ PagedResponseV0OcppTagModel
export type CmsOcppTagsFilterTagsArgs = {
  /** List of organization IDs to filter by */
  organizationIds?: string[]
  /** ID tag name to filter by (partial match) */
  idTagName?: string
  /** Filter for blocked tags (maxActiveTransactionCount = 0) */
  isBlocked?: boolean
  /** Page number (0-indexed) */
  page?: number
  /** Page size */
  count?: number
  /** Sort direction (ASC or DESC) */
  direction?: string
  /** Sort by field */
  sortBy?: string
}
export type CmsOcppConfigurationGetLatestConfigurationsResponse = /** status 200 OK */ OcppConfigurationResponseModel
export type CmsOcppConfigurationGetLatestConfigurationsArgs = {
  /** NOTE: This parameter will only retrieve configurations for the first charger in a list.
     A list of charger IDs to pull OCPP configurations for. */
  chargerIds: string[]
  /** NOTE:This paramater is not in use and will be expanded on in further release.
     A list of site ids to pull OCPP configurations for, for all chargers at the provided sites. */
  siteIds?: string[]
  /** NOTE:This paramater is not in use and will be expanded on in further release.
     The organization id to pull OCPP configurations for, for all chargers at all sites in the provided organization. */
  orgId?: string
  /** NOTE:This paramater is not in use and will be expanded on in further release.
    The depth of the organization to pull OCPP configurations for. */
  orgDepth?: number
}
export type CmsOcppConfigurationGetLatestConfigurationsForChargerResponse =
  /** status 200 OK */ OcppConfigurationResponseModel
export type CmsOcppConfigurationGetLatestConfigurationsForChargerArgs = {
  /** The unique identifier of the charger to pull OCPP configurations for */
  chargerId: string
}
export type CmsOcppConfigurationGetRefreshStatusForChargerResponse =
  /** status 200 OK */ RefreshConfigurationStatusModel
export type CmsOcppConfigurationGetRefreshStatusForChargerArgs = {
  /** The unique identifier of the charger to pull OCPP configurations for */
  chargerId: string
}
export type CmsOcppConfigurationGetRefreshStatusResponse = /** status 200 OK */ RefreshConfigurationStatusModel
export type CmsOcppConfigurationGetRefreshStatusArgs = {
  /** The unique identifier of the refresh configuration status request */
  id: string
}
export type CmsNodeUtilizationResponse = /** status 200 OK */ PowerUtilizationModel
export type CmsNodeUtilizationArgs = {
  id: string
  /** Lower time-bound for the time-series data (inclusive). */
  from?: string
  /** Upper time-bound for the time-series data (non-inclusive). */
  to?: string
  /** A time interval to group meter value data by (optional). On the aggregate timeline endpoints, omitting it defaults to 1m for ranges up to 24h and 15m for wider ranges; 1m and 5m are only available for ranges up to 7 days, and wider ranges return 400 (use 15m or coarser). The by-connector endpoint defaults to 15m and clamps 1m to 5m beyond 24h. */
  intervalPeriod?: '1m' | '5m' | '15m' | '30m' | '1h'
  /** If true, return only the interval with the maximum value over the requested period for each selected measures. If not specified, the default is false. */
  maxOnly?: boolean
  /** A list of measure names to include in the response if left null the default is activePowerImport,activePowerExport,powerOffered */
  measureNames?: (
    | 'activePowerImport'
    | 'activePowerExport'
    | 'powerOffered'
    | 'totalEnergyImport'
    | 'totalEnergyExport'
  )[]
}
export type CmsGetChargingNodeAuditResponse = /** status 200 OK */ PagedResponseV0ChargingNodeAuditModel
export type CmsGetChargingNodeAuditArgs = {
  /** The identifiers of a set of organizations by which to filter audit entries. Note: If organizationIds is empty and 'organizationId' is empty, the requester's organizationId and an orgDepth of 0 will be used. */
  organizationIds?: string[]
  /** Depth of 'child organizations' to include in the search for audit entries. Pass 0 to exclude all child organizations, and only include charging nodes of the specific organization being queried with organizationId. */
  orgDepth?: number
  /** A list of unique siteIds to filter your results by. */
  siteIds?: string[]
  /** A list of unique nodeIds to filter your results by. */
  nodeIds?: string[]
  /** A list of unique chargerIds to filter your results by. */
  chargerIds?: string[]
  /** A list of unique destinationIds to filter your results by. */
  destinationIds?: string[]
  /** A list of unique userIds to filter your results by. */
  userIds?: string[]
  /** A list of unique operations to filter your results by. If not provided, all operations will be included. */
  operations?: string[]
  /** A lower time-bound to filter energy data starting from and including the provided UTC timestamp. */
  fromTs: string
  /** An optional upper time-bound to filter audit entries ending at including the provided UTC timestamp. If not provided, defaults to the current timestamp of the request. */
  toTs: string
  /** An index used to retrieve the next page of audit entries. */
  page?: number
  /** The number of audit entries to be returned in a page. */
  count?: number
}
export type GetMeterDataIntervalsBySiteResponse =
  /** status 200 OK */ JsonApiObjectMeterValueCollectionIntervalModelMeterValueCollectionBySiteMetaAttributeModel
export type GetMeterDataIntervalsBySiteArgs = {
  /** A lower time-bound to filter interval data from (inclusive). Note that this actual time bound queried will be the interval period (associated with `intervalPeriod`) that contains this `from` field.
    For example, with a 15 minute `intervalPeriod`, if the `from` value passed is 2020-01-01T12:07:00Z, the `from` timestamp will be rounded down and queried as 2020-01-01T12:00:00Z.
     */
  from: string
  /** An upper time-bound to filter interval data from (exclusive). Note that this actual time bound queried will be the interval period (associated with `intervalPeriod`) that contains this `to` field.
    For example, with a 15 minute `intervalPeriod`, if the `to` value passed is 2020-01-01T12:07:00Z, the `to` timestamp will be rounded up and queried as 2020-01-01T12:15:00Z.
     */
  to: string
  /** A time interval to group meter value data by. */
  intervalPeriod?: '15m'
  /** An identifier of the site by which to filter data. */
  siteId?: string
}
export type CmsNodeUtilization1Response = /** status 200 OK */ PowerUtilizationModel
export type CmsNodeUtilization1Args = {
  id: string
  /** Lower time-bound for the time-series data (inclusive). */
  from?: string
  /** Upper time-bound for the time-series data (non-inclusive). */
  to?: string
  /** A time interval to group meter value data by (optional). On the aggregate timeline endpoints, omitting it defaults to 1m for ranges up to 24h and 15m for wider ranges; 1m and 5m are only available for ranges up to 7 days, and wider ranges return 400 (use 15m or coarser). The by-connector endpoint defaults to 15m and clamps 1m to 5m beyond 24h. */
  intervalPeriod?: '1m' | '5m' | '15m' | '30m' | '1h'
  /** If true, return only the interval with the maximum value over the requested period for each selected measures. If not specified, the default is false. */
  maxOnly?: boolean
  /** A list of measure names to include in the response if left null the default is activePowerImport,activePowerExport,powerOffered */
  measureNames?: (
    | 'activePowerImport'
    | 'activePowerExport'
    | 'powerOffered'
    | 'totalEnergyImport'
    | 'totalEnergyExport'
  )[]
}
export type CmsGetChargingNodeAudit1Response = /** status 200 OK */ PagedResponseV0ChargingNodeAuditModel
export type CmsGetChargingNodeAudit1Args = {
  /** The identifiers of a set of organizations by which to filter audit entries. Note: If organizationIds is empty and 'organizationId' is empty, the requester's organizationId and an orgDepth of 0 will be used. */
  organizationIds?: string[]
  /** Depth of 'child organizations' to include in the search for audit entries. Pass 0 to exclude all child organizations, and only include charging nodes of the specific organization being queried with organizationId. */
  orgDepth?: number
  /** A list of unique siteIds to filter your results by. */
  siteIds?: string[]
  /** A list of unique nodeIds to filter your results by. */
  nodeIds?: string[]
  /** A list of unique chargerIds to filter your results by. */
  chargerIds?: string[]
  /** A list of unique destinationIds to filter your results by. */
  destinationIds?: string[]
  /** A list of unique userIds to filter your results by. */
  userIds?: string[]
  /** A list of unique operations to filter your results by. If not provided, all operations will be included. */
  operations?: string[]
  /** A lower time-bound to filter energy data starting from and including the provided UTC timestamp. */
  fromTs: string
  /** An optional upper time-bound to filter audit entries ending at including the provided UTC timestamp. If not provided, defaults to the current timestamp of the request. */
  toTs: string
  /** An index used to retrieve the next page of audit entries. */
  page?: number
  /** The number of audit entries to be returned in a page. */
  count?: number
}
export type GetActivityResponse = /** status 200 OK */ PagedResponseV0GatewayRequestActivityItem
export type GetActivityArgs = {
  /** Entity ID (charger ID) */
  entityId: string
  /** Inclusive lower bound on request time (defaults to 'to' minus 1 day). */
  from?: string
  /** Inclusive upper bound on request time (defaults to now). */
  to?: string
  /** Optional request type filter (e.g. SetProfile, RestartCharger). */
  requestType?: string
  /** Page index (0-based). */
  page?: number
  /** Page size (items per page). */
  count?: number
}
export type GetDepotResponse = /** status 200 OK */ DepotModel
export type GetDepotArgs = {
  depotId: string
  include?: 'importKwhLast24h'[]
}
export type DeleteDepotResponse = /** status 200 OK */ BooleanModel
export type DeleteDepotArgs = {
  depotId: string
}
export type GetDepotUtilizationResponse = /** status 200 OK */ PowerUtilizationModel
export type GetDepotUtilizationArgs = {
  depotId: string
  /** Lower time-bound for the time-series data (inclusive). */
  from?: string
  /** Upper time-bound for the time-series data (non-inclusive). */
  to?: string
  /** A time interval to group meter value data by (optional). On the aggregate timeline endpoints, omitting it defaults to 1m for ranges up to 24h and 15m for wider ranges; 1m and 5m are only available for ranges up to 7 days, and wider ranges return 400 (use 15m or coarser). The by-connector endpoint defaults to 15m and clamps 1m to 5m beyond 24h. */
  intervalPeriod?: '1m' | '5m' | '15m' | '30m' | '1h'
  /** If true, return only the interval with the maximum value over the requested period for each selected measures. If not specified, the default is false. */
  maxOnly?: boolean
  /** A list of measure names to include in the response if left null the default is activePowerImport,activePowerExport,powerOffered */
  measureNames?: (
    | 'activePowerImport'
    | 'activePowerExport'
    | 'powerOffered'
    | 'totalEnergyImport'
    | 'totalEnergyExport'
  )[]
}
export type GetDepotUptimeResponse = /** status 200 OK */ UptimeResponse
export type GetDepotUptimeArgs = {
  /** The identifier for the depot you wish to query */
  depotId: string
  from: string
  to: string
}
export type GetDepotStatusResponse = /** status 200 OK */ LiveDepotUtilizationModel
export type GetDepotStatusArgs = {
  depotId: string
}
export type GetChargerResponse = /** status 200 OK */ ChargerDetailModelRead
export type GetChargerArgs = {
  /** Identifier of the charger. Cannot be empty. */
  chargerId: string
}
export type DeleteChargerResponse = /** status 200 OK */ BooleanModel
export type DeleteChargerArgs = {
  chargerId: string
}
export type GetChargerUtilizationTimelineResponse = /** status 200 OK */ PowerUtilizationModel
export type GetChargerUtilizationTimelineArgs = {
  chargerId: string
  /** Lower time-bound for the time-series data (inclusive). */
  from?: string
  /** Upper time-bound for the time-series data (non-inclusive). */
  to?: string
  /** A time interval to group meter value data by (optional). On the aggregate timeline endpoints, omitting it defaults to 1m for ranges up to 24h and 15m for wider ranges; 1m and 5m are only available for ranges up to 7 days, and wider ranges return 400 (use 15m or coarser). The by-connector endpoint defaults to 15m and clamps 1m to 5m beyond 24h. */
  intervalPeriod?: '1m' | '5m' | '15m' | '30m' | '1h'
  /** If true, return only the interval with the maximum value over the requested period for each selected measures. If not specified, the default is false. */
  maxOnly?: boolean
  /** A list of measure names to include in the response if left null the default is activePowerImport,activePowerExport,powerOffered */
  measureNames?: (
    | 'activePowerImport'
    | 'activePowerExport'
    | 'powerOffered'
    | 'totalEnergyImport'
    | 'totalEnergyExport'
  )[]
}
export type GetChargerUtilizationTimelineByConnectorResponse = /** status 200 OK */ ConnectorPowerUtilizationResponse
export type GetChargerUtilizationTimelineByConnectorArgs = {
  chargerId: string
  /** Lower time-bound for the time-series data (inclusive). */
  from?: string
  /** Upper time-bound for the time-series data (non-inclusive). */
  to?: string
  /** A time interval to group meter value data by (optional). On the aggregate timeline endpoints, omitting it defaults to 1m for ranges up to 24h and 15m for wider ranges; 1m and 5m are only available for ranges up to 7 days, and wider ranges return 400 (use 15m or coarser). The by-connector endpoint defaults to 15m and clamps 1m to 5m beyond 24h. */
  intervalPeriod?: '1m' | '5m' | '15m' | '30m' | '1h'
  /** If true, return only the interval with the maximum value over the requested period for each selected measures. If not specified, the default is false. */
  maxOnly?: boolean
  /** A list of measure names to include in the response if left null the default is activePowerImport,activePowerExport,powerOffered */
  measureNames?: (
    | 'activePowerImport'
    | 'activePowerExport'
    | 'powerOffered'
    | 'totalEnergyImport'
    | 'totalEnergyExport'
  )[]
}
export type GetChargerUptimeResponse = /** status 200 OK */ UptimeResponse
export type GetChargerUptimeArgs = {
  /** The identifier for the charger you wish to query */
  chargerId: string
  from: string
  to: string
}
export type GetMappedChargerProfilesResponse = /** status 200 OK */ ChargeProfileModel[]
export type GetMappedChargerProfilesArgs = {
  chargerId: string
  connectorId?: number
}
export type GetChargerLogsReportResponse = /** status 200 OK */ ReportGenerationStatusModel
export type GetChargerLogsReportArgs = {
  chargerId: string
  /** Date and time from which the logs are to be fetched. This field is required. The 'from' time must fall within the 52-week retention period for the OCPP logs */
  from: string
  /** Date and time up to which the logs are to be fetched. This field is optional. If left unspecified, it defaults to 1 day following the 'from' date. The 'to' date and time must be within 72 hours of the 'from' date and time. */
  to?: string
  ocppMessageTypes?:
    | 'Authorize'
    | 'BootNotification'
    | 'CancelReservation'
    | 'CertificateSigned'
    | 'ChangeAvailability'
    | 'ChangeConfiguration'
    | 'ClearCache'
    | 'ClearChargingProfile'
    | 'DataTransfer'
    | 'DeleteCertificate'
    | 'DiagnosticsStatusNotification'
    | 'ExtendedTriggerMessage'
    | 'FirmwareStatusNotification'
    | 'GetCompositeSchedule'
    | 'GetConfiguration'
    | 'GetDiagnostics'
    | 'GetInstalledCertificateIds'
    | 'GetLocalListVersion'
    | 'GetLog'
    | 'Heartbeat'
    | 'InstallCertificate'
    | 'LogStatusNotification'
    | 'MeterValues'
    | 'RemoteStartTransaction'
    | 'RemoteStopTransaction'
    | 'StartTransaction'
    | 'StopTransaction'
    | 'ReserveNow'
    | 'Reset'
    | 'SecurityEventNotification'
    | 'SendLocalList'
    | 'SetChargingProfile'
    | 'SignCertificate'
    | 'SignedFirmwareStatusNotification'
    | 'SignedUpdateFirmware'
    | 'StatusNotification'
    | 'TriggerMessage'
    | 'UnlockConnector'
    | 'UpdateFirmware'
    | 'ClearDisplayMessage'
    | 'ClearedChargingLimit'
    | 'ClearVariableMonitoring'
    | 'CostUpdated'
    | 'CustomerInformation'
    | 'Get15118EVCertificate'
    | 'GetBaseReport'
    | 'GetCertificateStatus'
    | 'GetChargingProfiles'
    | 'GetDisplayMessages'
    | 'GetMonitoringReport'
    | 'GetReport'
    | 'GetTransactionStatus'
    | 'GetVariables'
    | 'NotifyChargingLimit'
    | 'NotifyCustomerInformation'
    | 'NotifyDisplayMessages'
    | 'NotifyEVChargingNeeds'
    | 'NotifyEVChargingSchedule'
    | 'NotifyEvent'
    | 'NotifyMonitoringReport'
    | 'NotifyReport'
    | 'PublishFirmware'
    | 'PublishFirmwareStatusNotification'
    | 'ReportChargingProfiles'
    | 'RequestStartTransaction'
    | 'RequestStopTransaction'
    | 'TransactionEvent'
    | 'ReservationStatusUpdate'
    | 'SetDisplayMessage'
    | 'SetMonitoringBase'
    | 'SetMonitoringLevel'
    | 'SetNetworkProfile'
    | 'SetVariableMonitoring'
    | 'SetVariables'
    | 'UnpublishFirmware'
}
export type GetChargerLogEntriesResponse = /** status 200 OK */ PagedResponseV0ChargerLogEntryModel
export type GetChargerLogEntriesArgs = {
  chargerId: string
  /** Start time (inclusive) for log search. */
  from: string
  /** End time (exclusive) for log search. */
  to: string
  /** Optional list of OCPP actions to filter by, corresponding message acknowledgements and errors are included automatically. If not provided, all actions are returned. Valid values are defined in the OCPP specification. Common examples: MeterValues, StatusNotification, Heartbeat, StartTransaction, StopTransaction, Authorize, BootNotification. */
  actions?: (
    | 'AUTHORIZE'
    | 'BOOT_NOTIFICATION'
    | 'CANCEL_RESERVATION'
    | 'CERTIFICATE_SIGNED'
    | 'CHANGE_AVAILABILITY'
    | 'CHANGE_CONFIGURATION'
    | 'CLEAR_CACHE'
    | 'CLEAR_CHARGING_PROFILE'
    | 'DATA_TRANSFER'
    | 'DELETE_CERTIFICATE'
    | 'DIAGNOSTICS_STATUS_NOTIFICATION'
    | 'EXTENDED_TRIGGER_MESSAGE'
    | 'FIRMWARE_STATUS_NOTIFICATION'
    | 'GET_COMPOSITE_SCHEDULE'
    | 'GET_CONFIGURATION'
    | 'GET_DIAGNOSTICS'
    | 'GET_INSTALLED_CERTIFICATE_IDS'
    | 'GET_LOCAL_LIST_VERSION'
    | 'GET_LOG'
    | 'HEARTBEAT'
    | 'INSTALL_CERTIFICATE'
    | 'LOG_STATUS_NOTIFICATION'
    | 'METER_VALUES'
    | 'REMOTE_START_TRANSACTION'
    | 'REMOTE_STOP_TRANSACTION'
    | 'START_TRANSACTION'
    | 'STOP_TRANSACTION'
    | 'RESERVE_NOW'
    | 'RESET'
    | 'SECURITY_EVENT_NOTIFICATION'
    | 'SEND_LOCAL_LIST'
    | 'SET_CHARGING_PROFILE'
    | 'SIGN_CERTIFICATE'
    | 'SIGNED_FIRMWARE_STATUS_NOTIFICATION'
    | 'SIGNED_UPDATE_FIRMWARE'
    | 'STATUS_NOTIFICATION'
    | 'TRIGGER_MESSAGE'
    | 'UNLOCK_CONNECTOR'
    | 'UPDATE_FIRMWARE'
    | 'CLEAR_DISPLAY_MESSAGE'
    | 'CLEARED_CHARGING_LIMIT'
    | 'CLEAR_VARIABLE_MONITORING'
    | 'COST_UPDATED'
    | 'CUSTOMER_INFORMATION'
    | 'GET_15118_EV_CERTIFICATE'
    | 'GET_BASE_REPORT'
    | 'GET_CERTIFICATE_STATUS'
    | 'GET_CHARGING_PROFILES'
    | 'GET_DISPLAY_MESSAGES'
    | 'GET_MONITORING_REPORT'
    | 'GET_REPORT'
    | 'GET_TRANSACTION_STATUS'
    | 'GET_VARIABLES'
    | 'NOTIFY_CHARGING_LIMIT'
    | 'NOTIFY_CUSTOMER_INFORMATION'
    | 'NOTIFY_DISPLAY_MESSAGES'
    | 'NOTIFY_EV_CHARGING_NEEDS'
    | 'NOTIFY_EV_CHARGING_SCHEDULE'
    | 'NOTIFY_EVENT'
    | 'NOTIFY_MONITORING_REPORT'
    | 'NOTIFY_REPORT'
    | 'PUBLISH_FIRMWARE'
    | 'PUBLISH_FIRMWARE_STATUS_NOTIFICATION'
    | 'REPORT_CHARGING_PROFILES'
    | 'REQUEST_START_TRANSACTION'
    | 'REQUEST_STOP_TRANSACTION'
    | 'TRANSACTION_EVENT'
    | 'RESERVATION_STATUS_UPDATE'
    | 'SET_DISPLAY_MESSAGE'
    | 'SET_MONITORING_BASE'
    | 'SET_MONITORING_LEVEL'
    | 'SET_NETWORK_PROFILE'
    | 'SET_VARIABLE_MONITORING'
    | 'SET_VARIABLES'
    | 'UNPUBLISH_FIRMWARE'
  )[]
  /** When true, Heartbeat messages are excluded from the results. Useful for long ranges where heartbeats dominate. Defaults to false. */
  excludeHeartbeats?: boolean
  /** Page number (0-indexed). */
  page?: number
  /** Items per page. */
  count?: number
  /** Sort field. */
  sortBy?: 'time'
  /** Sort direction. */
  order?: 'ASC' | 'DESC'
}
export type GetChargerFaultsResponse = /** status 200 OK */ ChargerFaultsModel
export type GetChargerFaultsArgs = {
  chargerId: string
  from?: string
  to?: string
  page?: number
  count?: number
}
export type GetChargerConnectorsResponse = /** status 200 OK */ ConnectorModel[]
export type GetChargerConnectorsArgs = {
  chargerId: string
}
export type GetCapabilitySetResponse = /** status 200 Success */ ChargerCapabilitySetResponseModel
export type GetCapabilitySetArgs = {
  /** The identifier for the charger. */
  chargerId: string
}
export type CmsUtilizationGetUtilizationResponse = /** status 200 OK */ UtilizationResponseModel
export type CmsUtilizationGetUtilizationArgs = {
  /** The identifier of an organization by which to filter data. */
  organizationId?: string
  /** Identifiers of sites belonging to particular organizations to filter utilization data by. */
  siteIds?: string[]
  /** Identifiers of nodes belonging to particular sites to filter utilization data. */
  nodeIds?: string[]
  /** The amount of levels of child organizations to search and include data for. */
  orgDepth?: number
}
export type GetChargersTableDataResponse = /** status 200 OK */ ChargersTimespanTableModel
export type GetChargersTableDataArgs = {
  /** The identifier of an organization by which to filter data by. */
  organizationId?: string
  /** The amount of levels of child organizations to search and include data for. */
  orgDepth?: number
  /** A list of site identifiers by which to filter results.
    
    Retrieve your site IDs from `GET /api/v1/sites`.
    
    Note that this parameter is plural. Unrecognized query parameters are ignored rather than rejected, so a singular spelling applies no filter at all and silently widens the query to your entire organization. */
  siteIds?: string[]
  /** A list of node identifiers by which to filter results.
    
    Retrieve your node IDs from `GET /api/nodes`.
    
    Note that this parameter is plural. Unrecognized query parameters are ignored rather than rejected, so a singular spelling applies no filter at all and silently widens the query to your entire organization. */
  nodeIds?: string[]
  /** A lower time-bound to filter on dashboard summary data starting from and including the provided UTC timestamp. */
  fromTs: string
  /** An optional upper time-bound to filter on dashboard summary data ending at including the provided UTC timestamp. If not provided, defaults to the current timestamp of the request. */
  toTs?: string
  /** An index used to retrieve the next page of charger summaries. */
  page?: number
  /** The number of chargers summaries to be returned in a page. */
  count?: number
  /** An order direction of the charger summary data to be returned, uses either the default of chargerName, or the parameter provided in sortBy) */
  order?: 'ASC' | 'DESC'
  /** A parameter to sort charger table data by. */
  sortBy?: 'chargerName' | 'chargerId'
  /** Search for chargers by their name or ID (case insensitive). */
  searchString?: string
}
export type GetSummaryDataResponse = /** status 200 OK */ ChargersTimespanSummaryModel
export type GetSummaryDataArgs = {
  /** The identifier of an organization by which to filter data by. */
  organizationId?: string
  /** The amount of levels of child organizations to search and include data for. */
  orgDepth?: number
  /** A list of site identifiers by which to filter results.
    
    Retrieve your site IDs from `GET /api/v1/sites`.
    
    Note that this parameter is plural. Unrecognized query parameters are ignored rather than rejected, so a singular spelling applies no filter at all and silently widens the query to your entire organization. */
  siteIds?: string[]
  /** A list of node identifiers by which to filter results.
    
    Retrieve your node IDs from `GET /api/nodes`.
    
    Note that this parameter is plural. Unrecognized query parameters are ignored rather than rejected, so a singular spelling applies no filter at all and silently widens the query to your entire organization. */
  nodeIds?: string[]
  /** A lower time-bound to filter on dashboard summary data starting from and including the provided UTC timestamp. */
  fromTs: string
  /** An optional upper time-bound to filter on dashboard summary data ending at including the provided UTC timestamp. If not provided, defaults to the current timestamp of the request. */
  toTs?: string
}
export type CmsTimespanGetHistoricalStatusesResponse = /** status 200 OK */ HistoricalStatusSummaryModel
export type CmsTimespanGetHistoricalStatusesArgs = {
  /** The identifier of an organization by which to filter historical statuses. */
  organizationId?: string
  /** A list of site identifiers by which to filter results.
    
    Retrieve your site IDs from `GET /api/v1/sites`.
    
    Note that this parameter is plural. Unrecognized query parameters are ignored rather than rejected, so a singular spelling applies no filter at all and silently widens the query to your entire organization. */
  siteIds?: string[]
  /** A list of node identifiers by which to filter results.
    
    Retrieve your node IDs from `GET /api/nodes`.
    
    Note that this parameter is plural. Unrecognized query parameters are ignored rather than rejected, so a singular spelling applies no filter at all and silently widens the query to your entire organization. */
  nodeIds?: string[]
  /** A list of charger identifiers by which to filter results.
    
    Retrieve your charger IDs from `GET /api/chargers`, optionally filtered by `siteIds`.
    
    **Combined with the other filters, not prioritised over them.** Charger IDs are intersected with any `siteIds`, `nodeIds` and `organizationId` you also pass, so naming a charger together with a site it does not belong to matches nothing and returns an empty result.
    
    Note that this parameter is plural. Unrecognized query parameters are ignored rather than rejected, so a singular spelling applies no filter at all and silently widens the query to your entire organization. */
  chargerIds?: string[]
  /** The number of levels of child organizations to search and include historical charger and connector status summary summary data for. */
  orgDepth?: number
  /** An inclusive lower time-bound to filter on status data. */
  fromTs: string
  /** An optional non-inclusive upper time-bound to filter on status data. If not provided, defaults to the current timestamp of the request, rounded down to the nearest 15 minutes. */
  toTs?: string
}
export type GetEnergyOverTimeResponse = /** status 200 OK */ TimespanBucketedStatsResponseModel
export type GetEnergyOverTimeArgs = {
  /** The identifier of an organization by which to filter data by. */
  organizationId?: string
  /** The amount of levels of child organizations to search and include data for. */
  orgDepth?: number
  /** A list of site identifiers by which to filter results.
    
    Retrieve your site IDs from `GET /api/v1/sites`.
    
    Note that this parameter is plural. Unrecognized query parameters are ignored rather than rejected, so a singular spelling applies no filter at all and silently widens the query to your entire organization. */
  siteIds?: string[]
  /** A list of node identifiers by which to filter results.
    
    Retrieve your node IDs from `GET /api/nodes`.
    
    Note that this parameter is plural. Unrecognized query parameters are ignored rather than rejected, so a singular spelling applies no filter at all and silently widens the query to your entire organization. */
  nodeIds?: string[]
  /** A lower time-bound to filter energy data starting from and including the provided UTC timestamp.  Must be evenly divisible by the interval period. */
  fromTs: string
  /** An optional upper time-bound to filter energy data ending at including the provided UTC timestamp. If not provided, defaults to the current timestamp of the request. Must be evenly divisible by the interval period. */
  toTs: string
  /** The size of each bucket. Can be expressed in minutes hours or days.  Must be a multiple of 15 minutes. Examples are 15m, 45m, 1h, 1d, 7d */
  intervalPeriod: string
}
export type CmsChargersGetChargerStatusResponse = /** status 200 OK */ PagedResponseV0ChargerStatusApiResponseModel
export type CmsChargersGetChargerStatusArgs = {
  /** The identifiers of a set of organizations by which to filter charger statuses. Note: If organizationIds is empty and 'organizationId' is empty, the requester's organizationId and an orgDepth of 0 will be used. */
  organizationIds?: string[]
  /** The identifiers of a set of chargers by which to filter charger statuses. Note: If any siteIds are passed, the organizationId and organizationId params will be ignored, and filtering on statuses will be performed by site. */
  siteIds?: string[]
  /** An identifier of an organization by which to filter charger statuses. NOTE: If organizationId is passed and 'organizationIds' is empty, the organizationId will be used along with orgDepth to retrieve statuses from your organization and all child organizations. */
  organizationId?: string
  /** Depth of 'child organizations' to include in the search for charger's connector statuses. Pass 0 to exclude all child organizations, and only include chargers of the specific organization being queried with organizationId. */
  orgDepth?: number
  /** The identifiers of a set of chargers by which to filter charger statuses. Note: If any charger IDs are passed, filtering will be performed on collections by chargerID only. */
  chargerIds?: string[]
  /** The identifiers of a set of connectors by which to filter charger statuses. Note: Connector 0 refers to the charger as a whole. */
  connectorIds?: number[]
  /** A list of statuses types to include in the response. */
  statuses?: (
    | 'Available'
    | 'Preparing'
    | 'Charging'
    | 'Finishing'
    | 'SuspendedEVSE'
    | 'SuspendedEV'
    | 'Reserved'
    | 'PartiallyFaulted'
    | 'Faulted'
    | 'Unavailable'
    | 'Unknown'
    | 'Offline'
  )[]
  /** A lower time-bound to filter on the status timestamp. */
  from: string
  /** An optional upper time-bound to filter on the status timestamp. Note: If not provided, the current time will be used. */
  to?: string
  /** When true, includes boundary statuses for each connector: the most recent status before 'from' and the first status after 'to'. These boundary items are mixed into the paginated results and are distinguishable by their timestamps (before 'from' or after 'to'). Defaults to false. */
  includeBoundaries?: boolean
  /** An index used to retrieve the next page of charger statuses. */
  page?: number
  /** The number charger statuses to be returned in a page. */
  count?: number
  /** A value to sort your collection of statuses by. */
  sortBy?: 'timestamp'
  /** The order in which to sort your collection of statuses by. */
  order?: 'ASC' | 'DESC'
}
export type CmsOcppLogsGetStatusOfOcppLogsRequestResponse = /** status 200 OK */ ReportGenerationStatusModel
export type CmsOcppLogsGetStatusOfOcppLogsRequestArgs = {
  id: string
}
export type CmsMeterDataIntervalsResponse =
  /** status 200 OK */ JsonApiObjectMeterValueIntervalDataModelMeterValueIntervalMetaAttributeModel
export type CmsMeterDataIntervalsArgs = {
  /** A lower time-bound to filter interval data from (inclusive). Note that this actual time bound queried will be the interval period (associated with `intervalPeriod`) that contains this `from` field.
    For example, with a 15 minute `intervalPeriod`, if the `from` value passed is 2020-01-01T12:07:00Z, the `from` timestamp will be rounded down and queried as 2020-01-01T12:00:00Z.
     */
  from: string
  /** An upper time-bound to filter interval data from (exclusive). Note that this actual time bound queried will be the interval period (associated with `intervalPeriod`) that contains this `to` field.
    For example, with a 15 minute `intervalPeriod`, if the `to` value passed is 2020-01-01T12:07:00Z, the `to` timestamp will be rounded up and queried as 2020-01-01T12:15:00Z.
     */
  to: string
  /** A list of site identifiers by which to filter data. */
  siteIds?: string[]
  /** An identifier of an organization by which to filter data. */
  organizationId?: string
  /** The number of levels of child organizations to search and include data for. */
  orgDepth?: number
}
export type GetLatestStatusSummaryResponse = /** status 200 OK */ LatestStatusSummaryModel
export type GetLatestStatusSummaryArgs = {
  /** A list of organization identifiers by which to filter charger and connector statuses. If not provided, statuses for all organizations will be returned. */
  organizationId?: string[]
  /** An identifier of a site to filter charger and connector statuses by, use this to filter down to particular sites belonging to particular organizations. */
  siteIds?: string[]
  /** An identifier of charging nodes to filter charger and connector statuses by, use this to filter down nodes belonging to particular sites. */
  nodeIds?: string[]
  /** The amount of levels of child organizations to search and include when searching for latest charger and connector status statuses. */
  orgDepth?: number
  /** Whether to include charger-level breakdowns of connector statuses in the response (in the `connectorsByCharger` field). */
  includeConnectorsByCharger?: boolean
  /** Whether to include site-level breakdowns of connector statuses in the response (in the `connectorsBySite` field). */
  includeConnectorsBySite?: boolean
  /** Whether to include site-level breakdowns of charger statuses in the response (in the `chargersBySite` field). */
  includeChargersBySite?: boolean
  /** Whether to include node-level breakdowns of connector statuses in the response (in the `connectorsByNode` field). */
  includeConnectorsByNode?: boolean
  /** Whether to include node-level breakdowns of charger statuses in the response (in the `chargersByNode` field). */
  includeChargersByNode?: boolean
  /** List of commissioning states to filter the latest statuses for the chargers. */
  commissioningStates?: ('PRECOMMISSIONED' | 'COMMISSIONED' | 'DECOMMISSIONED')[]
}
export type CmsChargerFaultsGetFaultsResponse = /** status 200 Success */ PagedResponseV0ConnectorFaultModel
export type CmsChargerFaultsGetFaultsArgs = {
  /** The identifiers of a set of chargers by which to filter charger faults.
    
    NOTE: If any charger IDs are passed, the siteIds and organizationId params will be ignored. */
  chargerIds?: string[]
  /** A list of site identifiers by which to filter charger faults. */
  siteIds?: string[]
  /** A list of node identifiers by which to filter charger faults. */
  nodeIds?: string[]
  /** A list of organization identifiers by which to filter charger faults. */
  organizationId?: string[]
  /** An optional lower time-bound to filter on the fault's timestamp. If omitted, defaults to occurredBefore minus the configured default lookback window (7 days by default). The span between occurredAfter and occurredBefore must not exceed the configured maximum range (31 days by default). */
  occurredAfter?: string
  /** An optional upper time-bound to filter on the fault's timestamp. If omitted, defaults to the current time. */
  occurredBefore?: string
  /** An optional string to filter faults by fuzzy-matching on fault fields: charger ID, error code, error info, vendor error code, auth tag (ocpp_tag), and vendor ID. */
  searchString?: string
  /** List of commissioning states to filter the charger faults. */
  commissioningStates?: ('PRECOMMISSIONED' | 'COMMISSIONED' | 'DECOMMISSIONED')[]
  /** An index used to retrieve the next page of charger faults. */
  page: number
  /** The number of charger faults to be returned in a page. */
  count: number
  /** A value to sort charger faults by. */
  sortBy?: 'chargerName' | 'currentStatus' | 'errorCode' | 'siteName' | 'timestamp' | 'vendor'
  /** A sort direction for the results. */
  order?: 'ASC' | 'DESC'
  /** When true, include the faulted episode containing each fault (episodeStartedAt, episodeEndedAt and ongoing). An episode is the contiguous run of faulted statuses on the connector; warnings, which report a non-faulted status carrying an error code, belong to no episode and the fields are omitted for them. */
  includeEpisodes?: boolean
}
export type GetBaselineSeriesResponse = /** status 200 Success */ BaselineSeriesResponse
export type GetBaselineSeriesArgs = {
  /** The site (depot) ID for which to compute the baseline series. */
  siteId: string
  /** The start of the time window for the baseline series (inclusive). */
  from: string
  /** The end of the time window for the baseline series (exclusive). */
  to: string
}
export type GetBaselineDailyResponse = /** status 200 Success */ BaselineDailyResponseModel
export type GetBaselineDailyArgs = {
  /** One or more site (depot) IDs to query. */
  siteIds: string[]
  /** Start date of the query range (inclusive, site-local date, yyyy-MM-dd). */
  from: string
  /** End date of the query range (exclusive, site-local date, yyyy-MM-dd). */
  to: string
}
export type GetBaselineDailyCyclesResponse = /** status 200 Success */ BaselineDailyCyclesResponseModel
export type GetBaselineDailyCyclesArgs = {
  /** The site (depot) ID to query billing cycles for. */
  siteId: string
  /** Number of billing cycles to return (default 3, max 12). */
  count?: number
  /** Cursor for pagination: return cycles ending before this date (yyyy-MM-dd). Omit to start from the current billing cycle. */
  before?: string
}
export type GetProfileHistoriesResponse = /** status 200 OK */ PagedResponseV0ProfileApplicationRecordModel
export type GetProfileHistoriesArgs = {
  /** Charger id */
  chargerId: string
  /** When true, return only the latest record. */
  latest?: boolean
  /** Inclusive lower bound on request time (defaults to now minus 7 days). */
  from?: string
  /** Inclusive upper bound on request time (defaults to now). */
  to?: string
  /** Page index (0-based). */
  page?: number
  /** Page size (items per page). */
  count?: number
}
export type GetManufacturersResponse = /** status 200 OK */ PagedResponseV0ChargerManufacturerModel
export type GetManufacturersArgs = {
  page?: number
  count?: number
}
export type GetManufacturerMakeModelsResponse = /** status 200 OK */ PagedResponseV0ChargerMakeModelResponseModel
export type GetManufacturerMakeModelsArgs = {
  /** The identifier for a charger make model, generated by Synop. */
  manufacturerId: string
  page?: number
  count?: number
}
export type GetDiagnosticsStatusResponse = /** status 200 OK */ ChargerDiagnosticsResponseModel
export type GetDiagnosticsStatusArgs = {
  /** ID of the diagnostics request */
  id: string
}
export type CancelDiagnosticsRequestResponse = /** status 200 OK */ ChargerDiagnosticsResponseModel
export type CancelDiagnosticsRequestArgs = {
  /** ID of the diagnostics request to cancel */
  id: string
}
export type GetDiagnosticsAuditResponse = /** status 200 OK */ PagedResponseV0ChargerDiagnosticsAuditResponseModel
export type GetDiagnosticsAuditArgs = {
  /** ID of the diagnostics request */
  requestId: string
  /** An optional lower time-bound to filter on the date and time of the diagnostics audit timestamp. */
  from?: string
  /** An optional upper time-bound to filter on the date and time of the diagnostics audit timestamp. */
  to?: string
  /** An index used to retrieve the next page of charger diagnostics audit entries. */
  page: number
  /** The number of charger diagnostics audit entries to be returned in a page. */
  count: number
  /** A value to sort your collection of charger diagnostics audit entries by */
  sortBy?: 'auditTime'
  /** The order in which to sort your collection of charger diagnostics audit entries by. */
  order?: 'ASC' | 'DESC'
}
export type ClearAllConnectorProfilesResponse = /** status 200 OK */ BooleanModel
export type ClearAllConnectorProfilesArgs = {
  fleetId?: string
  clearConnectorProfilesRequest: ClearConnectorProfilesRequest
}
export type ChargerDestinationResponseModel = {
  /** The identifier of the destination the charger communicates through */
  destinationId?: string
  /** The type of the destination */
  destinationType?: 'STEVE' | 'CLOUD_GATEWAY' | 'LINK_DEVICE'
  /** The human-readable name of the destination */
  name?: string
}
export type ProblemDetail = {
  /** URI identifying the problem type; about:blank when unspecified */
  type?: string
  /** Short, human-readable summary of the problem type */
  title?: string
  /** HTTP status code */
  status?: number
  /** Human-readable explanation specific to this occurrence */
  detail?: string
  /** URI of the request that produced the problem */
  instance?: string
  [key: string]: unknown
}
export type ExternalServiceErrorMetaAttribute = {
  serviceCode?: 'FLEET_MANAGEMENT'
  path?: string
  statusCode?: number
  body?: string
}
export type JsonApiErrorObjectExternalServiceErrorMetaAttribute = {
  /** A unique identifier for the problem that occurred. */
  id: string
  /** A short summary of the problem that occurred. */
  title: string
  /** The HTTP status code applicable to this problem, expressed as a string value. */
  status: '200' | '400' | '401' | '500'
  /** An object containing the location of the error. */
  source?: string
  /** An explanation of the problem that occurred. */
  detail: string
  /** An application-specific error code, expressed as a string value. */
  code?: string
  meta?: ExternalServiceErrorMetaAttribute
}
export type JsonApiErrorWrapperExternalServiceErrorMetaAttribute = {
  /** A list of errors. */
  errors?: JsonApiErrorObjectExternalServiceErrorMetaAttribute[]
}
export type ChargerDestinationUpdateModel = {
  /** The identifier of the live destination to assign the charger to */
  destinationId: string
}
export type BasicAuthUpdateResponse = {
  success?: boolean
  error?: string
}
export type BasicAuthRequiredRequest = {
  required: boolean
}
export type BasicAuthCredentialsRequest = {
  password: string
}
export type AssetTariffMappingModel = {
  id: string
  assetType: 'SITE' | 'CHARGER'
  assetId: string
  lseId: string
  lseName: string
  lseCode?: string
  masterTariffId?: number
  tariffName: string
  tariffProvider: string
  customerClass: 'RESIDENTIAL' | 'GENERAL' | 'SPECIAL_USE' | 'PROPOSED'
  customTariffId?: string
  marketId?: string
  effectiveFrom: string
  effectiveTo?: string
  billingAnchorDate?: number
}
export type TariffAssociation = {
  assetType: 'SITE' | 'CHARGER'
  assetId: string
  lseId: string
  lseName: string
  lseCode?: string
  masterTariffId?: number
  customTariffId?: string
  marketId?: string
  tariffName: string
  tariffProvider: string
  customerClass: 'RESIDENTIAL' | 'GENERAL' | 'SPECIAL_USE' | 'PROPOSED'
  billingAnchorDate?: number
  validTariffProviderMapping?: boolean
}
export type CancelTariffAssociationRequestParams = {
  assetType: 'SITE' | 'CHARGER'
  assetId: string
}
export type ServiceEventModel = {
  /** The ID of the service event. */
  eventId: string
  /** The ID of the charger that the service event is associated with. */
  chargerId: string
  /** The date and time that the service event is effective from. */
  effectiveAsOf: string
  /** The type of service event. */
  eventType: 'COMMISSIONING' | 'OUTAGE' | 'SITE_MOVE' | 'ORG_MOVE' | 'NODE_MOVE' | 'COMMS_MOVE'
  /** The commissioning state */
  commissioningState?: 'PRECOMMISSIONED' | 'COMMISSIONED' | 'DECOMMISSIONED'
  /** A note or description of the service event. */
  note?: string
  /** The date and time that the service event was last updated. */
  updatedDate?: string
  /** The date and time that the service event was created. */
  createdDate: string
  /** The ID of the user that created or updated the service event. */
  userId?: string
  /** The ID of the organization that the user belongs to. */
  organizationId?: string
}
export type UpdateServiceEventModel = {
  /** The date and time that the service event is effective from. */
  effectiveAsOf: string
  /** A note or description of the service event. */
  note?: string
}
export type ChargeSchedulePeriodModel = {
  /** The amount of seconds after a charge profile is valid in which to start applying the profile */
  startPeriodInSeconds: number
  /** The amount to limit a particular charger to */
  powerLimit: number
  /** The number of phases in which to apply the profile */
  numberPhases: number
  /** The discharge limit in which to apply the profile */
  limitDischarge?: number
  /** The desired v2g charging mode. Case insensitive. */
  desiredMode?: 'discharging' | 'charging'
}
export type ChargeProfileModel = {
  /** The identifier of a charger, provided by Synop or the OEM. */
  chargerId?: string
  /** The connector on which a charging profile is applied, 0 applies to the entire charger */
  connectorId?: number
  /** The identifier of the charging profile, generated by Synop. */
  profileId?: string
  /** The order of precedence for a charging profile, the higher a stack level the higher priority for it to be assigned. */
  stackLevel?: number
  /** The charging profile mode to assign to a charger. */
  chargeProfilePurpose?: 'ChargePointMaxProfile' | 'TxDefaultProfile' | 'TxProfile'
  /** The schedule on which to apply the charging profile. */
  chargeProfileKind?: 'Absolute' | 'Recurring' | 'Relative'
  /** The period at which to reset a charge profile schedule. */
  recurrencyKind?: 'Daily' | 'Weekly'
  /** The period of time in which a charging profile is valid from. */
  validFrom?: string
  /** The period of time in which a charging profile is valid to. */
  validTo?: string
  /** The duration of the charging profile. */
  durationInSeconds?: number
  /** The date in which the charging profile will be begin from. */
  effectiveFrom?: string
  /** The unit for charging rate. */
  chargingRateUnit?: 'W' | 'A'
  /** The minimum charging rate. */
  minChargingRate?: number
  /** A short name describing the charging profile. */
  description?: string
  /** The ID of a depot, generated by Synop, to associate the charging profile. */
  depotId?: string
  /** The ID of a fleet, generated by Synop, to associate the charging profile. */
  fleetId?: string
  /** Signifies where a smart charging profile is currently active */
  currentlyActive?: boolean
  /** A list of schedule periods, fixed points that describe the rate at which to charge. */
  schedulePeriods?: ChargeSchedulePeriodModel[]
}
export type PagedResponseV0ChargeProfileModel = {
  first?: boolean
  last?: boolean
  pageSize?: number
  page?: number
  totalPages?: number
  totalItems?: number
  items?: ChargeProfileModel[]
}
export type V2GCompatibleSchedulePeriod = {
  /** The amount of seconds after a charge profile is valid in which to start applying the profile */
  startPeriodInSeconds: number
  /** Optional field used only for Proterra V2G commands, the limit in Watts to discharge a battery, must be set to 1000 */
  limitDischarge?: number
  /** Optional field used only for Proterra V2G commands, desired mode either discharging or charging */
  desiredMode?: 'discharging' | 'charging'
  /** The amount to limit a particular charger to */
  powerLimit?: number
  /** The number of phases in which to apply the profile */
  numberPhases?: number
}
export type ChargeProfileUpdateModel = {
  /** A short name describing the charging profile */
  depotId?: string
  /** A short description of the purpose of the charging profile. */
  description?: string
  /** The order of precedence for a charging profile, the higher a stack level the higher priority for it to be assigned. */
  stackLevel?: number
  /** The charging profile mode to assign to a charger. Case insensitive. */
  chargingProfilePurpose:
    | 'ChargePointMaxProfile'
    | 'TxDefaultProfile'
    | 'TxProfile'
    | 'CHARGE_POINT_MAX_PROFILE'
    | 'TX_DEFAULT_PROFILE'
    | 'TX_PROFILE'
  /** The schedule on which to apply the charging profile. Case insensitive. */
  chargingProfileKind: 'Absolute' | 'Recurring' | 'Relative'
  /** The period at which to reset a charge profile schedule. Case insensitive. */
  recurrencyKind?: 'Daily' | 'Weekly'
  /** The period of time in which a charging profile is valid from. */
  validFrom?: string
  /** The period of time in which a charging profile is valid to. */
  validTo?: string
  /** The duration of the charging profile. */
  durationInSeconds: number
  /** The time in which a charging profile shall begin. */
  startSchedule: string
  /** The unit for charging rate. Case insensitive. */
  chargingRateUnit: 'W' | 'A'
  /** The minimum charging rate. */
  minChargingRate?: number
  /** A map of intervals in which to apply a charging profile. */
  schedulePeriodMap: {
    [key: string]: V2GCompatibleSchedulePeriod
  }
  /** The identifier, provided by the OEM or Synop, for the charger you wish to perform a smart charging action on */
  chargerId?: string
  /** The connector to apply the profile on, if none provided, default to connector 0, referring to the entire charger. */
  connectorId?: number
  /** The identifier, provided Synop, for the smart charging profile you want to apply */
  profileId: string
}
export type ChargeProfileCreateModel = {
  /** A short name describing the charging profile */
  depotId?: string
  /** A short description of the purpose of the charging profile. */
  description?: string
  /** The order of precedence for a charging profile, the higher a stack level the higher priority for it to be assigned. */
  stackLevel?: number
  /** The charging profile mode to assign to a charger. Case insensitive. */
  chargingProfilePurpose:
    | 'ChargePointMaxProfile'
    | 'TxDefaultProfile'
    | 'TxProfile'
    | 'CHARGE_POINT_MAX_PROFILE'
    | 'TX_DEFAULT_PROFILE'
    | 'TX_PROFILE'
  /** The schedule on which to apply the charging profile. Case insensitive. */
  chargingProfileKind: 'Absolute' | 'Recurring' | 'Relative'
  /** The period at which to reset a charge profile schedule. Case insensitive. */
  recurrencyKind?: 'Daily' | 'Weekly'
  /** The period of time in which a charging profile is valid from. */
  validFrom?: string
  /** The period of time in which a charging profile is valid to. */
  validTo?: string
  /** The duration of the charging profile. */
  durationInSeconds: number
  /** The time in which a charging profile shall begin. */
  startSchedule: string
  /** The unit for charging rate. Case insensitive. */
  chargingRateUnit: 'W' | 'A'
  /** The minimum charging rate. */
  minChargingRate?: number
  /** A map of intervals in which to apply a charging profile. */
  schedulePeriodMap: {
    [key: string]: V2GCompatibleSchedulePeriod
  }
}
export type BooleanModel = {
  result?: boolean
}
export type ChargeProfileActionRequest = {
  /** The identifier, provided by the OEM or Synop, for the charger you wish to perform a smart charging action on */
  chargerId: string
  /** The connector to apply or remove a charging profile to, if 0 is provided, apply the profile to the entire charger */
  connectorId: number
  /** The corresponding smart charging profile Id to apply the profile to, generated by Synop */
  profileId: string
}
export type AddressDetails = {
  /** Street/block name and house number. */
  streetAddress: string
  /** City or town. */
  city: string
  /** State, province, or region. */
  state?: string
  /** Postal or ZIP code. */
  postalCode?: string
  /** Country code (ISO 3166-1 alpha-2). */
  country: string
}
export type EnergyEfficiencyModel = {
  /** The energy efficiency value (between 0 and 1). */
  value: number
  /** The type of entity that provided this efficiency value. */
  sourceEntityType: 'CHARGER' | 'SITE' | 'DEFAULT'
  /** The ID of the entity that provided this efficiency value. Null when sourceEntityType is DEFAULT. */
  sourceEntityId?: string
}
export type DepotModel = {
  depotId: string
  fleetId?: string
  depotNm?: string
  externalId?: string
  powerCeiling?: number
  powerCeilingUnit?: string
  currentCeiling?: number
  currentCeilingUnit?: string
  voltageCeiling?: number
  voltageCeilingUnits?: string
  latitude?: number
  longitude?: number
  address?: string
  addressDetails?: AddressDetails
  v2gEnrolled?: boolean
  geofence?: string
  numChargers?: number
  numVehicles?: number
  activeChargers?: number
  connectedChargers?: number
  rateCardId?: string
  rateCardTierType?: string
  created?: string
  updated?: string
  isLoadBalanced?: boolean
  /** The number of chargers that are in a pre-commissioned state. */
  chargersPrecommissioned?: number
  /** The number of chargers that are in a commissioned state. */
  chargersCommissioned?: number
  /** The number of chargers that are in a decommissioned state. */
  chargersDecommissioned?: number
  /** The number of chargers that are out of service. */
  chargersOutOfService?: number
  /** String representation, from IANA Time Zone Database, or 'UNKNOWN' if it could not be detected */
  timezone?: string
  /** The total energy (in kWh) that the site's chargers have delivered to vehicles in the last 24 hours. */
  importKwhLast24h?: number
  /** Whether the site has a tariff association. */
  hasTariffAssociation: boolean
  tariff?: AssetTariffMappingModel
  /** The energy efficiency value for this site (between 0 and 1). Returns null if no efficiency record exists. */
  efficiency?: number
  energyEfficiencyDetail?: EnergyEfficiencyModel
  efficiencyDetail?: EnergyEfficiencyModel
}
export type PagedResponseV0DepotModel = {
  first?: boolean
  last?: boolean
  pageSize?: number
  page?: number
  totalPages?: number
  totalItems?: number
  items?: DepotModel[]
}
export type GeometryBigDecimal = {
  type: string
  coordinates: number[]
}
export type TariffAssociationConfiguration = {
  lseId: string
  lseName: string
  lseCode?: string
  masterTariffId?: number
  customTariffId?: string
  marketId?: string
  tariffName: string
  tariffProvider: string
  customerClass: 'RESIDENTIAL' | 'GENERAL' | 'SPECIAL_USE' | 'PROPOSED'
  billingAnchorDate?: number
  validTariffProviderMapping?: boolean
}
export type DepotMetaDataUpdateModel = {
  depotId: string
  fleetId?: string
  depotNm?: string
  geofence?: string
  location?: GeometryBigDecimal
  address?: string
  addressDetails?: AddressDetails
  isLoadBalanced?: boolean
  siteLimit?: number
  /** [DEPRECATED] The rateCardId field is deprecated and will be removed after 06/30/2025. To set the tariff association, please use the `tariff` field. */
  rateCardId?: string
  /** [DEPRECATED] The rateCardTierType field is deprecated and will be removed after 06/30/2025. To set the tariff association, please use the `tariff` field. */
  rateCardTierType?: string
  externalId?: string
  tariff?: TariffAssociationConfiguration
  /** The energy efficiency value for this site (between 0 and 1). If not provided, the existing efficiency record will remain unchanged. */
  efficiency?: number
}
export type DepotCreationModel = {
  fleetId: string
  depotNm: string
  externalId?: string
  powerCeiling?: number
  currentCeiling?: number
  voltageCeiling?: number
  location?: GeometryBigDecimal
  v2gEnrolled?: boolean
  address?: string
  addressDetails?: AddressDetails
  geofence?: string
  rateCardId?: string
  rateCardTierType?: string
  isLoadBalanced?: boolean
  /** The energy efficiency value for this site (between 0 and 1). If not provided, no efficiency record will be created. */
  efficiency?: number
}
export type DepotEnergyLimitsModel = {
  depotId?: string
  fleetId?: string
  externalId?: string
  powerCeiling?: number
  voltageCeiling?: number
  currentCeiling?: number
  isLoadBalanced?: boolean
}
export type DepotEnergyLimitsUpdateModel = {
  powerCeiling?: number
  currentCeiling?: number
  voltageCeiling?: number
  isLoadBalanced?: boolean
}
export type ConnectorStatusModel = {
  /** The ID of the charger */
  chargerId?: string
  /** The nickname of the charger. */
  chargerNm?: string
  /** The identifier of the connector of which a status message occurred. PLEASE NOTE: the 'connector status' for connectorId 0 is DEPRECATED, and is scheduled to be removed by 2023-06-01; please use the ChargerStatusModel for accurate 'connector 0' information. */
  connectorId?: number
  /** The current status of the connector, according to OCPP. */
  status?:
    | 'Available'
    | 'Preparing'
    | 'Charging'
    | 'Finishing'
    | 'SuspendedEVSE'
    | 'SuspendedEV'
    | 'Reserved'
    | 'Faulted'
    | 'Unavailable'
    | 'Unknown'
  /** The current status of the connector. This includes 'Offline' if the charger has not been heard from in the last 15 minutes. */
  currentCombinedStatus?:
    | 'Available'
    | 'Preparing'
    | 'Charging'
    | 'Finishing'
    | 'SuspendedEVSE'
    | 'SuspendedEV'
    | 'Reserved'
    | 'Faulted'
    | 'Unavailable'
    | 'Unknown'
    | 'Offline'
  /** The current status of the connector [DEPRECATED, use `status` instead]. */
  legacyStatus?:
    | 'Available'
    | 'Preparing'
    | 'Charging'
    | 'Finishing'
    | 'SuspendedEVSE'
    | 'SuspendedEV'
    | 'Reserved'
    | 'Faulted'
    | 'Unavailable'
  /** The 'operational status' of a connector (whether or not it is operative/functioning). */
  operationalStatus?: 'Operative' | 'Inoperative' | 'Unknown'
  /** The 'occupied status' of a connector (whether or not there is a vehicle plugged into the connector). If the connector is inoperative, the occupied status will be 'Unknown'. */
  occupiedStatus?: 'Occupied' | 'Unoccupied' | 'Unknown'
  /** The 'simplified status' of a connector */
  simplifiedStatus?: 'Unoccupied' | 'PreparingOrCharging' | 'FinishedCharging' | 'Faulted' | 'Unavailable' | 'Unknown'
  /** This contains the error code reported by the connector. */
  errorCode?: string
  /** Additional error information reported by the connector. */
  errorInfo?: string
  /** An ID for a connector status message, defined by the manufacturer. */
  vendorId?: string
  /** An ID for a error code, defined by the manufacturer. */
  vendorErrorCode?: string
  /** The time, IN UTC in which an connector status message occurred on the charger. */
  statusTimestamp?: string
}
export type ConnectorUtilizationModel = {
  /** The last received power import values (in kilowatts) on a connector. This field will be populated with the latest value the server has received, even if the charger had not been heard from recently.If a charger does not provide a Power.Active.Import measurand, Voltage and Current will be used to calculate power.
    If Voltage and Current are not present, Power.Offered will be used instead. */
  lastKnownPowerImportKw?: number
  /** The sum of 'live' power import values (in kilowatts) on connector.
    A value of `null` means that the charger has not communicated with the server in the past 15 minutes.A value of 0 indicates either that the connector is not in a transaction, and has been heard from within the past 15 minutes; or if the charger is connector in a transaction exporting power.If a charger does not provide a Power.Active.Import measurand, Voltage and Current will be used to calculate power.
    If Voltage and Current are not present, Power.Offered will be used instead. */
  livePowerImportKw?: number
  /** The 'live' power export values (in kilowatts) on a connector. This field will only be populated if a charger has communicated with the server in the last 15 minutes, otherwise it will be `null` when no data has been received.A value of 0 indicates that the connector is actively discharging, but has not been heard from within the last 15 minutes. */
  lastKnownPowerExportKw?: number
  /** The the last received power export values (in kilowatts) on a connector. This field will be populated with the latest value the server has received, even if the charger had not been heard from recently.
    A value of `null` means that the charger has not communicated with the server in the past 15 minutes.A value of 0 indicates either that the connector is not in a transaction, and has been heard from within the past 15 minutes; or if the charger is connector in a transaction exporting power. */
  livePowerExportKw?: number
}
export type LastMeterValuesModel = {
  /** Current.Import - the most recent measure of instantaneous current flow to an EV in Amps. */
  currentImportAmps?: number
  /** The UTC timestamp of the most recent Current.Import measurand. */
  currentImportAmpsTimestamp?: string
  /** The most recent measure of instantaneous AC root mean square voltage. */
  voltage?: number
  /** The UTC timestamp of the most recent voltage measurand. */
  voltageTimestamp?: string
  /** Current.Offered - the most recent measure of the maximum current,in amps, offered to an EV. */
  currentOfferedAmps?: number
  /** The UTC timestamp of the most recent Current.Offered measurand. */
  currentOfferedAmpsTimestamp?: string
  /** Energy.Active.Import.Register - the most recent measure of energy imported by the EV in kiloWatt-hours. */
  energyActiveImportRegisterKwh?: number
  /** The UTC timestamp of the most recent Energy.Active.Import.Register measurand. */
  energyActiveImportRegisterKwhTimestamp?: string
  /** Energy.Active.Import.Interval - the most recent measure of energy imported by the EV since the last meter value sample, in kiloWatt-hours. */
  energyActiveImportIntervalKwh?: number
  /** The UTC timestamp of the most recent Energy.Active.Import.Interval measurand. */
  energyActiveImportIntervalKwhTimestamp?: string
  /** Power.Active.Import - the most recent measure of instantaneous power imported by the EV in kiloWatts. */
  powerActiveImportKw?: number
  /** The UTC timestamp of the most recent Power.Active.Import measurand. */
  powerActiveImportKwTimestamp?: string
  /** Power.Offered - the most recent measure of maximum power offered to the EV by the charger in kiloWatts. */
  powerOfferedKw?: number
  /** The UTC timestamp of the most recent Power.Offered measurand. */
  powerOfferedKwTimestamp?: string
  /** Power.Active.Export - the most recent measure of instantaneous power exported by the EV in kiloWatts. */
  powerActiveExportKw?: number
  /** The UTC timestamp of the most recent Power.Active.Export measurand. */
  powerActiveExportKwTimestamp?: string
  /** Power.Factor - the most recent measure of instantaneous power factor of total energy flow. */
  powerFactor?: number
  /** The UTC timestamp of the most recent Power.Factor measurand. */
  powerFactorTimestamp?: string
  /** The most recent measure of the temperature reading inside a charger. */
  temperature?: number
  /** The UTC timestamp of the most recent Temperature measurand. */
  temperatureTimestamp?: string
  /** The most recent measure of the state of charge of a vehicle in percentage. */
  soc?: number
  /** The UTC timestamp of the most recent SoC measurand. */
  socTimestamp?: string
  /** Current.Export - the most recent measure of instantaneous current flow from an EV, in amps. */
  currentExportAmps?: number
  /** The UTC timestamp of the most recent Current.Export measurand. */
  currentExportAmpsTimestamp?: string
  /** Energy.Active.Export.Register - the most recent measure of energy exported by an EV, in kiloWatt-hours. */
  energyActiveExportRegisterKwh?: number
  /** The UTC timestamp of the most recent Energy.Active.Export.Register measurand. */
  energyActiveExportRegisterKwhTimestamp?: string
}
export type TransactionReservationModel = {
  /** The unique id of the reservation */
  reservationId: string
  /** The time the reservation was started */
  reservationStartTime: string
  /** Identifies the chargerEvent associated with this reservation */
  chargerEventId?: string
  /** Charger reported status of the reservation */
  ocppStatus?: string
}
export type TransactionAuthTagMappingModel = {
  normalizedAuthTag?: string
  /** The type of authentication tag */
  authTagType?: 'RFID' | 'MAC_ADDRESS' | 'NONE'
  /** The organization ID associated with this auth tag */
  authTagOrganizationId?: string
  /** The user ID if this is an RFID tag */
  userId?: string
  /** The vehicle ID if this is a MAC_ADDRESS tag */
  vehicleId?: string
}
export type TransactionCostComponent = {
  id?: string
  rateName?: string
  rateType?: 'FLAT' | 'TOU' | 'TIER'
  rate?: number
  usageQuantity?: number
  cost?: number
}
export type TransactionSummaryModel = {
  /** The ID generated by Synop for a transaction. */
  id: string
  /** The ID for a transaction stored by the charger. */
  transactionPk: number
  /** The ID for the connector on which the transaction occurred . */
  connectorId: number
  /** The name of the connector on which the transaction occurred. */
  connectorName?: string
  /** The eMobility EVSE ID (eMI3/IDACS format) of the connector on which the transaction occurred. */
  emobilityEvseId?: string
  /** The internal ID of the charger on which the transaction occurred. */
  chargerPk: number
  /** The OCPP ID for charger on which the transaction occurred. */
  chargerId: string
  /** The name of the charger on which the transaction occurred. */
  chargerName: string
  /** The customer-assigned asset ID of the charger on which the transaction occurred. This is optional charger metadata and is null when not set. */
  chargerAssetId?: string
  /** The id of the depot of which the charger belongs to. */
  depotId: string
  /** The id of the organization of which the charger belongs to. */
  organizationId: string
  /** The ocpp id tag associated with the transaction. */
  ocppTag: string
  /** The reason why the transaction stopped. */
  stopReason?: string
  /** What caused the transaction to stop. */
  stopEventActor?: string
  /** The time in UTC in which the transaction started. */
  startTimestamp: string
  /** The time in UTC in which the transaction stopped. */
  stopTimestamp?: string
  /** The time in UTC in which the transaction was updated. */
  updatedTimestamp: string
  /** Raw OCPP meterStart (StartTransaction) — import register at transaction begin, in Wh. */
  meterStart?: number
  /** Raw OCPP meterStop (StopTransaction) — import register at transaction end, in Wh. */
  meterStop?: number
  /** The total energy imported during the transaction in kiloWatt hours. */
  totalEnergyImported?: number
  /** The total energy exported during the transaction in kiloWatt hours. */
  totalEnergyExported?: number
  /** Estimated energy imported during the transaction in kWh, calculated from minute-by-minute power data. WARNING: this value may not to be accurate, and should not be used for billing purposes. It is only to be used as a convenience number when direct energy data is missing. */
  estimatedEnergyImportKwh?: number
  /** The last timestamp during the transaction when nonzero power or energy transfer was observed. */
  lastNonzeroTransferTimestamp?: string
  /** The mean power imported during the transaction in kiloWatts. */
  meanPowerImport?: number
  /** The most recent power imported during the transaction in kiloWatts. */
  maxPowerImport?: number
  /** The latest power imported during the transaction in kiloWatts. */
  latestPowerImport?: number
  /** The mean power exported during the transaction in kiloWatts. */
  meanPowerExport?: number
  /** The max power exported during the transaction in kiloWatts. */
  maxPowerExport?: number
  /** The most recent power exported during the transaction in kiloWatts. */
  latestPowerExport?: number
  /** The mean power offered to the EV by the charger during the transaction in kiloWatts. */
  meanPowerOffered?: number
  /** The max power offered to the EV by the charger during the transaction in kiloWatts. */
  maxPowerOffered?: number
  /** The most recent power offered to the EV by the charger during the transaction in kiloWatts. */
  latestPowerOffered?: number
  /** The mean amperage of the transaction in Amps. */
  meanAmperageImport?: number
  /** The max amperage of the transaction in Amps. */
  maxAmperageImport?: number
  /** The most recent amperage of the transaction in Amps. */
  latestAmperageImport?: number
  /** The mean amperage offered to the EV by the charger during the transaction in Amps. */
  meanAmperageOffered?: number
  /** The max amperage offered to the EV by the charger during the transaction in Amps. */
  maxAmperageOffered?: number
  /** The most recent amperage offered to the EV by the charger during the transaction in Amps. */
  latestAmperageOffered?: number
  /** The minimum voltage during the transaction in Volts. */
  minVoltage?: number
  /** The mean voltage during the transaction in Volts. */
  meanVoltage?: number
  /** The max voltage during the transaction in Volts. */
  maxVoltage?: number
  /** The most recent voltage during the transaction in Volts. */
  latestVoltage?: number
  /** The minimum frequency during the transaction in Volts. */
  minFrequency?: number
  /** The mean frequency during the transaction in Volts. */
  meanFrequency?: number
  /** The max frequency during the transaction in Volts. */
  maxFrequency?: number
  /** The most recent frequency during the transaction in Volts. */
  latestFrequency?: number
  /** The starting temperature of the connector of the charger during the transaction in Celsius. */
  startingTemperature?: number
  /** The minimum temperature of the connector of the charger during the transaction in Celsius. */
  minTemperature?: number
  /** The mean temperature of the connector of the charger during the transaction in Celsius. */
  meanTemperature?: number
  /** The maximum temperature of the connector of the charger during the transaction in Celsius. */
  maxTemperature?: number
  /** The most recent temperature of the connector of the charger during the transaction in Celsius. */
  latestTemperature?: number
  /** The starting SoC of the EV during the transaction. */
  startingSoc?: number
  /** The most recent SoC of the EV during the transaction. */
  latestSoc?: number
  /** The timezone of the charger & site where the transaction took place. */
  timezone?: string
  /** The commissioning state of the charger at the beginning of the transaction. */
  commissioningState?: 'PRECOMMISSIONED' | 'COMMISSIONED' | 'DECOMMISSIONED'
  /** The time in UTC in which a connector was plugged into an EV, before starting a charging transaction. */
  plugInTime?: string
  /** The time in UTC in which a connector was unplugged from an EV after ending a charging transaction. */
  plugOutTime?: string
  /** An identifier for the node in which the transaction took place. */
  nodeId: string
  /** The name of the node in which the transaction took place. */
  nodeName?: string
  /** A flag indicating if this transaction occurred on the default node of a site. */
  isDefaultNode: boolean
  /** The energy efficiency factor for this transaction (e.g. 0.95 for 95% efficient). If this value is null, a default value of 0.95 is used. */
  energyEfficiency?: number
  reservation?: TransactionReservationModel
  authTagMapping?: TransactionAuthTagMappingModel
  /** The currency of the transaction. */
  currency?: string
  /** The total cost of the transaction. Null when an anomaly was detected during the cost calculation. */
  cost?: number
  /** The individual rate components that make up the transaction's cost. */
  costComponents?: TransactionCostComponent[]
  /** Whether the cost is anomalous. A value of `true` indicates that the cost could not be calculated due to data anomalies. */
  anomalyDetected?: boolean
}
export type ChargerStatusModel = {
  /** The latest known status of the charger (as a whole). This may be different from the current status if the charger is offline. */
  status?: 'Operative' | 'Faulted' | 'Unavailable' | 'Unknown' | 'PartiallyFaulted'
  /** The current status of the charger (as a whole). This includes 'Offline' if the charger has not been heard from in the last 15 minutes. */
  currentCombinedStatus?: 'Operative' | 'Faulted' | 'Unavailable' | 'Unknown' | 'Offline' | 'PartiallyFaulted'
  /** The time associated with the status message from the charger */
  statusTimestamp?: string
  /** The 'operational status' of a connector (whether or not it is operative/functioning). */
  operationalStatus?: 'Operative' | 'Inoperative' | 'Unknown'
  /** The connectivity status of the charger, as determined by the lastHeardTimestamp (online if heard from in the last 15 minutes). */
  connectivityStatus?: 'Online' | 'Offline'
}
export type ConnectorSimplifiedStatusCountsModel = {
  /** The total number of connectors with a simplifiedStatus of 'Faulted'. */
  numConnectorsFaulted?: number
  /** The total number of connectors with a simplifedStatus of 'Unavailable'. */
  numConnectorsUnavailable?: number
  /** The total number of connectors with a simplifedStatus of 'PreparingOrCharging' (where `status` is 'Preparing' or 'Charging'). */
  numConnectorsPreparingOrCharging?: number
  /** The total number of connectors with a simplifedStatus of 'FinishedCharging' (where `status` is 'SuspendedEV', 'SuspendedEVSE' or 'Finishing'). */
  numConnectorsFinishedCharging?: number
  /** The total number of connectors with a simplifiedStatus of 'Unoccupied' (where `status` is 'Available' or 'Reserved'). */
  numConnectorsUnoccupied?: number
}
export type ChargingSessionTelemetryModel = {
  deprecationMessage?: string
  chargerId?: string
  connectorId?: number
  chargingSessionId?: string
  measuredAt?: string
  currentImport?: number
  currentImportUnit?: string
  currentOffered?: number
  currentOfferedUnit?: string
  energyActiveImportRegister?: number
  energyActiveImportRegisterUnit?: string
  powerActiveImport?: number
  powerActiveImportUnit?: string
  livePowerImportUnit?: string
  powerOffered?: number
  powerOfferedUnit?: string
  voltage?: number
  voltageUnit?: string
  temperature?: number
  temperatureUnit?: string
  soc?: number
  socUnit?: string
  currentExport?: number
  currentExportUnit?: string
  powerActiveExport?: number
  powerActiveExportUnit?: string
  energyActiveExportRegister?: number
  energyActiveExportRegisterUnit?: string
  energyActiveImportInterval?: number
  energyActiveImportIntervalUnit?: string
  powerFactor?: number
  powerFactorUnit?: string
  context?: string
  livePowerImport?: number
  livePowerUnit?: string
}
export type ChargingSessionModel = {
  /** DEPRECATION NOTICE: This model is deprecated and will be removed on September 15th 2023, please use the TransactionSummary model instead located in the ChargerModel returned from the GET /api/chargers/ endpoint. */
  deprecationNotice?: string
  transactionId?: number
  sessionId?: string
  connectorId?: number
  chargerId?: string
  ocppTag?: string
  vehicleId?: string
  vin?: string
  userId?: string
  startTimestamp?: string
  stopTimestamp?: string
  stopReason?: string
  depotId?: string
  fleetId?: string
  chargerName?: string
  depotName?: string
  /** The kWh consumed during the session as measured by the charger. */
  kwhConsumed?: number
  kwhConsumedUnit?: string
  /** The power actively imported by an EV currently in a charging session, as measured by the charger. */
  powerImported?: number
  powerImportUnit?: string
  /** The power in kW offered by a charger during a charging session, as measured by the charger. */
  powerOffered?: number
  powerOfferedUnit?: string
  startSocValue?: number
  endSocValue?: number
}
export type ConnectorModel = {
  /** The ID of the connector */
  connectorId?: number
  /** The ID of the associated charger */
  chargerId?: string
  /** The connection type of the connector */
  connectorType?: 'J1772' | 'Type2' | 'CHAdeMO' | 'CCS1' | 'CCS2' | 'NACS' | 'MCS' | 'Other'
  /** Whether the connector is a socket (EV user brings a cable) or an attached cable. Null means unknown. */
  connectorFormat?: 'SOCKET' | 'CABLE'
  /** Electrical power delivery type for this connector (AC phase arrangement or DC). Null means unknown. */
  connectorPowerType?: 'AC_1_PHASE' | 'AC_2_PHASE' | 'AC_2_PHASE_SPLIT' | 'AC_3_PHASE' | 'DC'
  /** The optional name of the connector */
  connectorName?: string
  /** The eMobility EVSE ID (eMI3/IDACS format) for this connector */
  emobilityEvseId?: string
  /** The maximum power this connector can deliver, in kW. Null means unconfigured. */
  maxPower?: number
  /** The voltage of this connector, in volts. Null means unconfigured. */
  voltage?: number
  /** The amperage of this connector, in amps. Null means unconfigured. */
  amperage?: number
  currentType?: string
  powerFactor?: number
}
export type ChargerCapabilitiesOcppIdTagTypes = {
  values?: string[]
}
export type ChargerModel = {
  chargerId: string
  chargerName?: string
  endpointAddress?: string
  ocppProtocol?: string
  registrationStatus?: string
  chargePointYear?: number
  chargePointVendor?: string
  chargePointModel?: string
  chargePointSerialNumber?: string
  chargeBoxSerialNumber?: string
  firmwareVersion?: string
  firmwareUpdateStatus?: string
  /** The inferred status of the charger's most recent firmware update, based on the charger's reported status, as well as the last time the charger has communicated with the central system. */
  firmwareUpdateInferredStatus?:
    | 'Downloaded'
    | 'DownloadFailed'
    | 'Downloading'
    | 'Idle'
    | 'InstallationFailed'
    | 'Installing'
    | 'Installed'
    | 'Unknown'
  firmwareUpdateTimestamp?: string
  iccid?: string
  imsi?: string
  location?: GeometryBigDecimal
  meterType?: string
  meterSerialNumber?: string
  diagnosticsStatus?: string
  /** The status of diagnostics in simplified form. */
  diagnosticStatus?:
    | 'IN_PROGRESS'
    | 'AVAILABLE'
    | 'EXPIRED'
    | 'CANCELLED'
    | 'FAILED'
    | 'NOT_SUPPORTED'
    | 'MISSING_MAKE_MODEL'
  diagnosticsTimestamp?: string
  /** The last time the charger has sent a 'heartbeat' message to the central server. */
  lastHeartbeatTimestamp?: string
  /** The last time the central system has received _any_ message from the charger. */
  lastHeardTimestamp?: string
  description?: string
  note?: string
  /** Free Vend Mode. When true, every tag presented at this charger is accepted, without consulting OCPP tags, location rules or OCPI, and nothing is recorded about the tag. */
  freeVendMode?: boolean
  /** [DEPRECATED - Will be removed after 7/1/2025] use nodeId. An identifier for the group that the charger belongs to. A group is also called a node. */
  groupId?: string
  /** [DEPRECATED - Will be removed after 7/1/2025] use nodeName. The name of the group that the charger belongs to. A group is also called a node. */
  groupName?: string
  /** An identifier for the node that the charger belongs to. */
  nodeId?: string
  /** The name of the node that the charger belongs to. */
  nodeName?: string
  /** Specifies if this charger is on the defaultNode */
  isDefaultNode?: boolean
  maxPower: number
  maxCurrent?: number
  voltage?: number
  /** The type of electrical current that the charger is capable of delivering. */
  currentType?: 'AC' | 'DC'
  depotId?: string
  depotName?: string
  fleetId?: string
  externalId?: string
  latitude?: number
  longitude?: number
  created?: string
  updated?: string
  connectorIds: number[]
  activeConnectorIds: number[]
  connectorStatus: {
    [key: string]: ConnectorStatusModel
  }
  /** A map, indexed by connectorId, containing a representation of the power utilization on each connector */
  connectorUtilization: {
    [key: string]: ConnectorUtilizationModel
  }
  /** A map, indexed by connector id containing a representation of the last received meter values for a transaction on each connector. */
  lastMeterValues: {
    [key: string]: LastMeterValuesModel
  }
  /** A map, indexed by connector id containing a representation of the most recent transaction on each connector. */
  lastTransactions: {
    [key: string]: TransactionSummaryModel
  }
  latestChargerStatus: ChargerStatusModel
  connectorSimplifiedStatusCounts: ConnectorSimplifiedStatusCountsModel
  /** The latest set of metered values reported by a connector on the charger that have been received in the past week. */
  lastTelemetry?: {
    [key: string]: ChargingSessionTelemetryModel
  }
  /** The last know charging session that has occurred on the charger in the past week. */
  lastSession?: {
    [key: string]: ChargingSessionModel
  }
  v2gEnabled?: boolean
  /** A map, indexed by connector id containing details on each of the chargers connectors. */
  connectors: {
    [key: string]: ConnectorModel
  }
  /** The sum of 'live' power import values (in kilowatts) on a charger's connectors. This field will only be populated if a charger has communicated with the server in the last 15 minutes, otherwise it will be `null` when no data has been received.
    A value of `null` when a charger has not communicated with the server in the past 15 minutes.
    A value of 0 indicates either that the charger is not in a transaction, and has been heard from within the past 15 minutes; or if the charger is currently in a transaction exporting power.
    If a charger does not provide a Power.Active.Import measurand, Voltage and Current will be used to calculate power.If Voltage and Current are not present, Power.Offered will be used instead. */
  livePowerImport?: number
  /** The sum of 'live' power import values (in kilowatts) on a charger's connectors. This field will only be populated if a charger has communicated with the server in the last 15 minutes, otherwise it will be `null` when no data has been received.
    A value of `null` when a charger has not communicated with the server in the past 15 minutes.
    A value of 0 indicates either that the charger is not in a transaction, and has been heard from within the past 15 minutes; or if the charger is currently in a transaction exporting power.
    If a charger does not provide a Power.Active.Import measurand, Voltage and Current will be used to calculate power.If Voltage and Current are not present, Power.Offered will be used instead. */
  livePowerImportKw?: number
  /** The sum of the last received power import values (in kilowatts) on a charger's connectors. This field will be populated with the latest value the server has received, even if the charger had not been heard from recently. A value of 0 indicates that the connector was most recently not actively charging.If a charger does not provide a Power.Active.Import measurand, Voltage and Current will be used to calculate power.
    If Voltage and Current are not present, Power.Offered will be used instead. */
  lastKnownPowerImportKw: number
  livePowerImportUnit?: string
  /** The sum of 'live' power export values (in kilowatts) on a charger's connectors. This field will only be populated if a charger has communicated with the server in the last 15 minutes, otherwise it will be `null` when no data has been received.A value of `null` means that the charger has not communicated with the server in the past 15 minutes.
    A value of 0 indicates either that the charger is not in a transaction, and has been heard from within the past 15 minutes; or if the charger is currently in a transaction importing power. */
  livePowerExport?: number
  /** The sum of 'live' power export values (in kilowatts) on a charger's connectors. This field will only be populated if a charger has communicated with the server in the last 15 minutes, otherwise it will be `null` when no data has been received.A value of `null` means that the charger has not communicated with the server in the past 15 minutes.
    A value of 0 indicates either that the charger is not in a transaction, and has been heard from within the past 15 minutes; or if the charger is currently in a transaction importing power. */
  livePowerExportKw?: number
  /** The sum of the last received power export values (in kilowatts) on a charger's connectors. This field will be populated with the latest value the server has received, even if the charger had not been heard from recently. A value of 0 indicates that the connector was most recently not actively charging. */
  lastKnownPowerExportKw: number
  livePowerExportUnit?: string
  powerUnit?: string
  /** The date the charger was commissioned. */
  commissioningDate?: string
  /** The date the charger was decommissioned. */
  decommissioningDate?: string
  /** The network connection method of a charger. */
  networkConnectionMethod?: 'SIM' | 'WiFi' | 'LAN'
  /** A field for details about the network connection method of a charger. */
  networkConnectionDetails?: string
  /** The location of the charger according to the utility. */
  utilityLocationId?: string
  /** Whether or not the charger is ADA accessible. */
  isAdaAccessible?: boolean
  /** The type of installation of the charger. */
  evseInstallationType?: 'Pedestal' | 'WallMounted' | 'Other'
  /** The number of phases the charger prefers when receiving a charging profile. */
  preferredProfileNumPhases: number
  /** Indicator for whether the charger is a simulator. */
  isSimulator: boolean
  /** When true, transaction IDs are always inferred for this charger. Set this for chargers connected via an external primary CMS proxy, where the proxy may re-assign OCPP IDs mid-session independently of Synop. */
  alwaysInferTxIds?: boolean
  /** Power of ten applied to this charger's MeterValues energy readings at ingest, as OCPP 2.0.1's unitOfMeasure.multiplier. Null or 0 means as reported. */
  energyRegisterMultiplier?: number
  /** The commissioning state of the charger. */
  commissioningState?: 'PRECOMMISSIONED' | 'COMMISSIONED' | 'DECOMMISSIONED'
  /** The ID of the manufacturer of the charger. */
  manufacturerId?: string
  /** The name of the manufacturer of the charger. */
  manufacturerName?: string
  /** The ID of the make/model of the charger. */
  makeModelId?: string
  /** The name of the make/model of the charger. */
  makeModelName?: string
  /** From the capability set of the charger whether charging profiles require unique stack levels */
  chargingProfilesRequireUniqueStackLevels?: boolean
  /** If true, EMS will omit discharge parameters from profiles even if discharge is supported */
  excludeDischargeParameters?: boolean
  /** If true, the charger cannot follow a set point: EMS controls it on/off and budgets its full power whenever it is on */
  binaryShedding?: boolean
  /** From the capability set of the charger whether charging profiles accept Amps as a rate unit. */
  chargingProfilesAcceptsAmps?: boolean
  /** From the capability set of the charger whether charging profiles accept Watts as a rate unit. */
  chargingProfilesAcceptsWatts?: boolean
  ocppIdTagTypes?: ChargerCapabilitiesOcppIdTagTypes
  /** The energy efficiency value for this charger (between 0 and 1). Returns null if no efficiency record exists. */
  efficiency?: number
  energyEfficiencyDetail?: EnergyEfficiencyModel
  efficiencyDetail?: EnergyEfficiencyModel
}
export type ChargerModelRead = {
  chargerId: string
  chargerName?: string
  endpointAddress?: string
  ocppProtocol?: string
  registrationStatus?: string
  chargePointYear?: number
  chargePointVendor?: string
  chargePointModel?: string
  chargePointSerialNumber?: string
  chargeBoxSerialNumber?: string
  firmwareVersion?: string
  firmwareUpdateStatus?: string
  /** The inferred status of the charger's most recent firmware update, based on the charger's reported status, as well as the last time the charger has communicated with the central system. */
  firmwareUpdateInferredStatus?:
    | 'Downloaded'
    | 'DownloadFailed'
    | 'Downloading'
    | 'Idle'
    | 'InstallationFailed'
    | 'Installing'
    | 'Installed'
    | 'Unknown'
  firmwareUpdateTimestamp?: string
  iccid?: string
  imsi?: string
  location?: GeometryBigDecimal
  meterType?: string
  meterSerialNumber?: string
  diagnosticsStatus?: string
  /** The status of diagnostics in simplified form. */
  diagnosticStatus?:
    | 'IN_PROGRESS'
    | 'AVAILABLE'
    | 'EXPIRED'
    | 'CANCELLED'
    | 'FAILED'
    | 'NOT_SUPPORTED'
    | 'MISSING_MAKE_MODEL'
  diagnosticsTimestamp?: string
  /** The last time the charger has sent a 'heartbeat' message to the central server. */
  lastHeartbeatTimestamp?: string
  /** The last time the central system has received _any_ message from the charger. */
  lastHeardTimestamp?: string
  description?: string
  note?: string
  /** Free Vend Mode. When true, every tag presented at this charger is accepted, without consulting OCPP tags, location rules or OCPI, and nothing is recorded about the tag. */
  freeVendMode?: boolean
  /** [DEPRECATED - Will be removed after 7/1/2025] use nodeId. An identifier for the group that the charger belongs to. A group is also called a node. */
  groupId?: string
  /** [DEPRECATED - Will be removed after 7/1/2025] use nodeName. The name of the group that the charger belongs to. A group is also called a node. */
  groupName?: string
  /** An identifier for the node that the charger belongs to. */
  nodeId?: string
  /** The name of the node that the charger belongs to. */
  nodeName?: string
  /** Specifies if this charger is on the defaultNode */
  isDefaultNode?: boolean
  maxPower: number
  maxCurrent?: number
  voltage?: number
  /** The type of electrical current that the charger is capable of delivering. */
  currentType?: 'AC' | 'DC'
  depotId?: string
  depotName?: string
  fleetId?: string
  externalId?: string
  latitude?: number
  longitude?: number
  created?: string
  updated?: string
  connectorIds: number[]
  activeConnectorIds: number[]
  connectorStatus: {
    [key: string]: ConnectorStatusModel
  }
  /** A map, indexed by connectorId, containing a representation of the power utilization on each connector */
  connectorUtilization: {
    [key: string]: ConnectorUtilizationModel
  }
  /** A map, indexed by connector id containing a representation of the last received meter values for a transaction on each connector. */
  lastMeterValues: {
    [key: string]: LastMeterValuesModel
  }
  /** A map, indexed by connector id containing a representation of the most recent transaction on each connector. */
  lastTransactions: {
    [key: string]: TransactionSummaryModel
  }
  latestChargerStatus: ChargerStatusModel
  connectorSimplifiedStatusCounts: ConnectorSimplifiedStatusCountsModel
  /** The latest set of metered values reported by a connector on the charger that have been received in the past week. */
  lastTelemetry?: {
    [key: string]: ChargingSessionTelemetryModel
  }
  /** The last know charging session that has occurred on the charger in the past week. */
  lastSession?: {
    [key: string]: ChargingSessionModel
  }
  v2gEnabled?: boolean
  /** A map, indexed by connector id containing details on each of the chargers connectors. */
  connectors: {
    [key: string]: ConnectorModel
  }
  /** The sum of 'live' power import values (in kilowatts) on a charger's connectors. This field will only be populated if a charger has communicated with the server in the last 15 minutes, otherwise it will be `null` when no data has been received.
    A value of `null` when a charger has not communicated with the server in the past 15 minutes.
    A value of 0 indicates either that the charger is not in a transaction, and has been heard from within the past 15 minutes; or if the charger is currently in a transaction exporting power.
    If a charger does not provide a Power.Active.Import measurand, Voltage and Current will be used to calculate power.If Voltage and Current are not present, Power.Offered will be used instead. */
  livePowerImport?: number
  /** The sum of 'live' power import values (in kilowatts) on a charger's connectors. This field will only be populated if a charger has communicated with the server in the last 15 minutes, otherwise it will be `null` when no data has been received.
    A value of `null` when a charger has not communicated with the server in the past 15 minutes.
    A value of 0 indicates either that the charger is not in a transaction, and has been heard from within the past 15 minutes; or if the charger is currently in a transaction exporting power.
    If a charger does not provide a Power.Active.Import measurand, Voltage and Current will be used to calculate power.If Voltage and Current are not present, Power.Offered will be used instead. */
  livePowerImportKw?: number
  /** The sum of the last received power import values (in kilowatts) on a charger's connectors. This field will be populated with the latest value the server has received, even if the charger had not been heard from recently. A value of 0 indicates that the connector was most recently not actively charging.If a charger does not provide a Power.Active.Import measurand, Voltage and Current will be used to calculate power.
    If Voltage and Current are not present, Power.Offered will be used instead. */
  lastKnownPowerImportKw: number
  livePowerImportUnit?: string
  /** The sum of 'live' power export values (in kilowatts) on a charger's connectors. This field will only be populated if a charger has communicated with the server in the last 15 minutes, otherwise it will be `null` when no data has been received.A value of `null` means that the charger has not communicated with the server in the past 15 minutes.
    A value of 0 indicates either that the charger is not in a transaction, and has been heard from within the past 15 minutes; or if the charger is currently in a transaction importing power. */
  livePowerExport?: number
  /** The sum of 'live' power export values (in kilowatts) on a charger's connectors. This field will only be populated if a charger has communicated with the server in the last 15 minutes, otherwise it will be `null` when no data has been received.A value of `null` means that the charger has not communicated with the server in the past 15 minutes.
    A value of 0 indicates either that the charger is not in a transaction, and has been heard from within the past 15 minutes; or if the charger is currently in a transaction importing power. */
  livePowerExportKw?: number
  /** The sum of the last received power export values (in kilowatts) on a charger's connectors. This field will be populated with the latest value the server has received, even if the charger had not been heard from recently. A value of 0 indicates that the connector was most recently not actively charging. */
  lastKnownPowerExportKw: number
  livePowerExportUnit?: string
  powerUnit?: string
  /** The date the charger was commissioned. */
  commissioningDate?: string
  /** The date the charger was decommissioned. */
  decommissioningDate?: string
  /** The network connection method of a charger. */
  networkConnectionMethod?: 'SIM' | 'WiFi' | 'LAN'
  /** A field for details about the network connection method of a charger. */
  networkConnectionDetails?: string
  /** The location of the charger according to the utility. */
  utilityLocationId?: string
  /** Whether or not the charger is ADA accessible. */
  isAdaAccessible?: boolean
  /** The type of installation of the charger. */
  evseInstallationType?: 'Pedestal' | 'WallMounted' | 'Other'
  /** The number of phases the charger prefers when receiving a charging profile. */
  preferredProfileNumPhases: number
  /** Indicator for whether the charger is a simulator. */
  isSimulator: boolean
  /** When true, transaction IDs are always inferred for this charger. Set this for chargers connected via an external primary CMS proxy, where the proxy may re-assign OCPP IDs mid-session independently of Synop. */
  alwaysInferTxIds?: boolean
  /** Power of ten applied to this charger's MeterValues energy readings at ingest, as OCPP 2.0.1's unitOfMeasure.multiplier. Null or 0 means as reported. */
  energyRegisterMultiplier?: number
  /** The commissioning state of the charger. */
  commissioningState?: 'PRECOMMISSIONED' | 'COMMISSIONED' | 'DECOMMISSIONED'
  /** The ID of the manufacturer of the charger. */
  manufacturerId?: string
  /** The name of the manufacturer of the charger. */
  manufacturerName?: string
  /** The ID of the make/model of the charger. */
  makeModelId?: string
  /** The name of the make/model of the charger. */
  makeModelName?: string
  /** From the capability set of the charger whether charging profiles require unique stack levels */
  chargingProfilesRequireUniqueStackLevels?: boolean
  /** If true, EMS will omit discharge parameters from profiles even if discharge is supported */
  excludeDischargeParameters?: boolean
  /** If true, the charger cannot follow a set point: EMS controls it on/off and budgets its full power whenever it is on */
  binaryShedding?: boolean
  /** From the capability set of the charger whether charging profiles accept Amps as a rate unit. */
  chargingProfilesAcceptsAmps?: boolean
  /** From the capability set of the charger whether charging profiles accept Watts as a rate unit. */
  chargingProfilesAcceptsWatts?: boolean
  ocppIdTagTypes?: ChargerCapabilitiesOcppIdTagTypes
  /** The energy efficiency value for this charger (between 0 and 1). Returns null if no efficiency record exists. */
  efficiency?: number
  energyEfficiencyDetail?: EnergyEfficiencyModel
  efficiencyDetail?: EnergyEfficiencyModel
  /** [DEPRECATED] use freeVendMode. An alias for freeVendMode, kept for existing clients. A request may send it instead of freeVendMode; sending both with different values is rejected. */
  autoRegisterTags?: boolean
}
export type PagedResponseV0ChargerModel = {
  first?: boolean
  last?: boolean
  pageSize?: number
  page?: number
  totalPages?: number
  totalItems?: number
  items?: ChargerModel[]
}
export type PagedResponseV0ChargerModelRead = {
  first?: boolean
  last?: boolean
  pageSize?: number
  page?: number
  totalPages?: number
  totalItems?: number
  items?: ChargerModelRead[]
}
export type ChargerMakeModelKnownOperatingParameters = {
  /** A list of known power ratings in kilowatts for a charger make/model. */
  knownPowerRatingsKw?: number[]
  /** A list of known operating electrical current rating, in amps for a charger make/model. */
  knownOperatingCurrentsAmps?: number[]
  /** A list of known operating voltages, in volts for a charger make/model. */
  knownOperatingVoltages?: number[]
}
export type ChargerMakeModelResponseModel = {
  /** An internal identifier for a make/model of a charger, generated by Synop. */
  id?: string
  /** The name of the vendor for the charger make/model. */
  vendorName?: string
  /** The name of the model of the charger. */
  chargerModel?: string
  /** Additional information for the charger make/model.  */
  modelHelperText?: string
  /** The electrical current type of the charger. */
  currentType?: string
  chargerMakeModelKnownOperatingParameters?: ChargerMakeModelKnownOperatingParameters
}
export type ChargerManufacturerModel = {
  id?: string
  name?: string
}
export type ChargerCapabilitySetResponseModel = {
  /** An identifier for the capability set, generated by Synop. */
  id?: string
  /** A version identifier of the charger capabilities. */
  version?: string
  ocppIdTagTypes?: ChargerCapabilitiesOcppIdTagTypes
  /** The ocpp protocol supported by the charger. */
  ocppProtocol?: string
  /** A flag to signify if the charger supports charging profiles. */
  chargingProfilesAnySupport?: boolean
  /** A flag to signify if the charger supports Transaction Default charging profiles. */
  chargingProfilesSupportsDefaultTxProfile?: boolean
  /** A flag to signify if the charger supports Charge Point Max charging profiles. */
  chargingProfilesSupportsChargepointMax?: boolean
  /** A flag to signify if the charger supports Transaction Specific charging profiles. */
  chargingProfilesSupportsTxProfile?: boolean
  /** A flag to signify if the charger supports stack levels in charging profiles. */
  chargingProfilesStackLevelsSupported?: boolean
  /** The maximum stack level value you can apply to a charging profile. */
  chargingProfilesMaxStackLevels?: number
  /** A flag to signify if the charger requires unique stack levels in charging profiles across different connectors. */
  chargingProfilesRequireUniqueStackLevels?: boolean
  /** The maximum amount of charging profiles that can be on a charger at once. */
  chargingProfilesMaxSimultaneouslySupported?: number
  /** The maximum amount of schedule periods that can be inside a charging profile sent to a charger. */
  chargingProfilesMaxSchedulePeriods?: number
  /** A flag to signify if the charger can accept charging profiles with 0kW, and reduce power output to such. */
  chargingProfilesZeroPowerSupported?: boolean
  /** A flag to signify if the charger can accept charging profiles with Amps as a charging rate unit. */
  chargingProfilesAcceptsAmps?: boolean
  /** A flag to signify if the charger can accept charging profiles with Watts as a charging rate unit. */
  chargingProfilesAcceptsWatts?: boolean
  /** A flag to signify if the charger can accept perform V2G operations. */
  chargingProfilesSupportsDischarge?: boolean
  /** A flag to signify the maximum amount of power that can be returned to the grid during a V2G operation. */
  chargingProfilesMaxDischargePower?: number
  /** When true, omit discharge parameters from profiles even if supported. */
  excludeDischargeParameters?: boolean
  /** When true, the charger cannot follow a set point: EMS controls it on/off and budgets its full power whenever it is on. */
  binaryShedding?: boolean
  /** A JSON object of additional comments and observations about a particular charger make/model, keyed by quirk name. Values are free-form JSON scalars: usually a description string, sometimes a boolean flag. */
  knownQuirks?: object
  /** A flag to signify if the charger can accept and perform a remote start via OCPP. */
  remoteStartSupport?: boolean
  /** A flag to signify if the charger can accept and perform a remote stop via OCPP. */
  remoteStopSupport?: boolean
  /** A flag to signify if the charger can send transaction start messages via OCPP. */
  sendsTransactionStart?: boolean
  /** A flag to signify if the charger can send transaction stop messages via OCPP. */
  sendsTransactionStop?: boolean
  /** A flag to signify if the charger can send information via a data transfer message, if a vehicle is plugged into a charger irrespective of charging status. */
  sendsPlugInEvent?: boolean
  /** A flag to signify if the charger can send information via a data transfer message, if a vehicle is unplugged from a charger irrespective of charging status. */
  sendsPlugOutEvent?: boolean
  /** A flag to signify if the charger can send connector status messages via OCPP. */
  connectorStatusNotifSupport?: boolean
  /** A flag to signify if the charger can send connector meter value messages during a charging session via OCPP. */
  meterValuesAnySupport?: boolean
  /** A flag to signify if the charger can send connector meter value messages during a charging session with a context of 'Transaction.Begin' via OCPP. */
  meterValuesContextStart?: boolean
  /** A flag to signify if the charger can send connector meter value messages during a charging session with a context of 'Sample.Periodic' via OCPP. */
  meterValuesContextPeriodic?: boolean
  /** A flag to signify if the charger can send connector meter value messages during a charging session with a context of 'Transaction.End' via OCPP. */
  meterValuesContextStop?: boolean
  /** A JSON object that contains a list of measurands sent by the charger during a charging session */
  meterValuesSupportedMeasurands?: {
    [key: string]: string[]
  }
  /** A flag to signify if the charger can accept and perform a hard reboot via OCPP. */
  hardRebootSupported?: boolean
  /** A flag to signify if the charger can accept and perform a soft reboot via OCPP. */
  softRebootSupported?: boolean
  /** A flag to signify if the charger can accept and perform a get all configuration keys request via OCPP. */
  configKeysGetAllSupported?: boolean
  /** A flag to signify if the charger can accept and perform a get singular configuration key request via OCPP. */
  configKeysGetSpecificSupported?: boolean
  /** A flag to signify if the charger can accept and perform a set configuration key request via OCPP. */
  configKeysSetSupported?: boolean
  /** A flag to signify if the charger can upload diagnostics files. */
  canUploadDiagnostics?: boolean
  /** A flag to signify if the charger uses FTPS for diagnostics uploads. */
  usesDiagnosticsFtps?: boolean
  /** A flag to signify if the charger uses absolute path for diagnostics uploads. */
  usesDiagnosticsAbsolutePath?: boolean
  /** A flag to signify if the charger requires a filename in the diagnostics FTP location URL. When true, a timestamped filename with diagnosticsFileNameSuffix is appended. */
  usesDiagnosticsFileName?: boolean
  /** The file extension suffix appended to the diagnostics filename (e.g. '.tgz', '.zip'). Only used when usesDiagnosticsFileName is true. */
  diagnosticsFileNameSuffix?: string
  /** A flag to signify if cost data can be sent to the charger to be displayed. */
  canSendCostData?: boolean
}
export type ChargerInsightsModel = {
  /** The current health of the charger. If the charger has never been heard from, its health is `Unknown`. If it was in a faulted state at any time in the past 24 hours, it is considered `Unhealthy`. Otherwise, if it was offline in the past 24 hours, it is considered `Marginal`. Lastly, if none of the above situations has occurred, the charger is considered `Healthy`. */
  chargerHealth: 'Unhealthy' | 'Marginal' | 'Unknown' | 'Healthy'
}
export type ChargerDetailModel = {
  chargerId: string
  chargerName?: string
  endpointAddress?: string
  ocppProtocol?: string
  registrationStatus?: string
  chargePointYear?: number
  chargePointVendor?: string
  chargePointModel?: string
  chargePointSerialNumber?: string
  chargeBoxSerialNumber?: string
  firmwareVersion?: string
  firmwareUpdateStatus?: string
  /** The inferred status of the charger's most recent firmware update, based on the charger's reported status, as well as the last time the charger has communicated with the central system. */
  firmwareUpdateInferredStatus?:
    | 'Downloaded'
    | 'DownloadFailed'
    | 'Downloading'
    | 'Idle'
    | 'InstallationFailed'
    | 'Installing'
    | 'Installed'
    | 'Unknown'
  firmwareUpdateTimestamp?: string
  iccid?: string
  imsi?: string
  location?: GeometryBigDecimal
  meterType?: string
  meterSerialNumber?: string
  diagnosticsStatus?: string
  /** The status of diagnostics in simplified form. */
  diagnosticStatus?:
    | 'IN_PROGRESS'
    | 'AVAILABLE'
    | 'EXPIRED'
    | 'CANCELLED'
    | 'FAILED'
    | 'NOT_SUPPORTED'
    | 'MISSING_MAKE_MODEL'
  diagnosticsTimestamp?: string
  /** The last time the charger has sent a 'heartbeat' message to the central server. */
  lastHeartbeatTimestamp?: string
  /** The last time the central system has received _any_ message from the charger. */
  lastHeardTimestamp?: string
  description?: string
  note?: string
  /** Free Vend Mode. When true, every tag presented at this charger is accepted, without consulting OCPP tags, location rules or OCPI, and nothing is recorded about the tag. */
  freeVendMode?: boolean
  /** [DEPRECATED - Will be removed after 7/1/2025] use nodeId. An identifier for the group that the charger belongs to. A group is also called a node. */
  groupId?: string
  /** [DEPRECATED - Will be removed after 7/1/2025] use nodeName. The name of the group that the charger belongs to. A group is also called a node. */
  groupName?: string
  /** An identifier for the node that the charger belongs to. */
  nodeId?: string
  /** The name of the node that the charger belongs to. */
  nodeName?: string
  /** Specifies if this charger is on the defaultNode */
  isDefaultNode?: boolean
  maxPower: number
  maxCurrent?: number
  voltage?: number
  /** The type of electrical current that the charger is capable of delivering. */
  currentType?: 'AC' | 'DC'
  depotId?: string
  depotName?: string
  fleetId?: string
  externalId?: string
  latitude?: number
  longitude?: number
  created?: string
  updated?: string
  connectorIds: number[]
  activeConnectorIds: number[]
  connectorStatus: {
    [key: string]: ConnectorStatusModel
  }
  /** A map, indexed by connectorId, containing a representation of the power utilization on each connector */
  connectorUtilization: {
    [key: string]: ConnectorUtilizationModel
  }
  /** A map, indexed by connector id containing a representation of the last received meter values for a transaction on each connector. */
  lastMeterValues: {
    [key: string]: LastMeterValuesModel
  }
  /** A map, indexed by connector id containing a representation of the most recent transaction on each connector. */
  lastTransactions: {
    [key: string]: TransactionSummaryModel
  }
  latestChargerStatus: ChargerStatusModel
  connectorSimplifiedStatusCounts: ConnectorSimplifiedStatusCountsModel
  /** The latest set of metered values reported by a connector on the charger that have been received in the past week. */
  lastTelemetry?: {
    [key: string]: ChargingSessionTelemetryModel
  }
  /** The last know charging session that has occurred on the charger in the past week. */
  lastSession?: {
    [key: string]: ChargingSessionModel
  }
  v2gEnabled?: boolean
  /** A map, indexed by connector id containing details on each of the chargers connectors. */
  connectors: {
    [key: string]: ConnectorModel
  }
  /** The sum of 'live' power import values (in kilowatts) on a charger's connectors. This field will only be populated if a charger has communicated with the server in the last 15 minutes, otherwise it will be `null` when no data has been received.
    A value of `null` when a charger has not communicated with the server in the past 15 minutes.
    A value of 0 indicates either that the charger is not in a transaction, and has been heard from within the past 15 minutes; or if the charger is currently in a transaction exporting power.
    If a charger does not provide a Power.Active.Import measurand, Voltage and Current will be used to calculate power.If Voltage and Current are not present, Power.Offered will be used instead. */
  livePowerImport?: number
  /** The sum of 'live' power import values (in kilowatts) on a charger's connectors. This field will only be populated if a charger has communicated with the server in the last 15 minutes, otherwise it will be `null` when no data has been received.
    A value of `null` when a charger has not communicated with the server in the past 15 minutes.
    A value of 0 indicates either that the charger is not in a transaction, and has been heard from within the past 15 minutes; or if the charger is currently in a transaction exporting power.
    If a charger does not provide a Power.Active.Import measurand, Voltage and Current will be used to calculate power.If Voltage and Current are not present, Power.Offered will be used instead. */
  livePowerImportKw?: number
  /** The sum of the last received power import values (in kilowatts) on a charger's connectors. This field will be populated with the latest value the server has received, even if the charger had not been heard from recently. A value of 0 indicates that the connector was most recently not actively charging.If a charger does not provide a Power.Active.Import measurand, Voltage and Current will be used to calculate power.
    If Voltage and Current are not present, Power.Offered will be used instead. */
  lastKnownPowerImportKw: number
  livePowerImportUnit?: string
  /** The sum of 'live' power export values (in kilowatts) on a charger's connectors. This field will only be populated if a charger has communicated with the server in the last 15 minutes, otherwise it will be `null` when no data has been received.A value of `null` means that the charger has not communicated with the server in the past 15 minutes.
    A value of 0 indicates either that the charger is not in a transaction, and has been heard from within the past 15 minutes; or if the charger is currently in a transaction importing power. */
  livePowerExport?: number
  /** The sum of 'live' power export values (in kilowatts) on a charger's connectors. This field will only be populated if a charger has communicated with the server in the last 15 minutes, otherwise it will be `null` when no data has been received.A value of `null` means that the charger has not communicated with the server in the past 15 minutes.
    A value of 0 indicates either that the charger is not in a transaction, and has been heard from within the past 15 minutes; or if the charger is currently in a transaction importing power. */
  livePowerExportKw?: number
  /** The sum of the last received power export values (in kilowatts) on a charger's connectors. This field will be populated with the latest value the server has received, even if the charger had not been heard from recently. A value of 0 indicates that the connector was most recently not actively charging. */
  lastKnownPowerExportKw: number
  livePowerExportUnit?: string
  powerUnit?: string
  /** The date the charger was commissioned. */
  commissioningDate?: string
  /** The date the charger was decommissioned. */
  decommissioningDate?: string
  /** The network connection method of a charger. */
  networkConnectionMethod?: 'SIM' | 'WiFi' | 'LAN'
  /** A field for details about the network connection method of a charger. */
  networkConnectionDetails?: string
  /** The location of the charger according to the utility. */
  utilityLocationId?: string
  /** Whether or not the charger is ADA accessible. */
  isAdaAccessible?: boolean
  /** The type of installation of the charger. */
  evseInstallationType?: 'Pedestal' | 'WallMounted' | 'Other'
  /** The number of phases the charger prefers when receiving a charging profile. */
  preferredProfileNumPhases: number
  /** Indicator for whether the charger is a simulator. */
  isSimulator: boolean
  /** When true, transaction IDs are always inferred for this charger. Set this for chargers connected via an external primary CMS proxy, where the proxy may re-assign OCPP IDs mid-session independently of Synop. */
  alwaysInferTxIds?: boolean
  /** Power of ten applied to this charger's MeterValues energy readings at ingest, as OCPP 2.0.1's unitOfMeasure.multiplier. Null or 0 means as reported. */
  energyRegisterMultiplier?: number
  /** The commissioning state of the charger. */
  commissioningState?: 'PRECOMMISSIONED' | 'COMMISSIONED' | 'DECOMMISSIONED'
  /** The ID of the manufacturer of the charger. */
  manufacturerId?: string
  /** The name of the manufacturer of the charger. */
  manufacturerName?: string
  /** The ID of the make/model of the charger. */
  makeModelId?: string
  /** The name of the make/model of the charger. */
  makeModelName?: string
  /** From the capability set of the charger whether charging profiles require unique stack levels */
  chargingProfilesRequireUniqueStackLevels?: boolean
  /** If true, EMS will omit discharge parameters from profiles even if discharge is supported */
  excludeDischargeParameters?: boolean
  /** If true, the charger cannot follow a set point: EMS controls it on/off and budgets its full power whenever it is on */
  binaryShedding?: boolean
  /** From the capability set of the charger whether charging profiles accept Amps as a rate unit. */
  chargingProfilesAcceptsAmps?: boolean
  /** From the capability set of the charger whether charging profiles accept Watts as a rate unit. */
  chargingProfilesAcceptsWatts?: boolean
  ocppIdTagTypes?: ChargerCapabilitiesOcppIdTagTypes
  /** The energy efficiency value for this charger (between 0 and 1). Returns null if no efficiency record exists. */
  efficiency?: number
  energyEfficiencyDetail?: EnergyEfficiencyModel
  chargerMakeModel?: ChargerMakeModelResponseModel
  chargerManufacturerModel?: ChargerManufacturerModel
  chargerCapabilitySet?: ChargerCapabilitySetResponseModel
  insights: ChargerInsightsModel
  /** The number of kWh the charger has delivered to vehicles in the last 24 hours. */
  importKwhLast24h: number
  efficiencyDetail?: EnergyEfficiencyModel
}
export type ChargerDetailModelRead = {
  chargerId: string
  chargerName?: string
  endpointAddress?: string
  ocppProtocol?: string
  registrationStatus?: string
  chargePointYear?: number
  chargePointVendor?: string
  chargePointModel?: string
  chargePointSerialNumber?: string
  chargeBoxSerialNumber?: string
  firmwareVersion?: string
  firmwareUpdateStatus?: string
  /** The inferred status of the charger's most recent firmware update, based on the charger's reported status, as well as the last time the charger has communicated with the central system. */
  firmwareUpdateInferredStatus?:
    | 'Downloaded'
    | 'DownloadFailed'
    | 'Downloading'
    | 'Idle'
    | 'InstallationFailed'
    | 'Installing'
    | 'Installed'
    | 'Unknown'
  firmwareUpdateTimestamp?: string
  iccid?: string
  imsi?: string
  location?: GeometryBigDecimal
  meterType?: string
  meterSerialNumber?: string
  diagnosticsStatus?: string
  /** The status of diagnostics in simplified form. */
  diagnosticStatus?:
    | 'IN_PROGRESS'
    | 'AVAILABLE'
    | 'EXPIRED'
    | 'CANCELLED'
    | 'FAILED'
    | 'NOT_SUPPORTED'
    | 'MISSING_MAKE_MODEL'
  diagnosticsTimestamp?: string
  /** The last time the charger has sent a 'heartbeat' message to the central server. */
  lastHeartbeatTimestamp?: string
  /** The last time the central system has received _any_ message from the charger. */
  lastHeardTimestamp?: string
  description?: string
  note?: string
  /** Free Vend Mode. When true, every tag presented at this charger is accepted, without consulting OCPP tags, location rules or OCPI, and nothing is recorded about the tag. */
  freeVendMode?: boolean
  /** [DEPRECATED - Will be removed after 7/1/2025] use nodeId. An identifier for the group that the charger belongs to. A group is also called a node. */
  groupId?: string
  /** [DEPRECATED - Will be removed after 7/1/2025] use nodeName. The name of the group that the charger belongs to. A group is also called a node. */
  groupName?: string
  /** An identifier for the node that the charger belongs to. */
  nodeId?: string
  /** The name of the node that the charger belongs to. */
  nodeName?: string
  /** Specifies if this charger is on the defaultNode */
  isDefaultNode?: boolean
  maxPower: number
  maxCurrent?: number
  voltage?: number
  /** The type of electrical current that the charger is capable of delivering. */
  currentType?: 'AC' | 'DC'
  depotId?: string
  depotName?: string
  fleetId?: string
  externalId?: string
  latitude?: number
  longitude?: number
  created?: string
  updated?: string
  connectorIds: number[]
  activeConnectorIds: number[]
  connectorStatus: {
    [key: string]: ConnectorStatusModel
  }
  /** A map, indexed by connectorId, containing a representation of the power utilization on each connector */
  connectorUtilization: {
    [key: string]: ConnectorUtilizationModel
  }
  /** A map, indexed by connector id containing a representation of the last received meter values for a transaction on each connector. */
  lastMeterValues: {
    [key: string]: LastMeterValuesModel
  }
  /** A map, indexed by connector id containing a representation of the most recent transaction on each connector. */
  lastTransactions: {
    [key: string]: TransactionSummaryModel
  }
  latestChargerStatus: ChargerStatusModel
  connectorSimplifiedStatusCounts: ConnectorSimplifiedStatusCountsModel
  /** The latest set of metered values reported by a connector on the charger that have been received in the past week. */
  lastTelemetry?: {
    [key: string]: ChargingSessionTelemetryModel
  }
  /** The last know charging session that has occurred on the charger in the past week. */
  lastSession?: {
    [key: string]: ChargingSessionModel
  }
  v2gEnabled?: boolean
  /** A map, indexed by connector id containing details on each of the chargers connectors. */
  connectors: {
    [key: string]: ConnectorModel
  }
  /** The sum of 'live' power import values (in kilowatts) on a charger's connectors. This field will only be populated if a charger has communicated with the server in the last 15 minutes, otherwise it will be `null` when no data has been received.
    A value of `null` when a charger has not communicated with the server in the past 15 minutes.
    A value of 0 indicates either that the charger is not in a transaction, and has been heard from within the past 15 minutes; or if the charger is currently in a transaction exporting power.
    If a charger does not provide a Power.Active.Import measurand, Voltage and Current will be used to calculate power.If Voltage and Current are not present, Power.Offered will be used instead. */
  livePowerImport?: number
  /** The sum of 'live' power import values (in kilowatts) on a charger's connectors. This field will only be populated if a charger has communicated with the server in the last 15 minutes, otherwise it will be `null` when no data has been received.
    A value of `null` when a charger has not communicated with the server in the past 15 minutes.
    A value of 0 indicates either that the charger is not in a transaction, and has been heard from within the past 15 minutes; or if the charger is currently in a transaction exporting power.
    If a charger does not provide a Power.Active.Import measurand, Voltage and Current will be used to calculate power.If Voltage and Current are not present, Power.Offered will be used instead. */
  livePowerImportKw?: number
  /** The sum of the last received power import values (in kilowatts) on a charger's connectors. This field will be populated with the latest value the server has received, even if the charger had not been heard from recently. A value of 0 indicates that the connector was most recently not actively charging.If a charger does not provide a Power.Active.Import measurand, Voltage and Current will be used to calculate power.
    If Voltage and Current are not present, Power.Offered will be used instead. */
  lastKnownPowerImportKw: number
  livePowerImportUnit?: string
  /** The sum of 'live' power export values (in kilowatts) on a charger's connectors. This field will only be populated if a charger has communicated with the server in the last 15 minutes, otherwise it will be `null` when no data has been received.A value of `null` means that the charger has not communicated with the server in the past 15 minutes.
    A value of 0 indicates either that the charger is not in a transaction, and has been heard from within the past 15 minutes; or if the charger is currently in a transaction importing power. */
  livePowerExport?: number
  /** The sum of 'live' power export values (in kilowatts) on a charger's connectors. This field will only be populated if a charger has communicated with the server in the last 15 minutes, otherwise it will be `null` when no data has been received.A value of `null` means that the charger has not communicated with the server in the past 15 minutes.
    A value of 0 indicates either that the charger is not in a transaction, and has been heard from within the past 15 minutes; or if the charger is currently in a transaction importing power. */
  livePowerExportKw?: number
  /** The sum of the last received power export values (in kilowatts) on a charger's connectors. This field will be populated with the latest value the server has received, even if the charger had not been heard from recently. A value of 0 indicates that the connector was most recently not actively charging. */
  lastKnownPowerExportKw: number
  livePowerExportUnit?: string
  powerUnit?: string
  /** The date the charger was commissioned. */
  commissioningDate?: string
  /** The date the charger was decommissioned. */
  decommissioningDate?: string
  /** The network connection method of a charger. */
  networkConnectionMethod?: 'SIM' | 'WiFi' | 'LAN'
  /** A field for details about the network connection method of a charger. */
  networkConnectionDetails?: string
  /** The location of the charger according to the utility. */
  utilityLocationId?: string
  /** Whether or not the charger is ADA accessible. */
  isAdaAccessible?: boolean
  /** The type of installation of the charger. */
  evseInstallationType?: 'Pedestal' | 'WallMounted' | 'Other'
  /** The number of phases the charger prefers when receiving a charging profile. */
  preferredProfileNumPhases: number
  /** Indicator for whether the charger is a simulator. */
  isSimulator: boolean
  /** When true, transaction IDs are always inferred for this charger. Set this for chargers connected via an external primary CMS proxy, where the proxy may re-assign OCPP IDs mid-session independently of Synop. */
  alwaysInferTxIds?: boolean
  /** Power of ten applied to this charger's MeterValues energy readings at ingest, as OCPP 2.0.1's unitOfMeasure.multiplier. Null or 0 means as reported. */
  energyRegisterMultiplier?: number
  /** The commissioning state of the charger. */
  commissioningState?: 'PRECOMMISSIONED' | 'COMMISSIONED' | 'DECOMMISSIONED'
  /** The ID of the manufacturer of the charger. */
  manufacturerId?: string
  /** The name of the manufacturer of the charger. */
  manufacturerName?: string
  /** The ID of the make/model of the charger. */
  makeModelId?: string
  /** The name of the make/model of the charger. */
  makeModelName?: string
  /** From the capability set of the charger whether charging profiles require unique stack levels */
  chargingProfilesRequireUniqueStackLevels?: boolean
  /** If true, EMS will omit discharge parameters from profiles even if discharge is supported */
  excludeDischargeParameters?: boolean
  /** If true, the charger cannot follow a set point: EMS controls it on/off and budgets its full power whenever it is on */
  binaryShedding?: boolean
  /** From the capability set of the charger whether charging profiles accept Amps as a rate unit. */
  chargingProfilesAcceptsAmps?: boolean
  /** From the capability set of the charger whether charging profiles accept Watts as a rate unit. */
  chargingProfilesAcceptsWatts?: boolean
  ocppIdTagTypes?: ChargerCapabilitiesOcppIdTagTypes
  /** The energy efficiency value for this charger (between 0 and 1). Returns null if no efficiency record exists. */
  efficiency?: number
  energyEfficiencyDetail?: EnergyEfficiencyModel
  chargerMakeModel?: ChargerMakeModelResponseModel
  chargerManufacturerModel?: ChargerManufacturerModel
  chargerCapabilitySet?: ChargerCapabilitySetResponseModel
  insights: ChargerInsightsModel
  /** The number of kWh the charger has delivered to vehicles in the last 24 hours. */
  importKwhLast24h: number
  efficiencyDetail?: EnergyEfficiencyModel
  /** [DEPRECATED] use freeVendMode. An alias for freeVendMode, kept for existing clients. A request may send it instead of freeVendMode; sending both with different values is rejected. */
  autoRegisterTags?: boolean
}
export type ConnectorUpdateModel = {
  /** The connection type of the connector. Omit to leave unchanged; send `unset` to clear it. */
  connectorType?: 'J1772' | 'Type2' | 'CHAdeMO' | 'CCS1' | 'CCS2' | 'NACS' | 'MCS' | 'Other' | 'unset'
  /** Whether the connector is a socket (EV user brings a cable) or an attached cable. Omit to leave unchanged; send `unset` to clear it. */
  connectorFormat?: 'SOCKET' | 'CABLE' | 'unset'
  /** Electrical power delivery type for this connector (AC phase arrangement or DC). Omit to leave unchanged; send `unset` to clear it. */
  connectorPowerType?: 'AC_1_PHASE' | 'AC_2_PHASE' | 'AC_2_PHASE_SPLIT' | 'AC_3_PHASE' | 'DC' | 'unset'
  /** The optional name of the connector. Omit to leave unchanged; send an empty string to clear it. */
  connectorName?: string
  /** The eMobility EVSE ID (eMI3/IDACS format) for this connector. Omit to leave unchanged; send an empty string to clear it. */
  emobilityEvseId?: string
  /** The maximum power this connector can deliver, in kW. Omit to leave unchanged; send 0 to clear it. This is per-connector, distinct from the charger-level maxPower. */
  maxPower?: number
  /** The voltage of this connector, in volts. Omit to leave unchanged; send 0 to clear it. This is per-connector, distinct from the charger-level voltage. */
  voltage?: number
  /** The amperage of this connector, in amps. Omit to leave unchanged; send 0 to clear it. */
  amperage?: number
}
export type ChargerUpdateModel = {
  chargerId: string
  depotId?: string
  externalId?: string
  chargerName?: string
  /** Free Vend Mode. When true, every tag presented at this charger is accepted, without consulting OCPP tags, location rules or OCPI, and nothing is recorded about the tag. */
  freeVendMode?: boolean
  /** [DEPRECATED] use freeVendMode. An alias for freeVendMode, kept for existing clients. A request may send it instead of freeVendMode; sending both with different values is rejected. */
  autoRegisterTags?: boolean
  description?: string
  latitude?: number
  longitude?: number
  maxPower?: number
  maxCurrent?: number
  voltage?: number
  currentType?: string
  year?: number
  v2gEnabled?: boolean
  makeModelId?: string
  /** [DEPRECATED] The date the charger was commissioned. This field is deprecated and will be removed after 12/01/2024. To set the commissioning date, create a commissioning event located in POST /api/service-events. */
  commissioningDate?: string
  networkConnectionDetails?: string
  utilityLocationId?: string
  isAdaAccessible?: 'Yes' | 'No' | 'unset'
  evseInstallationType?: 'Pedestal' | 'WallMounted' | 'Other' | 'unset'
  networkConnectionMethod?: 'SIM' | 'WiFi' | 'LAN' | 'unset'
  connectors?: {
    [key: string]: ConnectorUpdateModel
  }
  /** The number of phases the charger prefers when receiving a charging profile (1 or 3). */
  preferredProfileNumPhases?: number
  /** The energy efficiency value for this charger (between 0 and 1). If not provided, the existing efficiency record will remain unchanged. */
  efficiency?: number
  /** When true, transaction IDs are always inferred for this charger. Set this for chargers connected via an external primary CMS proxy, where the proxy may re-assign OCPP IDs mid-session independently of Synop. */
  alwaysInferTxIds?: boolean
  /** Power of ten applied to this charger's MeterValues energy readings before they are stored: stored = reported × 10^energyRegisterMultiplier, the same exponent as OCPP 2.0.1's unitOfMeasure.multiplier. -3 to 3; 0 means as reported. Set this for a charger whose energy register is out of scale with the unit it reports, for example a 0.01 Wh register labelled Wh, which takes -2. Applies to readings ingested from when it is set and never to stored ones; the energy rescale backfill corrects those. Set it once the charger has sent no meter values for at least 5 minutes: ingest's energy outlier check compares each reading with the previous one, and would drop the first corrected readings as a jump from the last uncorrected one. */
  energyRegisterMultiplier?: number
}
export type ChargerCreationModel = {
  chargerId: string
  depotId: string
  externalId?: string
  chargerName?: string
  /** Free Vend Mode. When true, every tag presented at this charger is accepted, without consulting OCPP tags, location rules or OCPI, and nothing is recorded about the tag. */
  freeVendMode?: boolean
  /** [DEPRECATED] use freeVendMode. An alias for freeVendMode, kept for existing clients. A request may send it instead of freeVendMode; sending both with different values is rejected. */
  autoRegisterTags?: boolean
  description?: string
  latitude: number
  longitude: number
  maxPower?: number
  maxCurrent?: number
  voltage?: number
  currentType: string
  year?: number
  v2gEnabled?: boolean
  makeModelId?: string
  /** [DEPRECATED] The date the charger was commissioned. This field is deprecated and will be removed after 12/01/2024. To set the commissioning date, create a commissioning event located in POST /api/service-events. */
  commissioningDate?: string
  /** The network connection method of a charger. */
  networkConnectionMethod?: 'SIM' | 'WiFi' | 'LAN'
  /** A field for details about the network connection method of a charger. */
  networkConnectionDetails?: string
  /** The location of the charger according to the utility. */
  utilityLocationId?: string
  /** Whether or not the charger is ADA accessible. */
  isAdaAccessible?: boolean
  /** The type of installation of the charger. */
  evseInstallationType?: 'Pedestal' | 'WallMounted' | 'Other'
  /** The number of phases the charger prefers when receiving a charging profile (1 or 3). */
  preferredProfileNumPhases?: number
  /** Indicator for whether the charger is a simulator or not. */
  isSimulator?: boolean
  /** The energy efficiency value for this charger (between 0 and 1). If not provided, no efficiency record will be created. */
  efficiency?: number
}
export type TransactionAuthTagBackfillResponse = {
  /** Unique identifier for this backfill job. */
  backfillId?: string
  /** Current job status. */
  status?: 'PENDING' | 'QUEUED' | 'RUNNING' | 'SUCCEEDED' | 'FAILED' | 'PARTIAL_FAILED'
  /** Charger the backfill was requested for. */
  chargerId?: string
  /** Organization the charger belongs to. */
  orgId?: string
  /** Start of the transaction window. */
  fromTime?: string
  /** End of the transaction window. */
  toTime?: string
  /** Total unmapped/NONE-mapped transactions found. */
  totalCount?: number
  /** Transactions successfully mapped. */
  updatedCount?: number
  /** Transactions skipped (no change). */
  skippedCount?: number
  /** Transactions that failed to map. */
  failedCount?: number
  /** Error detail, populated on failure. */
  errorMessage?: string
  /** When the backfill was created. */
  createdAt?: string
  /** When the backfill was last updated. */
  updatedAt?: string
}
export type PagedResponseV0TransactionAuthTagBackfillResponse = {
  first?: boolean
  last?: boolean
  pageSize?: number
  page?: number
  totalPages?: number
  totalItems?: number
  items?: TransactionAuthTagBackfillResponse[]
}
export type StartTransactionAuthTagBackfillRequest = {
  /** Charger to backfill auth tag mappings for. */
  chargerId: string
  /** Start of the transaction window (inclusive). Must be before toTime. */
  fromTime: string
  /** End of the transaction window (inclusive). Must be within 365 days of fromTime. */
  toTime: string
}
export type OcppAuthorizationRuleResponse = {
  ocppTagAuthorizationRulePk?: number
  idTag?: string
  /** ALLOW or DENY */
  mode?: 'ALLOW' | 'DENY'
  /** CHARGER, SITE, ORG, or GLOBAL */
  entityType?: 'CHARGER' | 'SITE' | 'ORG' | 'GLOBAL'
  entityId?: string
  created?: string
  updated?: string
}
export type PagedResponseV0OcppAuthorizationRuleResponse = {
  first?: boolean
  last?: boolean
  pageSize?: number
  page?: number
  totalPages?: number
  totalItems?: number
  items?: OcppAuthorizationRuleResponse[]
}
export type OcppAuthorizationRuleCreateRequest = {
  /** OCPP id tag this rule applies to */
  idTag: string
  /** ALLOW or DENY */
  mode: 'ALLOW' | 'DENY'
  /** CHARGER, SITE, ORG, or GLOBAL */
  entityType: 'CHARGER' | 'SITE' | 'ORG' | 'GLOBAL'
  /** charge_box_id, depot_id, fleet_id, or * for GLOBAL */
  entityId: string
}
export type SkippedChargerModel = {
  /** The ID of the skipped charger */
  chargerId?: string
  /** Why the charger was skipped */
  reason?: string
}
export type DestinationAssignChargersResponseModel = {
  /** IDs of the chargers whose destination assignment was changed */
  movedChargerIds?: string[]
  /** Chargers that were not moved, each with the reason it was skipped */
  skipped?: SkippedChargerModel[]
}
export type DestinationAssignChargersRequestModel = {
  /** Explicit IDs of the chargers to assign. Mutually exclusive with fromDestinationId. */
  chargerIds?: string[]
  /** Moves every live charger currently assigned to this destination. Mutually exclusive with chargerIds. */
  fromDestinationId?: string
}
export type GetCompositeScheduleSubmitResponse = {
  requestId?: string
  requestTime?: string
}
export type GetCompositeScheduleRequest = {
  duration: string
  chargingRateUnit?: 'A' | 'W'
  connectorId: number
}
export type BasicAuthPasswordUpdateResponse = {
  processing?: boolean
}
export type BydChargerMappingResponse = {
  id?: string
  chargerId?: string
  connectorId?: number
  macAddress?: string
  transitProperty?: string
  chargerType?: string
  siteId?: string
  created?: string
  updated?: string
}
export type BydChargerMappingCreateRequest = {
  /** Synop charger ID to associate with the BYD gateway */
  chargerId: string
  /** Connector number (typically 1) */
  connectorId: number
  /** IOC gateway MAC address, colon-free uppercase hex (e.g. E4B318F341AE) */
  macAddress: string
  /** MQTT topic prefix (e.g. synop) */
  transitProperty: string
  /** BYD charger model (e.g. AC80, AC200) */
  chargerType: string
  /** Site the charger belongs to */
  siteId: string
}
export type SiteLifecycleStateModel = {
  /** The requested site id. */
  siteId?: string
  /** DELETED if the site has been soft-deleted, ACTIVE if it exists and has not, NOT_FOUND if no site has this id. */
  state?: 'ACTIVE' | 'DELETED' | 'NOT_FOUND'
  /** When the site row was last written, in UTC; null for NOT_FOUND. For a deleted site this is normally the deletion, unless the row was written again afterwards. */
  updatedAt?: string
}
export type SiteLifecycleStatesResponse = {
  /** Exactly one entry per distinct, non-blank requested id, in request order. An id with no site is answered NOT_FOUND, never left out. */
  sites?: SiteLifecycleStateModel[]
}
export type SiteLifecycleStatesRequest = {
  /** Site ids to look up, at most 500. Blank and repeated ids are ignored. */
  siteIds: string[]
}
export type AdminUploadDiagnosticsResponseModel = {
  chargerId?: string
  requestId?: string
  /** The status of diagnostics request. */
  status?:
    | 'Idle'
    | 'IssuingRequest'
    | 'RequestAccepted'
    | 'RequestRejected'
    | 'FtpUploading'
    | 'FtpUploadFailed'
    | 'FtpUploaded'
    | 'S3Uploading'
    | 'S3Uploaded'
    | 'S3UploadFailed'
    | 'Cancelled'
  timestamp?: string
}
export type AdminUploadDiagnosticsRequestModel = {
  location: string
  from: string
  to: string
}
export type ChargerLifecycleStateModel = {
  /** The requested charge box id. */
  chargeBoxId?: string
  /** DELETED if the charger has been soft-deleted, ACTIVE if it exists and has not, NOT_FOUND if no charger has this id. */
  state?: 'ACTIVE' | 'DELETED' | 'NOT_FOUND'
  /** When the charger row was last written, in UTC; null for NOT_FOUND. For a deleted charger this is normally the deletion, unless the row was written again afterwards. */
  updatedAt?: string
}
export type ChargerLifecycleStatesResponse = {
  /** Exactly one entry per distinct, non-blank requested id, in request order. An id with no charger is answered NOT_FOUND, never left out. */
  chargers?: ChargerLifecycleStateModel[]
}
export type ChargerLifecycleStatesRequest = {
  /** Charge box ids to look up, at most 500. Blank and repeated ids are ignored. */
  chargeBoxIds: string[]
}
export type PagedResponseV0ServiceEventModel = {
  first?: boolean
  last?: boolean
  pageSize?: number
  page?: number
  totalPages?: number
  totalItems?: number
  items?: ServiceEventModel[]
}
export type CreateServiceEventModel = {
  /** The ID of the charger that the service event is associated with. */
  chargerId: string
  /** The date and time that the service event is effective from. */
  effectiveAsOf: string
  /** The type of service event. */
  eventType: 'COMMISSIONING' | 'OUTAGE' | 'SITE_MOVE' | 'ORG_MOVE' | 'NODE_MOVE' | 'COMMS_MOVE'
  /** The service state. Pre-commissioning is not allowed. */
  commissioningState?: 'COMMISSIONED' | 'DECOMMISSIONED'
  /** A note or description of the service event. */
  note?: string
}
export type BulkCommissionActionResponseModel = {
  /** The IDs of the chargers that were successfully commissioned/decommissioned. */
  succeeded: string[]
  /** The IDs of the chargers that could not be commissioned/decommissioned */
  failed: string[]
  /** The commissioning state of the chargers. */
  commissioningState: 'COMMISSIONED' | 'DECOMMISSIONED'
}
export type BulkCommissionActionRequestModel = {
  /** The IDs of the chargers to commission. */
  chargerIds: string[]
  /** The date and time that the commissioning is effective from. */
  effectiveAsOf: string
  /** A note or description of the service event. */
  note?: string
  /** The service state of the chargers. */
  commissioningState: 'COMMISSIONED' | 'DECOMMISSIONED'
}
export type SetProfileResponseModel = {
  result?: boolean
  status?: 'Applied' | 'Pending' | 'Rejected' | 'NotSupported' | 'Unknown' | 'Timeout' | 'NotConnected' | 'Invalid'
}
export type TagResponseModel = {
  /** An authorization tag that can consists of RFID values, Vehicle MAC addresses, or OEM provided IDs to allow transactions to occurs on the Synop platform
    This value must be 20 characters or less. */
  idTag: string
  /** An identifier of a organization of which the ID tag belongs to. */
  organizationId: string
}
export type PagedResponseV0TagResponseModel = {
  first?: boolean
  last?: boolean
  pageSize?: number
  page?: number
  totalPages?: number
  totalItems?: number
  items?: TagResponseModel[]
}
export type AddTagsInputModel = {
  /** A list of objects containing  OCPP ID tags with their corresponding organization Ids */
  idTags: TagResponseModel[]
}
export type OcppTagModel = {
  /** OCPP ID Tag identifier */
  idTag: string
  /** Organization ID associated with this tag */
  organizationId?: string
  /** Maximum number of active transactions allowed for this tag (0 means blocked) */
  maxActiveTransactionCount?: number
}
export type OcppTagCollectionModel = {
  /** List of OCPP ID Tags */
  ocppTags: OcppTagModel[]
}
export type TagCollectionInputModel = {
  /** List of OCPP ID Tags to block */
  idTags: string[]
}
export type RefreshConfigurationStatusModel = {
  /** The unique identifier of the refresh configuration request. */
  id: string
  /** The unique identifier of the charger that the refresh configuration request was sent to. */
  chargerId: string
  /** The status of the refresh configuration request. */
  status: 'PROCESSING' | 'COMPLETED' | 'ERROR'
  /** The reason for the error if the status is not COMPLETED. */
  errorReason?: string
  /** The date and time that the refresh configuration request was sent. */
  requestedAt: string
}
export type ChangeConfigurationApiResponseModel = {
  /** The configuration key that was submitted to the charger to be changed. */
  key: string
  /** The value corresponding to the value that was submitted to the charger to be changed. */
  value: string
  /** The response status of the charger for the configuration change. */
  chargerResponseStatus:
    | 'Accepted'
    | 'Rejected'
    | 'NotSupported'
    | 'RebootRequired'
    | 'Unknown'
    | 'UnknownMessageId'
    | 'UnknownVendorId'
    | 'Idle'
    | 'Uploaded'
    | 'UploadFailed'
    | 'Uploading'
    | 'Downloaded'
    | 'DownloadFailed'
    | 'Downloading'
    | 'InstallationFailed'
    | 'Installing'
    | 'Installed'
    | 'Pending'
    | 'Occupied'
    | 'Faulted'
    | 'Unavailable'
    | 'NotImplemented'
    | 'Expired'
    | 'Invalid'
    | 'ConcurrentTx'
    | 'Blocked'
    | 'Scheduled'
    | 'Unlocked'
    | 'UnlockFailed'
    | 'NoResponse'
    | 'NotConnected'
    | 'OK'
  /** The response message from the charger corresponding to the responseStatus. */
  responseMessage: string
  refreshConfigurationStatus?: RefreshConfigurationStatusModel
}
export type ChangeConfigurationKeyRequestModel = {
  /** A configuration key to update. */
  key: string
  /** The value of the key to update on the charger */
  value: string
}
export type RefreshChargerConfigurationParams = {
  chargerId: string
}
export type ChargingNodeResponseModel = {
  id: string
  name: string
  siteId: string
  destinationId: string
  isDefaultGroup?: boolean
}
export type PagedResponseV0ChargingNodeResponseModel = {
  first?: boolean
  last?: boolean
  pageSize?: number
  page?: number
  totalPages?: number
  totalItems?: number
  items?: ChargingNodeResponseModel[]
}
export type ChargingNodeMoveChargersResponseModel = {
  succeeded?: string[]
  failed?: {
    [key: string]: string
  }
}
export type ModifyChargingNodeSetChargersResult = {
  added?: ChargingNodeMoveChargersResponseModel
  removed?: ChargingNodeMoveChargersResponseModel
  chargeBoxIds?: string[]
}
export type ModifyChargingNodeResponseModel = {
  id: string
  name: string
  siteId: string
  destinationId: string
  isDefaultGroup?: boolean
  setChargersResult?: ModifyChargingNodeSetChargersResult
}
export type ChargingNodeCreateModel = {
  /** The name of the charging group. */
  name: string
  /** The site ID the charging group belongs to. */
  siteId: string
  /** The IoT destination ID the charging group belongs to. Reach out to Synop to create groups with a destination ID other than Synop's default */
  destinationId?: string
  /** Set the chargers on the charging group. If null or missing, no chargers will be moved to this group. */
  chargerIds?: string[]
  /** Set this node as the default node for its site. Defaults to false. If true, the current default node for the site will be changed to non-default. */
  isDefaultGroup?: boolean
}
export type ChargingNodeMoveChargersRequestModel = {
  /** The IDs of the chargers to move to this group */
  chargerIds: string[]
}
export type UpdateFirmwareResponseModel = {
  /** The status of the firmware request. */
  status: 'Accepted' | 'Failed' | 'NoResponse'
  /** Additional information about the firmware status */
  statusMessage?: string
}
export type UpdateFirmwareRequest = {
  /** The location of the firmware, should be an ftp uri */
  firmwareLocation: string
  /** The path of the file on the ftp server. */
  retrieveDate: string
}
export type TransactionStartResponseModel = {
  id?: string
  transactionPk?: number
  communicationResult?:
    | 'Applied'
    | 'Pending'
    | 'Rejected'
    | 'NotSupported'
    | 'Unknown'
    | 'Timeout'
    | 'NotConnected'
    | 'Invalid'
}
export type ChargingTransactionRequest = {
  connectorId?: number
  tagId: string
}
export type SetUserPriceRequestInputModel = {
  idToken: string
  priceText: string
}
export type ChargingPriceModel = {
  hourPrice?: number
  flatFee?: number
  kwhPrice?: number
}
export type IdlePriceModel = {
  graceMinutes?: number
  hourPrice?: number
}
export type NextPeriodModel = {
  atTime: string
  chargingPrice: ChargingPriceModel
  idlePrice?: IdlePriceModel
}
export type TriggerMeterValueModel = {
  atTime?: string
  atEnergykWh?: number
  atPowerkW?: number
  atCPStatus?: string
}
export type SendRunningCostRequestInputModel = {
  synopTransactionId: string
  timestamp: string
  meterValue: number
  cost: number
  state: 'Charging' | 'Idle'
  chargingPrice: ChargingPriceModel
  idlePrice?: IdlePriceModel
  nextPeriod?: NextPeriodModel
  triggerMeterValue?: TriggerMeterValueModel
}
export type SendFinalCostRequestInputModel = {
  synopTransactionId: string
  cost: number
  priceText: string
  qrCodeText?: string
}
export type ReserveNowResponseModel = {
  reservationId?: string
  chargerId?: string
  ocppStatus?: string
  connectorId?: number
  authTag?: string
}
export type ReserveNowRequest = {
  connectorId?: number
  authTag: string
  expiry: string
  eventId?: string
}
export type ModifyWebsocketConnectionRequest = {
  connectionModifier: 'SEVER' | 'ALLOW'
}
export type JsonNode = object
export type StatusInfo = {
  reasonCode: string
  additionalInfo?: string
}
export type DataTransferResultModel = {
  status: 'ACCEPTED' | 'REJECTED' | 'UNKNOWN_MESSAGE_ID' | 'UNKNOWN_VENDOR_ID'
  data?: JsonNode
  statusInfo?: StatusInfo
}
export type DataTransferRequestModel = {
  vendorId: string
  messageId?: string
  data?: JsonNode
}
export type CancelReservationResponseModel = {
  reservationId?: string
  chargerId?: string
  ocppStatus?: string
}
export type CancelReservationRequest = {
  reservationId?: string
  ocppReservationId?: number
  connectorId?: number
  eventId?: string
}
export type UnlockConnectorResponseModel = {
  status: 'UNLOCKED' | 'UNLOCK_FAILED' | 'NOT_SUPPORTED' | 'ONGOING_AUTHORIZED_TRANSACTION' | 'UNKNOWN_CONNECTOR'
}
export type UnlockConnectorRequest = {
  chargerId: string
  connectorId: number
}
export type TriggerMessageResponse = {
  status: 'ACCEPTED' | 'REJECTED' | 'NOT_IMPLEMENTED'
}
export type TriggerConnectorMessageRequest = {
  chargerId: string
  connectorId: number
  messageType: 'TRANSACTION_EVENT' | 'METER_VALUES' | 'STATUS_NOTIFICATION'
}
export type TriggerChargerMessageRequest = {
  chargerId: string
  messageType:
    | 'BOOT_NOTIFICATION'
    | 'HEARTBEAT'
    | 'DIAGNOSTIC_STATUS_NOTIFICATION'
    | 'FIRMWARE_STATUS_NOTIFICATION'
    | 'STATUS_NOTIFICATION'
    | 'SIGN_CHARGING_STATION_CERTIFICATE'
    | 'SIGN_V_2_G_CERTIFICATE'
    | 'SIGN_COMBINED_CERTIFICATE'
    | 'PUBLISH_FIRMWARE_STATUS_NOTIFICATION'
    | 'LOG_STATUS_NOTIFICATION'
}
export type OcppDestinationResponseModel = {
  /** The unique identifier of an OCPP Destination. */
  id: string
  /** The name of the OCPP Destination. */
  name?: string
  /** The IoT Destination Id of the OCPP Destination. */
  destinationId: string
  /** The type of the OCPP Destination. */
  destinationType?: 'STEVE' | 'CLOUD_GATEWAY' | 'LINK_DEVICE'
  /** The site ID where this destination is located. */
  siteId?: string
}
export type PagedResponseV0OcppDestinationResponseModel = {
  first?: boolean
  last?: boolean
  pageSize?: number
  page?: number
  totalPages?: number
  totalItems?: number
  items?: OcppDestinationResponseModel[]
}
export type CreateOcppDestinationModel = {
  /** The name of the OCPP Destination. */
  name?: string
  /** The IoT Destination Id of the OCPP Destination. */
  destinationId: string
  /** The type of the OCPP Destination. */
  destinationType: 'STEVE' | 'CLOUD_GATEWAY' | 'LINK_DEVICE'
  /** The site ID where this destination is located. Required for Link destinations. */
  siteId?: string
}
export type ChangeAvailabilityResponseModel = {
  status: 'ACCEPTED' | 'REJECTED' | 'SCHEDULED'
}
export type ChangeAvailabilityRequest = {
  chargerId: string
  connectorId?: number
  type: 'INOPERATIVE' | 'OPERATIVE'
}
export type ChargerDiagnosticsResponseModel = {
  /** The ID of the charger that the diagnostics request was made for. */
  chargerId: string
  /** The Unique ID of the diagnostics request. */
  id: string
  /** The status of diagnostics request. */
  status:
    | 'Idle'
    | 'IssuingRequest'
    | 'RequestAccepted'
    | 'RequestRejected'
    | 'FtpUploading'
    | 'FtpUploadFailed'
    | 'FtpUploaded'
    | 'S3Uploading'
    | 'S3Uploaded'
    | 'S3UploadFailed'
    | 'Cancelled'
  /** The timestamp the diagnostics request was initially made. */
  requestTimestamp: string
  /** The timestamp of the last status update. */
  lastUpdatedStatusTimestamp: string
  /** The start of the timespan that the diagnostics file covers. */
  requestedFrom?: string
  /** The end of the timespan that the diagnostics file covers. */
  requestedTo?: string
  /** The URL to download the diagnostics file, the url will be provided as a pre-signed link pointing to the file in an amazon s3 bucket. */
  downloadUrl?: string
  /** The ID of the user that created or last updated the diagnostics request. */
  userId?: string
  /** The ID of the organization that created or last updated the diagnostics reqeust */
  organizationId: string
}
export type PagedResponseV0ChargerDiagnosticsResponseModel = {
  first?: boolean
  last?: boolean
  pageSize?: number
  page?: number
  totalPages?: number
  totalItems?: number
  items?: ChargerDiagnosticsResponseModel[]
}
export type ChargerDiagnosticsRequestModel = {
  /** ID of the charger to request diagnostics from */
  chargerId: string
  /** The date and time from which to request diagnostics from. The provided date must be in the past. */
  from: string
  /** The date and time from which to request diagnostics to. The provided date must be in the past. */
  to: string
  /** An override flag to use FTPS (File Transfer Protocol Secure) instead of FTP. If set to true, this will use ftps:// instead of ftp:// for more secure file transfer. */
  useFTPS?: boolean
}
export type UpdateTransactionOcppTagResponse = {
  /** External transaction id. */
  transactionId?: string
  /** Charger that ran the transaction. */
  chargerId?: string
  /** OCPP tag before the override. */
  previousOcppTag?: string
  /** OCPP tag after the override. */
  newOcppTag?: string
}
export type UpdateTransactionOcppTagRequest = {
  /** Replacement OCPP auth tag for the transaction. */
  ocppTag: string
  /** Optional reason recorded on the long-lived audit row. */
  reason?: string
}
export type OcppAuthorizationRuleUpdateRequest = {
  /** ALLOW or DENY */
  mode: 'ALLOW' | 'DENY'
}
export type BydChargerMappingUpdateRequest = {
  /** Connector number (typically 1) */
  connectorId?: number
  /** IOC gateway MAC address, colon-free uppercase hex (e.g. E4B318F341AE) */
  macAddress?: string
  /** MQTT topic prefix (e.g. synop) */
  transitProperty?: string
  /** BYD charger model (e.g. AC80, AC200) */
  chargerType?: string
  /** Site the charger belongs to */
  siteId?: string
}
export type ChargingNodeDeleteResponseModel = {
  id: string
  name: string
  siteId: string
  destinationId: string
  isDefaultGroup?: boolean
  movedChargers?: ChargingNodeMoveChargersResponseModel
}
export type ChargingNodeUpdateModel = {
  /** The name of the charging node. */
  name?: string
  /** The IoT destination ID the charging node belongs to. Reach out to Synop to update nodes with a destination ID other than Synop's default */
  destinationId?: string
  /** Set the chargers on the charging node. If null or missing, no chargers will be moved to or from this node. If sent to the empty list, all chargers will be removed from the node. */
  chargerIds?: string[]
  /** Set this node as the default node for its site. Only the value true is accepted. If missing, no change is made to the default status. */
  isDefaultGroup?: boolean
}
export type UpdateOcppDestinationModel = {
  /** The name of the OCPP Destination. */
  name?: string
  /** The IoT Destination Id of the OCPP Destination. If provided, a destinationId cannot be null. */
  destinationId?: string
  /** The type of the OCPP Destination. */
  destinationType?: string
  /** The site ID where this destination is located. Required for Link destinations. */
  siteId?: string
}
export type TransactionOcppTagOverrideModel = {
  time?: string
  chargerId?: string
  id?: string
  transactionPk?: number
  transactionId?: string
  orgId?: string
  previousOcppTag?: string
  newOcppTag?: string
  previousAuthTagType?: string
  actorId?: string
  actorType?: 'USER' | 'API_KEY' | 'SYSTEM'
  actorSource?: string
  actorOrgId?: string
  reason?: string
}
export type PagedResponseV0TransactionOcppTagOverrideModel = {
  first?: boolean
  last?: boolean
  pageSize?: number
  page?: number
  totalPages?: number
  totalItems?: number
  items?: TransactionOcppTagOverrideModel[]
}
export type PaginationMetadata = {
  first: boolean
  last: boolean
  pageSize: number
  page: number
  totalPages: number
  totalItems: number
}
export type Meta = {
  pagination: PaginationMetadata
}
export type SiteModel = {
  siteId?: string
  organizationId?: string
  name?: string
  externalId?: string
  address?: string
  latitude?: number
  longitude?: number
  timezone?: string
  geofence?: string
  created?: string
  updated?: string
}
export type PagedResponseV2SiteModel = {
  meta: Meta
  data: SiteModel[]
}
export type OcppConfigurationParameterModel = {
  /** The key of the OCPP configuration key parameter */
  key: string
  /** The value of the OCPP configuration key parameter */
  value: string
  /** A flag indicating whether the configuration key is modifiable */
  readOnly: boolean
}
export type OcppConfigurationResponseModel = {
  /** The ID of the charger that the configuration values are being returned for. */
  chargerId: string
  /** A collection of the OCPP standard configuration keys and their values. */
  configurationKeys: OcppConfigurationParameterModel[]
  /** A collection of custom, OEM-defined configuration keys and their values. */
  customKeys: OcppConfigurationParameterModel[]
  /** A collection of unknown keys that the requested charger returned no value for. The unknown fields are provided as a comma-separated string. */
  unknownKeys: string
  /** The date and time that the configuration values were retrieved. */
  asOf: string
}
export type PagedResponseV0OcppConfigurationResponseModel = {
  first?: boolean
  last?: boolean
  pageSize?: number
  page?: number
  totalPages?: number
  totalItems?: number
  items?: OcppConfigurationResponseModel[]
}
export type ConfigurationChangeModel = {
  /** Configuration key or variable name. */
  key?: string
  /** Submitted value; "[REDACTED]" for sensitive keys. */
  value?: string
  /** Component name for component-scoped variables. */
  component?: string | null
}
export type ConfigurationChangeErrorModel = {
  /** Error type, for example CHARGER or CALL_ERROR. */
  type?: string
  /** Error code reported by the charger. */
  code?: string
  /** Error description. */
  description?: string
}
export type GatewayActorModel = {
  /** Actor id. */
  id?: string
  /** Actor type, for example USER, API_KEY or SYSTEM. */
  type?: string | null
  /** Where the request came from, for example WEB or API_KEY. */
  source?: string | null
  /** Organization the actor belongs to. */
  organizationId?: string | null
} | null
export type ConfigurationChangeRecordModel = {
  /** Gateway request id for this configuration change. */
  id?: string
  /** Charger entity id. */
  chargerId?: string
  /** Connector scope for the change; "0" means whole charger. */
  dispenserId?: string
  /** When the configuration change was submitted (UTC). */
  requestTime?: string
  /** When the charger reported a result (UTC); omitted until a result arrives. */
  resultTime?: string | null
  /** Configuration properties submitted; sensitive values are redacted. */
  changes?: ConfigurationChangeModel[]
  /** Outcome of the change, derived from the charger result. */
  status?:
    | 'PENDING'
    | 'ACCEPTED'
    | 'FAILED'
    | 'REJECTED'
    | 'TIMEOUT'
    | 'NOT_CONNECTED'
    | 'NOT_SUPPORTED'
    | 'INVALID'
    | 'CONFLICT'
  /** Human-readable description of the status. */
  statusDescription?: string
  /** Errors reported by the charger; omitted when there are none. */
  errors?: ConfigurationChangeErrorModel[]
  /** Origin of the request when known. */
  origin?: string | null
  actor?: GatewayActorModel
}
export type PagedResponseV0ConfigurationChangeRecordModel = {
  first?: boolean
  last?: boolean
  pageSize?: number
  page?: number
  totalPages?: number
  totalItems?: number
  items?: ConfigurationChangeRecordModel[]
}
export type BasicAuthEventModel = {
  time?: string
  chargerId?: string
  eventType?: string
  actor?: string
  actorType?: 'USER' | 'API_KEY' | 'SYSTEM'
  orgId?: string
}
export type PagedResponseV0BasicAuthEventModel = {
  first?: boolean
  last?: boolean
  pageSize?: number
  page?: number
  totalPages?: number
  totalItems?: number
  items?: BasicAuthEventModel[]
}
export type BasicAuthConfigResponse = {
  basicAuthRequired?: boolean
  basicAuthConfigured?: boolean
}
export type ChargerConnectionEventModel = {
  /** The ID of the charger. */
  chargerId?: string
  /** The node ID the charger belongs to. */
  nodeId?: string
  /** The site ID the charger belongs to. */
  siteId?: string
  /** The organization ID the charger belongs to. */
  organizationId?: string
  /** The connection status (CONNECTED or DISCONNECTED). */
  status?: string
  /** The timestamp when this event occurred. */
  time?: string
  /** The time when the charger connected. */
  connectTime?: string
  /** The time when the charger disconnected. */
  disconnectTime?: string
  /** The outage duration in seconds, if applicable. */
  outageDurationSeconds?: number
  /** Human-readable outage duration, if applicable. */
  outageDurationFormatted?: string
  /** The timestamp when this record was created. */
  createdAt?: string
}
export type PagedResponseV0ChargerConnectionEventModel = {
  first?: boolean
  last?: boolean
  pageSize?: number
  page?: number
  totalPages?: number
  totalItems?: number
  items?: ChargerConnectionEventModel[]
}
export type BydRawEventItem = {
  macAddress?: string
  location?: string
  time?: string
  direction?: string
  topic?: string
  event?: {
    [key: string]: object
  }
  statusText?: string
  errorDescription?: string
  payloadText?: string
}
export type PagedResponseV0BydRawEventItem = {
  first?: boolean
  last?: boolean
  pageSize?: number
  page?: number
  totalPages?: number
  totalItems?: number
  items?: BydRawEventItem[]
}
export type FleetMessageActivityChargerModel = {
  chargerId?: string
  organizationId?: string
  siteId?: string
  /** The gateway node that carried most of this charger's traffic in the window. A charger that reconnects can occupy more than one, and everything else on this row covers all of them. */
  nodeId?: string
  /** Messages this charger sent across the whole window. */
  totalMessages?: number
  /** Bytes this charger sent across the whole window. */
  totalBytes?: number
  /** Hours the charger has a stored row in. The denominator of both averages, so a charger that spoke in four hours of a day is averaged over four rather than twenty-four. */
  activeHours?: number
  /** totalMessages over activeHours. */
  averageMessagesPerHour?: number
  /** totalBytes over activeHours. */
  averageBytesPerHour?: number
  /** This charger's totalMessages as a fraction of the window's, between 0 and 1. The denominator is every charger in scope rather than only those above the threshold, so dragging the threshold does not move the share. */
  shareOfFleetMessages?: number
}
export type FleetMessageActivityResponse = {
  /** Start of the served window, inclusive, snapped down to the hour. */
  from?: string
  /** End of the served window, exclusive, snapped up to the hour. */
  to?: string
  /** First hour the record holds inside the window. Later than from when the window reaches back past the record's beginning or past its ninety-day retention. Null when the record holds none of the window. Answers to the window alone and to none of the filters, so a quiet organization narrows the numbers on this card without narrowing the period they were measured over. */
  coveredFrom?: string
  /** End of the last hour the record holds inside the window, exclusive. Earlier than to when the record has not been written that far forward. Null when the record holds none of the window, and unaffected by the filters for the reason given on coveredFrom. */
  coveredTo?: string
  /** Messages a charger had to send inside one hour to count as active. Reported so that "active" reads as a definition rather than a fact. */
  minMessages?: number
  /** Messages across every charger in scope, above the threshold or not, so this and the share on each row do not move when the threshold does. */
  totalMessages?: number
  /** Bytes across every charger in scope, above the threshold or not. */
  totalBytes?: number
  /** Chargers that cleared minMessages in at least one hour of the window, counted before any limit, so this is also how many rows the table has to page through. */
  activeChargers?: number
  /** The chattiest of those chargers, highest average messages per hour first. */
  chargers?: FleetMessageActivityChargerModel[]
}
export type FleetOnlineBucketModel = {
  /** Start of the bucket, inclusive. */
  bucket?: string
  /** Chargers in scope that the connectivity record holds any sample for in this bucket. Not the size of the operated fleet: a charger the connectivity job has never written, because nothing has ever been heard from it, is absent rather than counted as offline. Null where the record holds no data for the bucket. */
  chargersSeen?: number
  /** Chargers online at the end of this bucket, from each charger's last sample in it. With chargersOffline this partitions chargersSeen, so the two can be read as a pair. A snapshot rather than a summary: over a daily bucket it describes how things stood at the end of the day, and onlineFraction is the better number at that grain. */
  chargersOnline?: number
  /** Chargers offline at the end of this bucket. chargersOnline plus chargersOffline equals chargersSeen. */
  chargersOffline?: number
  /** Fraction of the bucket the scoped fleet spent online, weighted by sample. A charger up for half the bucket contributes half. */
  onlineFraction?: number
  /** Average number of chargers online across the bucket, which is onlineFraction times chargersSeen. Fractional on purpose: it is an average over the bucket rather than a reading at an instant. */
  averageChargersOnline?: number
  /** Chargers in scope that were online at no point in this bucket. */
  chargersNeverOnline?: number
  /** Chargers in scope that were online at every sample in this bucket. */
  chargersOnlineThroughout?: number
}
export type FleetOnlineResponse = {
  /** Start of the requested window, snapped down to a bucket boundary. */
  from?: string
  /** End of the window, exclusive. */
  to?: string
  /** Rollup interval the buckets are on. */
  interval?: string
  /** Start of the span actually measured, which is the first bucket the record covers. Null when the record covers none of the window. Reported separately from `from` because the record begins at its migration and fills forward, so a request reaching before that is answered over less than it asked for. */
  coveredFrom?: string
  /** End of the span actually measured, exclusive. Null when nothing is covered. */
  coveredTo?: string
  /** Every bucket from the first the record covers to the last, interior gaps filled with a zero-charger reading. Narrower than the window when the record does not cover all of it, and empty when it covers none of it, because an absent bucket means the record has nothing to say rather than that the fleet was down. */
  buckets?: FleetOnlineBucketModel[]
}
export type AttentionReasonModel = {
  /** Stable reason code, for example vendor_fault. */
  code?: string
  /** The metric this reason reads. */
  metric?: string
  /** What was counted over the requested window. */
  observed?: number
  /** What it had to reach to count as a reason, scaled to the requested window. Reported so the reader can see how far past the line a charger is, rather than only that it crossed one. */
  threshold?: number
}
export type ChargerAttentionModel = {
  chargerId?: string
  siteId?: string
  organizationId?: string
  /** From charge_box, for the vendor escalation conversation. */
  vendor?: string
  model?: string
  /** From charge_box, because a fleet-wide fault is usually one firmware build rather than one charger. */
  firmwareVersion?: string
  /** How many independent reasons this charger carries. The ranking signal: several independent reasons predicts a genuinely broken charger far better than any single threshold crossing. */
  reasonCount?: number
  /** Every reason, with its evidence. */
  reasons?: AttentionReasonModel[]
}
export type ChargerAttentionResponse = {
  /** Start of the measured window, inclusive. Every charger shares it. Later than the requested start when the record does not reach that far back. */
  from?: string
  /** End of the measured window, exclusive. Earlier than the requested end when the record has not been written that far forward. */
  to?: string
  /** Chargers carrying at least one reason, most reasons first. */
  chargers?: ChargerAttentionModel[]
  /** How many chargers carried at least one reason, before any limit applied. */
  totalFlagged?: number
  /** The organizations the worklist was measured over, with any organization tree already expanded. Absent when it covered the whole operated fleet. */
  organizationIds?: string[]
  /** The sites the worklist was narrowed to. Absent when it was not narrowed by site. */
  siteIds?: string[]
  /** How many operated chargers were in scope. totalFlagged counts against this, so the two together say how much of the scope needs attention rather than only how many chargers do. */
  chargersInScope?: number
}
export type SiteTariffMappingsResponseModel = {
  /** Map of site IDs to their associated tariff mappings within the requested time range */
  siteTariffMappings?: {
    [key: string]: AssetTariffMappingModel[]
  }
}
export type PagedResponseV0TransactionSummaryModel = {
  first?: boolean
  last?: boolean
  pageSize?: number
  page?: number
  totalPages?: number
  totalItems?: number
  items?: TransactionSummaryModel[]
}
export type SignedMeterValueModel = {
  /** The measurand of the signed reading. */
  measurand?: string
  /** The signed meter value as reported by the charger (e.g. an OCMF blob). */
  value?: string
  /** The unit of the signed reading. */
  unit?: string
}
export type TransactionMeterValuesModel = {
  /** The ID generated by Synop for a transaction. */
  id?: string
  /** The ID for charger on which the transaction occurred. */
  chargerId?: string
  /** The ID for the connector on which the transaction occurred . */
  connectorId?: number
  /** The ID for a transaction stored by the charger. */
  transactionPk?: number
  /** The time in which the meter value was messaged at. */
  measuredAt?: string
  /** Electrical current imported by the EV. */
  currentImport?: number
  currentImportUnit?: string
  /** Electrical current offered to the EV by the charger. */
  currentOffered?: number
  currentOfferedUnit?: string
  /** Total energy imported by the EV. */
  energyActiveImportRegister?: number
  energyActiveImportRegisterUnit?: string
  /** Power instantaneously imported by the EV. */
  powerActiveImport?: number
  powerActiveImportUnit?: string
  livePowerImportUnit?: string
  /** Power offered to the EV by the charger. */
  powerOffered?: number
  powerOfferedUnit?: string
  voltage?: number
  voltageUnit?: string
  /** The temperature of the connector currently in a transaction. */
  temperature?: number
  temperatureUnit?: string
  soc?: number
  socUnit?: string
  currentExport?: number
  currentExportUnit?: string
  /** Power instantaneously exported by the EV. */
  powerActiveExport?: number
  powerActiveExportUnit?: string
  /** Total energy exported by the EV. */
  energyActiveExportRegister?: number
  energyActiveExportRegisterUnit?: string
  energyActiveImportInterval?: number
  energyActiveImportIntervalUnit?: string
  powerFactor?: number
  powerFactorUnit?: string
  /** The measuring type of the meter values */
  context?: string
  livePowerImport?: number
  /** Power instantaneously imported by the EV. */
  livePowerUnit?: string
  /** OCPP signed meter values (SignedData) recorded at this timestamp. Only populated when the request opts in via includeSignedData. */
  signedData?: SignedMeterValueModel[]
}
export type MeterValueCollectionIntervalModel = {
  /** A list of time intervals during the requested window. */
  intervals?: string[][]
  /** The mean power import, in kilowatts, during the requested window. Each index of the list corresponds to the same index in the intervals list. */
  meanPowerImport?: number[]
  /** The maximum power import, in kilowatts, during the requested window. Each index of the list corresponds to the same index in the intervals list. */
  maxPowerImport?: number[]
  /** The total energy import, in kilowatt-hours, during the requested window. Each index of the list corresponds to the same index in the intervals list. */
  totalEnergyImport?: number[]
}
export type MeterValueCollectionMetaAttributeModel = {
  /** The number of seconds defining each interval in the api response. */
  intervalPeriod: '15m'
  /** The transaction ID of the request. */
  transactionId?: string
  authTagMapping?: TransactionAuthTagMappingModel
}
export type JsonApiObjectMeterValueCollectionIntervalModelMeterValueCollectionMetaAttributeModel = {
  data?: MeterValueCollectionIntervalModel
  meta?: MeterValueCollectionMetaAttributeModel
}
export type TransactionCostCalculation = {
  transactionId?: string
  masterTariffId?: number
  tariffId?: number
  totalCost?: number
  currency?: string
  calculationProvider?: 'GENABILITY' | 'SMART_PRICES' | 'ZERO_COST' | 'UNKNOWN'
  components?: TransactionCostComponent[]
  anomalyDetected?: boolean
}
export type ServiceEventAuditModel = {
  /** The date and time that the service event was audited. */
  timestamp: string
  /** The ID of the service event. */
  eventId: string
  /** The ID of the charger that the service event is associated with. */
  chargerId: string
  /** The date and time that the service event is effective from. */
  effectiveAsOf: string
  /** The type of service event. */
  eventType: 'COMMISSIONING' | 'OUTAGE' | 'SITE_MOVE' | 'ORG_MOVE' | 'NODE_MOVE' | 'COMMS_MOVE'
  /** The commissioning state for this event */
  commissioningState?: 'PRECOMMISSIONED' | 'COMMISSIONED' | 'DECOMMISSIONED'
  /** A note or description of the service event. */
  note?: string
  /** The ID of the user that performed the operation. */
  userId?: string
  /** The ID of the organization that the user belongs to. */
  organizationId?: string
  /** The ID of the site that the charger belongs to. */
  siteId?: string
  /** The ID of the node that the charger belongs to. */
  nodeId?: string
  /** The operation that was performed on the service event. */
  operation: 'CREATE' | 'UPDATE' | 'DELETE'
  /** The ID of the organization that the charger belongs to. */
  chargerOrgId?: string
}
export type PagedResponseV0ServiceEventAuditModel = {
  first?: boolean
  last?: boolean
  pageSize?: number
  page?: number
  totalPages?: number
  totalItems?: number
  items?: ServiceEventAuditModel[]
}
export type ReportGenerationStatusModel = {
  id?: string
  status?: string
  reportUrl?: string
  requestedBy?: string
  created?: string
  updated?: string
}
export type PagedResponseV0OcppTagModel = {
  first?: boolean
  last?: boolean
  pageSize?: number
  page?: number
  totalPages?: number
  totalItems?: number
  items?: OcppTagModel[]
}
export type PowerUtilizationModel = {
  activePowerImport?: number[][]
  activePowerExport?: number[][]
  powerOffered?: number[][]
  /** Total energy import (kWh) for the collection over the specified time period. */
  totalEnergyImport?: number[][]
  /** Total energy export (kWh) for the collection over the specified time period. */
  totalEnergyExport?: number[][]
}
export type ChargingNodeAuditModel = {
  /** The date and time that the charging node was audited. */
  timestamp: string
  /** The ID of the audit. */
  id: string
  /** The ID of the site that the audit is associated with. */
  siteId: string
  /** The ID of the node that the audit is associated with. */
  nodeId: string
  /** The ID of the destination that the audit is associated with. */
  destinationId: string
  /** The name of the node. */
  name: string
  /** The ID of the charger that the audit is associated with. Only defined on ADD_CHARGE and REMOVE_CHARGER operations. */
  chargerId?: string
  /** The primary key of the user that the audit is associated with. */
  userId?: string
  /** The  organization ID of the user that performed the operation. */
  organizationId: string
  /** The operation that was performed on the charging node. */
  operation: 'CREATE' | 'UPDATE' | 'DELETE' | 'ADD_CHARGER' | 'REMOVE_CHARGER'
}
export type PagedResponseV0ChargingNodeAuditModel = {
  first?: boolean
  last?: boolean
  pageSize?: number
  page?: number
  totalPages?: number
  totalItems?: number
  items?: ChargingNodeAuditModel[]
}
export type MeterValueCollectionBySiteMetaAttributeModel = {
  /** The number of seconds defining each interval in the api response. */
  intervalPeriod: '15m'
  /** The start time of the first interval in the api response. */
  from: string
  /** The end time of the last interval in the api response. */
  to: string
}
export type JsonApiObjectMeterValueCollectionIntervalModelMeterValueCollectionBySiteMetaAttributeModel = {
  data?: MeterValueCollectionIntervalModel
  meta?: MeterValueCollectionBySiteMetaAttributeModel
}
export type GatewayRequestActivityItem = {
  requestId?: string
  time?: string
  entityId?: string
  componentId?: string
  requestType?: string
  outcome?: 'SUCCEEDED' | 'FAILED' | 'PENDING' | 'TIMEOUT'
  origin?: string
  actorId?: string
  actorType?: 'USER' | 'API_KEY' | 'SYSTEM'
  actorSource?: string
  actorOrgId?: string
}
export type PagedResponseV0GatewayRequestActivityItem = {
  first?: boolean
  last?: boolean
  pageSize?: number
  page?: number
  totalPages?: number
  totalItems?: number
  items?: GatewayRequestActivityItem[]
}
export type UptimeResponse = {
  from?: string
  to?: string
  statusAllocation?: {
    [key: string]: number
  }
  uptimePc?: number
}
export type ActiveChargerModel = {
  chargeBoxId?: string
  sessionId?: number
  connectorId?: number
  depotId?: string
  fleetId?: string
  firstEnergyImportValue?: number
  lastEnergyImportValue?: number
  latestPowerImport?: number
  latestCurrentImport?: number
  latestVoltage?: number
  isEnergyMeasurandMissing?: boolean
  isPowerEstimated?: boolean
  isVoltageMeasurandMissing?: boolean
  isCurrentMeasurandMissing?: boolean
  powerOffered?: number
  currentOffered?: number
  kwhConsumed?: number
  currentType?: string
  maxChargingSchedulePeriods?: number
  maxChargingProfileStackLevels?: number
  maxChargingProfilesInstalled?: number
}
export type LiveDepotUtilizationModel = {
  /** An external identifier for the depot. */
  externalId?: string
  /** The identifier for the depot. */
  depotId?: string
  /** Total energy consumed for all active charging sessions in a depot. */
  kwhConsumed?: number
  /** The unit for the active total energy usage */
  kwhConsumedUnit?: string
  /** A sum of voltage from all chargers that can meter voltage. */
  totalVoltage?: number
  /** The unit of voltage being used at a depot. */
  voltageUnit?: string
  /** A sum of current from all chargers that can meter current. */
  totalCurrent?: number
  /** The unit of current being used at a depot. */
  currentUnit?: string
  /** A sum of live power from all chargers that can meter power */
  totalPower?: number
  /** The unit of power being used at a depot. */
  powerUnit?: string
  /** A flag to note that total power usage calculated is estimated from other units provided by the charger.Some chargers do not provide a power unit as metered data. */
  powerCalculationEstimated?: boolean
  /** A flag to notify that total energy usage is missing values, some chargers may not provide energy metering. */
  isPartialEnergyTotal?: boolean
  /** A flag to notify that total current usage is missing values, some chargers may not provide current metering. */
  isPartialCurrentTotal?: boolean
  /** A flag to notify that total voltage usage is missing values, some chargers may not provide voltage metering. */
  isPartialVoltageTotal?: boolean
  /** A list of chargers that have had their live power usage estimated due to missing meeasurands. */
  chargersPowerEstimatedOn?: string[]
  /** A list of chargers that do not have any power metering. */
  chargersMissingPowerMeasurand?: string[]
  /** A list of chargers that do not have any energy metering. */
  chargersMissingEnergyMeasurand?: string[]
  /** A list of chargers that do not have any current metering. */
  chargersMissingCurrentMeasurand?: string[]
  /** A list of chargers that do not have any voltage metering. */
  chargersMissingVoltageMeasurand?: string[]
  /** A list of chargers that are actively charging at a depot. */
  activeChargers?: ActiveChargerModel[]
}
export type ConnectorPowerUtilizationResponse = {
  connectors?: {
    [key: string]: PowerUtilizationModel
  }
  effectiveInterval?: string
}
export type OcppLogMessageType = 'Call' | 'CallResult' | 'CallError'
export type ChargerLogEntryModel = {
  time?: string
  chargerId?: string
  messageId?: string
  messageTypeId?: number
  messageType?: OcppLogMessageType
  direction?: string
  action?: string
  organizationId?: string
  siteId?: string
  nodeId?: string
  errorCode?: string
  errorDescription?: string
  ocppMessage?: string
  /** The OCPP payload object on its own, where ocppMessage is the whole wire envelope. Clients rendering a message want this, so that the message type id and call id stay out of the displayed body. An acknowledgement carries an empty object. */
  payload?: object
}
export type PagedResponseV0ChargerLogEntryModel = {
  first?: boolean
  last?: boolean
  pageSize?: number
  page?: number
  totalPages?: number
  totalItems?: number
  items?: ChargerLogEntryModel[]
}
export type ChargerFaultsModel = {
  /** A list of error messages, mapped to the ID of a connector on which they occurred on. */
  connectorFaults?: {
    [key: string]: ConnectorStatusModel[]
  }
}
export type CollectionUtilizationResponseModel = {
  /** The last received power import values (charge) summed across all chargers in a site. This field will be populated regardless of the last time a charger has been heard from.
    If a charger does not provide a Power.Active.Import measurand, Voltage and Current will be used to calculate power.
    If Voltage and Current are not present, Power.Offered will be used instead. */
  lastKnownPowerImportKw: number
  /** The last received power import values (charge) in kiloWatts, summed across all chargers in a site. A charger's power will only be summed if it has communicated with the server in the last 15 minutes while in a transaction.
     If a charger does not provide a Power.Active.Import measurand, Voltage and Current will be used to calculate power.
    If Voltage and Current are not present, Power.Offered will be used instead. */
  livePowerImportKw: number
  /** The last received power export values (discharge) in kiloWatts, summed across all chargers in a site. A charger's power will only be summed if it has communicated with the server in the last 15 minutes while in a transaction.
     This value is summed up for all connectors on charger. */
  livePowerExportKw: number
  /** The last received power export values (discharge) in kiloWatts, summed across all chargers in a site. This field will be summed regardless of the last time a charger has been heard from.
    This value is summed up for all connectors on chargers. */
  lastKnownPowerExportKw: number
  chargersNotRecentlyHeardFrom: string[]
}
export type ChargerUtilizationResponseModel = {
  /** The last received power import values (charge) summed across all chargers in a site. This field will be populated regardless of the last time a charger has been heard from.
    If a charger does not provide a Power.Active.Import measurand, Voltage and Current will be used to calculate power.
    If Voltage and Current are not present, Power.Offered will be used instead. */
  lastKnownPowerImportKw: number
  /** The last received power import values (charge) in kiloWatts, summed across all chargers in a site. A charger's power will only be summed if it has communicated with the server in the last 15 minutes while in a transaction.
     If a charger does not provide a Power.Active.Import measurand, Voltage and Current will be used to calculate power.
    If Voltage and Current are not present, Power.Offered will be used instead. */
  livePowerImportKw: number
  /** The last received power export values (discharge) in kiloWatts, summed across all chargers in a site. A charger's power will only be summed if it has communicated with the server in the last 15 minutes while in a transaction.
     This value is summed up for all connectors on charger. */
  livePowerExportKw: number
  /** The last received power export values (discharge) in kiloWatts, summed across all chargers in a site. This field will be summed regardless of the last time a charger has been heard from.
    This value is summed up for all connectors on chargers. */
  lastKnownPowerExportKw: number
}
export type UtilizationResponseModel = {
  total?: CollectionUtilizationResponseModel
  /** A map, indexed by site ids, containing objects that represent the utilization of each site. */
  sites?: {
    [key: string]: CollectionUtilizationResponseModel
  }
  /** A map, indexed by node ids, containing objects that represent the utilization of each node. Will be null if node data was not requested. */
  nodes?: {
    [key: string]: CollectionUtilizationResponseModel
  }
  /** A map, indexed by charger ids, containing the utilization of each individually requested charger. */
  chargers?: {
    [key: string]: ChargerUtilizationResponseModel
  }
}
export type ChargersTimespanTableElementModel = {
  /** The internal id of the charger. */
  chargerPk: number
  /** The OCPP defined ID of a charger, usually provided by an OEM. */
  chargerId: string
  /** A nickname for the charger. */
  chargerName?: string
  /** The ID of the charger's site. */
  siteId?: string
  /** The total amount of transactions that occurred in the query window for a given charger. */
  totalTransactions?: number
  /** The total number of unique OCPP tags in transactions for a charger in the provided query window. */
  totalUniqueTags?: number
  /** The summed up amount of all energy dispensed (in watt-Hours) by an individual charger within the query window. */
  totalEnergyDispensedWh?: number
  /** The total amount of time (in seconds) spent in charging transactions in the provided query window. */
  totalChargeTime?: number
  /** The average transaction length (in seconds) for transactions that have occurred within the query window for an individual charger. */
  averageTransactionLength?: number
  /** The number of faults and warnings (combined) that have occurred for an individual charger within the query window. */
  totalFaults?: number
  /** The total amount of faults ('Faulted' status messages) that have occurred in the provided query window. */
  totalFaultedStatuses?: number
  /** The total amount of warnings (non-Faulted status messages with error codes) that have occurred in the provided query window. */
  totalWarnings?: number
  /** The amount of time (in seconds) that a charger was in an operative state within the query window. */
  uptimeSeconds?: number
  /** The percentage of time the charger was operative vs inoperative. */
  uptimePercentage?: number
  /** The percentage of time the charger was operative, counting only the time it was online (offline time is excluded from the denominator). Null when the charger had no online time in the query window. */
  uptimeWhileOnlinePercentage?: number
  /** The amount of time (in seconds) that the charger was offline (not reporting to the platform) within the query window. */
  offlineSeconds?: number
  /** The number of connectors associated with the charger. */
  numConnectors: number
}
export type ChargersTimespanTableModel = {
  /** The requested time interval to summarize charger data from. */
  fromTs?: string
  /** The requested time interval to summarize charger data to. */
  toTs?: string
  /** A list of objects representing an overall summary of transactions, faults, and uptime for individual  chargers. */
  chargerSummary?: ChargersTimespanTableElementModel[]
}
export type ChargersTimespanSummaryModel = {
  /** The requested time interval to summarize dashboard data from. */
  fromTs?: string
  /** The requested time interval to summarize dashboard data to. */
  toTs?: string
  /** The total amount of chargers based on the filter criteria provided. */
  totalChargers?: number
  /** The total amount of connectors based on the filter criteria provided. */
  totalConnectors?: number
  /** The total amount of transactions that occurred in the provided query window. */
  totalTransactions?: number
  /** The total amount of unique OCPP tags that were encountered in the provided query window. */
  totalUniqueTags?: number
  /** The total amount of energy dispensed (in watt-hours) in the provided query window. */
  totalEnergyDispensedWh?: number
  /** The total amount of time (in seconds) spent charging in the provided query window. */
  totalChargeTime?: number
  /** The average length of a transaction (in seconds) spent charging in the provided query window. */
  averageTransactionLength?: number
  /** The total amount of faults and warnings (combined) that have occurred in the provided query window. */
  totalFaults?: number
  /** The total amount of faults ('Faulted' status messages) that have occurred in the provided query window. */
  totalFaultedStatuses?: number
  /** The total amount of warnings (non-Faulted status messages with error codes) that have occurred in the provided query window. */
  totalWarnings?: number
  /** The amount of seconds all chargers in the query window have been in an operative state. */
  chargerUptimeSeconds?: number
  /** The percentage of time all chargers in the query window have been in an operative state. */
  chargerUptimePercentage?: number
  /** The percentage of time all chargers in the query window have been in an operative state, counting only the time they were online (offline time is excluded from the denominator). Null when there was no online time in the query window. */
  chargerUptimeWhileOnlinePercentage?: number
  /** The amount of seconds all chargers in the query window have been offline (not reporting to the platform). */
  chargerOfflineSeconds?: number
}
export type ChargerStatusHistoryModel = {
  /** The total amount of chargers included in the request.
    
    Use this to confirm your filter applied. Unrecognized query parameters are ignored rather than rejected, so a mistyped filter returns a successful response scoped to your whole organization. If this count is larger than the number of chargers you expected, check the spelling of your `siteIds` / `chargerIds` parameters. */
  numChargers: number
  /** A mapping from charger status to the amount of time (in milliseconds) spent in each state. */
  statuses: {
    [key: string]: number
  }
}
export type ConnectorStatusHistoryModel = {
  /** The total amount of connectors included in the request.
    
    Use this to confirm your filter applied. Unrecognized query parameters are ignored rather than rejected, so a mistyped filter returns a successful response scoped to your whole organization. If this count is larger than the number of connectors you expected, check the spelling of your `siteIds` / `chargerIds` parameters. */
  numConnectors: number
  /** A mapping from connector status to the amount of time (in milliseconds) spent in each state. */
  statuses: {
    [key: string]: number
  }
  /** The total number of milliseconds spent by all connectors in an operative state. This is the sum across all connectors represented in the query. */
  uptimeMs?: number
  /** The uptimeMs divided by the total "service time" of the connectors. For these purposes, a connector's service time is defined as "the number of milliseconds in the query interval that the connector spent in a status other than Unknown". */
  uptimePercentage?: number
  /** The uptimeMs divided by the connectors' service time excluding Offline time — i.e. uptime counting only the time the connectors were online (reporting a status). Null when the connectors had no online time in the query interval. */
  uptimeWhileOnlinePercentage?: number
}
export type HistoricalStatusSummaryModel = {
  /** The requested time interval to historical charger and connector status data from. */
  fromTs?: string
  /** The requested time interval to summarize historical charger and connector status data to. */
  toTs?: string
  chargerStatusHistory?: ChargerStatusHistoryModel
  connectorStatusHistory?: ConnectorStatusHistoryModel
}
export type TimespanStatsBucket = {
  timestamp?: string
  energyImportedWh?: number
  energyExportedWh?: number
  transactionsStarted?: number
  totalTransactionTime?: number
  totalTransactionStartedLength?: number
  averageTransactionLength?: number
  totalFaults?: number
  totalWarnings?: number
}
export type TimespanBucketedStatsResponseModel = {
  /** The beginning of the requested interval */
  fromTs?: string
  /** The end of the requested interval */
  toTs?: string
  /** The size of each bucket */
  intervalPeriod?: string
  /** The amount of energy dispensed in each bucket in kWh */
  buckets?: TimespanStatsBucket[]
}
export type ChargerStatusApiResponseModel = {
  /** The ID of the charger. */
  chargerId: string
  /** The configurable name of the charger. */
  chargerName?: string
  /** The ID of the connector the status occured on, an ID of 0 represents the charger as a whole. */
  connectorId?: number
  /** The configurable name of the connector. */
  connectorName: string
  /** The ID of the site the charger belongs to. */
  siteId: string
  /** The ID of the organization that the charger belongs to. */
  organizationId: string
  /** The current status of the connector. */
  status:
    | 'Available'
    | 'Preparing'
    | 'Charging'
    | 'Finishing'
    | 'SuspendedEVSE'
    | 'SuspendedEV'
    | 'Reserved'
    | 'PartiallyFaulted'
    | 'Faulted'
    | 'Unavailable'
    | 'Unknown'
    | 'Offline'
  /** The operational status of the connector. */
  operationalStatus?: 'Operative' | 'Inoperative' | 'Unknown' | 'Offline'
  /** The occupied status of the connector. */
  occupiedStatus: 'Occupied' | 'Unoccupied' | 'Unknown' | 'Offline'
  /** The error code associated with the status. All statuses should have an error code, even if it is NoError. */
  errorCode:
    | 'ConnectorLockFailure'
    | 'EVCommunicationError'
    | 'GroundFailure'
    | 'HighTemperature'
    | 'InternalError'
    | 'LocalListConflict'
    | 'NoError'
    | 'OtherError'
    | 'OverCurrentFailure'
    | 'OverVoltage'
    | 'PowerMeterFailure'
    | 'PowerSwitchFailure'
    | 'ReaderFailure'
    | 'ResetFailure'
    | 'UnderVoltage'
    | 'WeakSignal'
  /** Additional information about the error provided by the manufacturer, if applicable. */
  errorInfo?: string
  /** The vendor ID associated with the status. */
  vendorId?: string
  /** The vendor error code associated with the status. */
  vendorErrorCode?: string
  /** The time the status was recorded on the connector. */
  timestamp: string
}
export type PagedResponseV0ChargerStatusApiResponseModel = {
  first?: boolean
  last?: boolean
  pageSize?: number
  page?: number
  totalPages?: number
  totalItems?: number
  items?: ChargerStatusApiResponseModel[]
}
export type MeterValueIntervalDataSeriesModel = {
  groupKey?: {
    [key: string]: string
  }
  values?: {
    [key: string]: number[]
  }
}
export type MeterValueIntervalDataModel = {
  /** A list of time intervals during the requested window. */
  intervals?: string[][]
  /** A list of data series containing the requested time-series data. */
  series?: MeterValueIntervalDataSeriesModel[]
}
export type MeterValueIntervalMetaAttributeModel = {
  /** The number of seconds defining each interval in the api response. */
  intervalPeriod: 'none'
  /** The start time of the first interval in the api response. */
  from: string
  /** The end time of the last interval in the api response. */
  to: string
}
export type JsonApiObjectMeterValueIntervalDataModelMeterValueIntervalMetaAttributeModel = {
  data?: MeterValueIntervalDataModel
  meta?: MeterValueIntervalMetaAttributeModel
}
export type LatestConnectorStatusSummaryModel = {
  /** The total amount of connectors queried. */
  total: number
  /** A map indicating how many connectors currently have a given status. */
  currentStatuses: {
    [key: string]: number
  }
  /** A map indicating how many connectors were last known to have a given status. */
  lastKnownStatuses: {
    [key: string]: number
  }
  /** A map indicating how many connectors currently have a given operational status. */
  operationalStatuses: {
    [key: string]: number
  }
  /** A map indicating how many connectors currently have a given simplified status. */
  simplifiedStatuses: {
    [key: string]: number
  }
  /** A map indicating how many connectors currently have a given occupied status. */
  occupiedStatuses: {
    [key: string]: number
  }
}
export type LatestChargerStatusSummaryModel = {
  /** The total amount of chargers queried. */
  total: number
  /** A map indicating how many chargers currently have a given status. */
  currentStatuses: {
    [key: string]: number
  }
  /** A map indicating how many chargers were last known to have a given status. */
  lastKnownStatuses: {
    [key: string]: number
  }
  /** A map indicating how many chargers currently have a given operational status. */
  operationalStatuses: {
    [key: string]: number
  }
  /** A map indicating how many chargers currently have a given connectivity status. */
  connectivityStatuses: {
    [key: string]: number
  }
}
export type LatestStatusSummaryModel = {
  connectors: LatestConnectorStatusSummaryModel
  chargers: LatestChargerStatusSummaryModel
  /** Charger-level breakdowns of connector statuses, if requested by setting includeConnectorsByCharger=true */
  connectorsByCharger?: {
    [key: string]: LatestConnectorStatusSummaryModel
  }
  /** Site-level breakdowns of connector statuses, if requested by setting includeConnectorsBySite=true */
  connectorsBySite?: {
    [key: string]: LatestConnectorStatusSummaryModel
  }
  /** Site-level breakdowns of charger statuses, if requested by setting includeChargersBySite=true */
  chargersBySite?: {
    [key: string]: LatestChargerStatusSummaryModel
  }
  /** Node-level breakdowns of connector statuses, if requested by setting includeConnectorsByNode=true */
  connectorsByNode?: {
    [key: string]: LatestConnectorStatusSummaryModel
  }
  /** Node-level breakdowns of charger statuses, if requested by setting includeChargersByNode=true */
  chargersByNode?: {
    [key: string]: LatestChargerStatusSummaryModel
  }
}
export type ConnectorFaultModel = {
  /** The ID of the site the charger belongs to. */
  siteId: string
  /** The ID of the charger. */
  chargerId: string
  /** The name of the charger. */
  chargerName?: string
  /** The ID of the connector which faulted. */
  connectorId: number
  /** The name of the connector on which the fault occurred. */
  connectorName?: string
  /** The ID of the faulted connector status. */
  connectorStatusId: number
  /** The current status of the charger. */
  currentChargerStatus?: 'Operative' | 'Faulted' | 'Unavailable' | 'Unknown' | 'Offline' | 'PartiallyFaulted'
  /** The current status of the connector, if the connector is on the charger level (connectorId = 0) the value will be null, as connector 0 represents the charger as a whole. */
  currentConnectorStatus?:
    | 'Available'
    | 'Preparing'
    | 'Charging'
    | 'Finishing'
    | 'SuspendedEVSE'
    | 'SuspendedEV'
    | 'Reserved'
    | 'Faulted'
    | 'Unavailable'
    | 'Unknown'
    | 'Offline'
  /** The status of the connector at the time of the faulted message. */
  faultStatus?:
    | 'Available'
    | 'Preparing'
    | 'Charging'
    | 'Finishing'
    | 'SuspendedEVSE'
    | 'SuspendedEV'
    | 'Reserved'
    | 'Faulted'
    | 'Unavailable'
    | 'Unknown'
    | 'Offline'
  /** The error code reported by the connector. */
  errorCode: string
  /** Additional error information reported by the connector. */
  errorInfo?: string
  /** The name of the vendor. */
  vendor?: string
  /** A vendor-defined ID for a error code */
  vendorErrorCode?: string
  /** The time (in UTC) at which the fault occurred. */
  timestamp: string
  /** The ID of the transaction that was in progress at the time of the fault. */
  transactionId?: string
  /** The Auth. tag associated with the transaction at the time of the fault. */
  ocppTag?: string
  /** The time (in UTC) at which the faulted episode containing this fault began. An episode is the contiguous run of faulted statuses on the connector: it opens on the first faulted status, spans consecutive faulted statuses and closes on the first non-faulted one. Absent for warnings, which report a non-faulted status carrying an error code and so belong to no episode. */
  episodeStartedAt?: string
  /** The time (in UTC) at which the faulted episode containing this fault ended. Absent while the episode is still ongoing, for warnings, and when the closing status falls outside the configured lookahead. */
  episodeEndedAt?: string
  /** Whether the faulted episode containing this fault is still open, i.e. the connector is faulted as of now. Absent for warnings. */
  ongoing?: boolean
}
export type PagedResponseV0ConnectorFaultModel = {
  first?: boolean
  last?: boolean
  pageSize?: number
  page?: number
  totalPages?: number
  totalItems?: number
  items?: ConnectorFaultModel[]
}
export type EnergyInterval = {
  /** The start time of the interval */
  timestamp?: string
  /** The energy allocated to this interval in kWh */
  kwh?: number
}
export type BaselineSeriesResponse = {
  /** The site (depot) ID for which the series were computed */
  siteId?: string
  /** The start of the time window for the series */
  from?: string
  /** The end of the time window for the series (exclusive) */
  to?: string
  /** The baseline energy series as 15-minute interval data points. Each point represents the energy that would have been consumed if transactions charged at max power from start until their total energy was depleted. */
  baselineEnergySeries?: EnergyInterval[]
  /** The actual energy series as 15-minute interval data points. Each point represents the actual energy consumed during that interval based on meter data. */
  actualEnergySeries?: EnergyInterval[]
  /** The total calculated cost for the baseline energy series (energy + demand). Null if pricing data is unavailable. */
  baselineCostTotal?: number
  /** The total calculated cost for the actual energy series (energy + demand). Null if pricing data is unavailable. */
  actualCostTotal?: number
  /** The energy cost (kWh-based) for the baseline series. Null if pricing data is unavailable. */
  baselineEnergyCost?: number
  /** The energy cost (kWh-based) for the actual series. Null if pricing data is unavailable. */
  actualEnergyCost?: number
  /** The demand charge cost for the baseline series (peak kW * demand rate). Null if pricing data is unavailable. */
  baselineDemandCost?: number
  /** The demand charge cost for the actual series (peak kW * demand rate). Null if pricing data is unavailable. */
  actualDemandCost?: number
  /** The ISO currency code for the cost values (e.g., 'USD'). Null if pricing data is unavailable. */
  currency?: string
}
export type DailyRecord = {
  /** The site (depot) ID */
  siteId?: string
  /** The site-local date for this record */
  date?: string
  /** Actual energy cost (smart prices × actual kWh) */
  actualEnergyCost?: number
  /** Baseline energy cost (smart prices × baseline kWh) */
  baselineEnergyCost?: number
  /** Actual demand cost apportioned to this day (cycle demand charge / days in cycle). Subject to change for billing cycles still in progress */
  actualDemandCost?: number
  /** Baseline demand cost apportioned to this day. Subject to change for billing cycles still in progress */
  baselineDemandCost?: number
  /** Actual total kWh consumed */
  actualTotalKwh?: number
  /** Baseline total kWh (at max charger power) */
  baselineTotalKwh?: number
  /** Whether the billing cycle containing this day is complete */
  cycleComplete?: boolean
  /** Start date of the billing cycle containing this day */
  billingCycleStart?: string
  /** End date (exclusive) of the billing cycle containing this day */
  billingCycleEnd?: string
}
export type CostBucket = {
  /** Total energy cost (sum of daily energy costs) */
  energyCost?: number
  /** Total demand cost (sum of daily demand costs). Subject to change for billing cycles still in progress */
  demandCost?: number
  /** Total cost (energy + demand) */
  totalCost?: number
  /** Total kWh consumed */
  totalKwh?: number
  /** Weighted average cost per kWh = totalCost / totalKwh. Null when totalKwh=0 */
  costPerKwh?: number
}
export type CostSummary = {
  actual?: CostBucket
  baseline?: CostBucket
  /** Net savings: baseline total cost minus actual total cost */
  savings?: number
}
export type BaselineDailyResponseModel = {
  /** The site IDs included in this response */
  siteIds?: string[]
  /** Start date of the queried range (inclusive) */
  from?: string
  /** End date of the queried range (exclusive) */
  to?: string
  /** ISO currency code (e.g. 'USD') */
  currency?: string
  /** Daily cost records ordered by date */
  days?: DailyRecord[]
  summary?: CostSummary
}
export type CycleSummaryBlock = {
  /** Start date of the billing cycle (inclusive) */
  cycleStart?: string
  /** End date of the billing cycle (exclusive) */
  cycleEnd?: string
  /** Billing anchor day (1-28) */
  anchorDay?: number
  /** Total number of days in this billing cycle */
  daysInCycle?: number
  /** Whether this billing cycle is complete */
  cycleComplete?: boolean
  /** Daily cost records within this billing cycle */
  days?: DailyRecord[]
  summary?: CostSummary
}
export type BaselineDailyCyclesResponseModel = {
  /** The site (depot) ID */
  siteId?: string
  /** ISO currency code (e.g. 'USD') */
  currency?: string
  /** Billing cycles ordered from most recent to oldest */
  cycles?: CycleSummaryBlock[]
  /** Whether more billing cycles exist before the oldest returned cycle. Use the oldest cycle's start date as the 'before' cursor to fetch the next page. */
  hasMore?: boolean
}
export type ProfileApplicationRecordModel = {
  /** Gateway request id for this application attempt. */
  id?: string
  /** When the profile application was requested (UTC). */
  applicationTime?: string
  /** Charger entity id. */
  chargerId?: string
  /** Connector scope for the application; "0" means whole charger */
  dispenserId?: string
  /** Synop profile id when present on the snapshot payload; otherwise null. */
  profileId?: string | null
  /** Derived status from gateway result error payload, if any. */
  applicationStatus?:
    | 'PENDING'
    | 'ACCEPTED'
    | 'FAILED'
    | 'REJECTED'
    | 'TIMEOUT'
    | 'NOT_CONNECTED'
    | 'NOT_SUPPORTED'
    | 'INVALID'
    | 'CONFLICT'
  /** Profile purpose derived from the applied snapshot, when a profile is present. */
  profileType?: ('ChargePointMaxProfile' | 'TxDefaultProfile' | 'TxProfile') | null
  /** Origin metadata when present on the snapshot; otherwise omitted. */
  origin?: string | null
  appliedProfile?: ChargeProfileModel
  /** Human-readable description of the application status. */
  statusDescription?: string
}
export type PagedResponseV0ProfileApplicationRecordModel = {
  first?: boolean
  last?: boolean
  pageSize?: number
  page?: number
  totalPages?: number
  totalItems?: number
  items?: ProfileApplicationRecordModel[]
}
export type PagedResponseV0ChargerManufacturerModel = {
  first?: boolean
  last?: boolean
  pageSize?: number
  page?: number
  totalPages?: number
  totalItems?: number
  items?: ChargerManufacturerModel[]
}
export type PagedResponseV0ChargerMakeModelResponseModel = {
  first?: boolean
  last?: boolean
  pageSize?: number
  page?: number
  totalPages?: number
  totalItems?: number
  items?: ChargerMakeModelResponseModel[]
}
export type ChargerDiagnosticsAuditResponseModel = {
  /** The ID of the diagnostics request */
  requestId: string
  /** The ID of the charger */
  chargerId: string
  /** The timestamp when the audit entry was created */
  timestamp: string
  /** The ID of the user who performed the operation */
  userId?: string
  /** The ID of the organization of the requestor */
  organizationId: string
  /** The operation performed (CREATE, DELETE, etc.) */
  operation: 'CREATE' | 'UPDATE' | 'DELETE'
}
export type PagedResponseV0ChargerDiagnosticsAuditResponseModel = {
  first?: boolean
  last?: boolean
  pageSize?: number
  page?: number
  totalPages?: number
  totalItems?: number
  items?: ChargerDiagnosticsAuditResponseModel[]
}
export type ClearConnectorProfilesRequest = {
  /** The identifier, provided by the OEM or Synop, for the charger you wish to clear profiles on */
  chargerId: string
  /** The connector to clear charging profiles from. A value of 0 targets only charge-point-level profiles (OCPP connector 0), not every connector. Omit this field to clear profiles across all connectors on the charger. */
  connectorId?: number
  /** Optional filter to only clear profiles with the specified purpose type. If omitted, all profiles on the connector are cleared. */
  chargingProfilePurpose?: 'ChargePointMaxProfile' | 'TxDefaultProfile' | 'TxProfile'
  /** Optional filter to only clear profiles at the specified stack level. If omitted, profiles at all stack levels are cleared. */
  stackLevel?: number
}
export const {
  useGetChargerDestinationQuery,
  useLazyGetChargerDestinationQuery,
  useAssignChargerDestinationMutation,
  useSetRequiredMutation,
  useSetCredentialsMutation,
  useUpdateTariffAssociationMutation,
  useCancelTariffAssociationMutation,
  useGetServiceEventQuery,
  useLazyGetServiceEventQuery,
  useUpdateServiceEventMutation,
  useDeleteServiceEventMutation,
  useGetChargeProfilesQuery,
  useLazyGetChargeProfilesQuery,
  useUpdateChargeProfileMutation,
  useSaveChargeProfileMutation,
  useClearChargingProfileMutation,
  useGetDepotsQuery,
  useLazyGetDepotsQuery,
  useUpdateDepotMutation,
  useCreateDepotMutation,
  useGetDepotEnergyLimitsQuery,
  useLazyGetDepotEnergyLimitsQuery,
  useUpdateDepotEnergyLimitsMutation,
  useGetChargersQuery,
  useLazyGetChargersQuery,
  useUpdateChargerMutation,
  useCreateChargerMutation,
  useReassembleMutation,
  useListBackfillsForChargerQuery,
  useLazyListBackfillsForChargerQuery,
  useStartBackfillMutation,
  useListRulesQuery,
  useLazyListRulesQuery,
  useCreateRuleMutation,
  useAssignChargersToDestinationMutation,
  useSubmitGetCompositeScheduleMutation,
  useUpdatePasswordMutation,
  useCreateMappingMutation,
  useGetSiteLifecycleStatesMutation,
  useUploadDiagnosticsMutation,
  useGetChargerLifecycleStatesMutation,
  useGetServiceEventsQuery,
  useLazyGetServiceEventsQuery,
  useCreateServiceEventMutation,
  useBulkCommissionDecommissionChargersMutation,
  useSetChargeProfileMutation,
  useCmsOcppTagsGetTagsQuery,
  useLazyCmsOcppTagsGetTagsQuery,
  useCmsOcppTagsAddTagsMutation,
  useCmsOcppTagsRemoveTagsMutation,
  useCmsOcppTagsAuthorizeTagsMutation,
  useCmsOcppConfigurationChangeConfigurationMutation,
  useCmsOcppConfigurationRefreshConfigurationsMutation,
  useCmsChargersGetChargingNodesQuery,
  useLazyCmsChargersGetChargingNodesQuery,
  useCmsChargersCreateChargingNodeMutation,
  useCmsChargersAddToNodeMutation,
  useCmsChargersGetChargingNodes1Query,
  useLazyCmsChargersGetChargingNodes1Query,
  useCmsChargersCreateChargingNode1Mutation,
  useCmsChargersAddToNode1Mutation,
  useUpdateFirmwareMutation,
  useStopChargingTransactionMutation,
  useStartChargingTransactionMutation,
  useSetUserPriceMutation,
  useSendRunningCostMutation,
  useSendFinalCostMutation,
  useResetChargerMutation,
  useReserveNowMutation,
  useModifyWebsocketConnectionMutation,
  useGetDataTransferResultQuery,
  useLazyGetDataTransferResultQuery,
  useSendDataTransferMutation,
  useCancelReservationMutation,
  useUnlockConnectorMutation,
  useTriggerConnectorMessageMutation,
  useTriggerChargerMessageMutation,
  useCmsOcppDestinationGetMultipleOcppDestinationsQuery,
  useLazyCmsOcppDestinationGetMultipleOcppDestinationsQuery,
  useCmsOcppDestinationCreateOcppDestinationMutation,
  useChangeAvailabilityMutation,
  useGetDiagnosticsRequestsQuery,
  useLazyGetDiagnosticsRequestsQuery,
  useRequestDiagnosticsMutation,
  useOverrideOcppTagMutation,
  useGetRuleQuery,
  useLazyGetRuleQuery,
  useDeleteRuleMutation,
  useUpdateRuleMutation,
  useGetMappingsQuery,
  useLazyGetMappingsQuery,
  useDeleteMappingMutation,
  useUpdateMappingMutation,
  useCmsChargersGetChargingNodeQuery,
  useLazyCmsChargersGetChargingNodeQuery,
  useCmsChargersDeleteChargingNodeMutation,
  useCmsChargersUpdateChargingNodeMutation,
  useCmsChargersGetChargingNode1Query,
  useLazyCmsChargersGetChargingNode1Query,
  useCmsChargersDeleteChargingNode1Mutation,
  useCmsChargersUpdateChargingNode1Mutation,
  useCmsOcppDestinationGetOcppDestinationQuery,
  useLazyCmsOcppDestinationGetOcppDestinationQuery,
  useCmsOcppDestinationDeleteOcppDestinationMutation,
  useCmsOcppDestinationUpdateOcppDestinationMutation,
  useListOverridesQuery,
  useLazyListOverridesQuery,
  useGetBackfillStatusQuery,
  useLazyGetBackfillStatusQuery,
  useGetSitesQuery,
  useLazyGetSitesQuery,
  useGetSiteQuery,
  useLazyGetSiteQuery,
  useGetOcppConfigurationHistoryQuery,
  useLazyGetOcppConfigurationHistoryQuery,
  useGetConfigurationChangesQuery,
  useLazyGetConfigurationChangesQuery,
  useGetEventsQuery,
  useLazyGetEventsQuery,
  useGetConfigQuery,
  useLazyGetConfigQuery,
  useGetConnectionEventsQuery,
  useLazyGetConnectionEventsQuery,
  useGetRawEventsQuery,
  useLazyGetRawEventsQuery,
  useGetMessageActivityQuery,
  useLazyGetMessageActivityQuery,
  useGetFleetOnlineQuery,
  useLazyGetFleetOnlineQuery,
  useGetAttentionWorklistQuery,
  useLazyGetAttentionWorklistQuery,
  useGetSiteTariffMappingsQuery,
  useLazyGetSiteTariffMappingsQuery,
  useGetAssetTariffMappingsQuery,
  useLazyGetAssetTariffMappingsQuery,
  useGetChargingTransactionsQuery,
  useLazyGetChargingTransactionsQuery,
  useGetTransactionByIdQuery,
  useLazyGetTransactionByIdQuery,
  useGetTransactionMeterValuesQuery,
  useLazyGetTransactionMeterValuesQuery,
  useCmsChargingTransactionsGetMeterValueIntervalDataQuery,
  useLazyCmsChargingTransactionsGetMeterValueIntervalDataQuery,
  useCmsChargingTransactionsInferStopQuery,
  useLazyCmsChargingTransactionsInferStopQuery,
  useGetCostCalculationForTransactionQuery,
  useLazyGetCostCalculationForTransactionQuery,
  useGetServiceEventAuditQuery,
  useLazyGetServiceEventAuditQuery,
  useGetTransactionsReportQuery,
  useLazyGetTransactionsReportQuery,
  useCmsReportsGetStatusOfTransactionReportQuery,
  useLazyCmsReportsGetStatusOfTransactionReportQuery,
  useGetMeterValueIntervalsReportQuery,
  useLazyGetMeterValueIntervalsReportQuery,
  useGetMeterValueIntervalsReportStatusQuery,
  useLazyGetMeterValueIntervalsReportStatusQuery,
  useGetChargeProfileQuery,
  useLazyGetChargeProfileQuery,
  useCmsOcppTagsFilterTagsQuery,
  useLazyCmsOcppTagsFilterTagsQuery,
  useCmsOcppConfigurationGetLatestConfigurationsQuery,
  useLazyCmsOcppConfigurationGetLatestConfigurationsQuery,
  useCmsOcppConfigurationGetLatestConfigurationsForChargerQuery,
  useLazyCmsOcppConfigurationGetLatestConfigurationsForChargerQuery,
  useCmsOcppConfigurationGetRefreshStatusForChargerQuery,
  useLazyCmsOcppConfigurationGetRefreshStatusForChargerQuery,
  useCmsOcppConfigurationGetRefreshStatusQuery,
  useLazyCmsOcppConfigurationGetRefreshStatusQuery,
  useCmsNodeUtilizationQuery,
  useLazyCmsNodeUtilizationQuery,
  useCmsGetChargingNodeAuditQuery,
  useLazyCmsGetChargingNodeAuditQuery,
  useGetMeterDataIntervalsBySiteQuery,
  useLazyGetMeterDataIntervalsBySiteQuery,
  useCmsNodeUtilization1Query,
  useLazyCmsNodeUtilization1Query,
  useCmsGetChargingNodeAudit1Query,
  useLazyCmsGetChargingNodeAudit1Query,
  useGetActivityQuery,
  useLazyGetActivityQuery,
  useGetDepotQuery,
  useLazyGetDepotQuery,
  useDeleteDepotMutation,
  useGetDepotUtilizationQuery,
  useLazyGetDepotUtilizationQuery,
  useGetDepotUptimeQuery,
  useLazyGetDepotUptimeQuery,
  useGetDepotStatusQuery,
  useLazyGetDepotStatusQuery,
  useGetChargerQuery,
  useLazyGetChargerQuery,
  useDeleteChargerMutation,
  useGetChargerUtilizationTimelineQuery,
  useLazyGetChargerUtilizationTimelineQuery,
  useGetChargerUtilizationTimelineByConnectorQuery,
  useLazyGetChargerUtilizationTimelineByConnectorQuery,
  useGetChargerUptimeQuery,
  useLazyGetChargerUptimeQuery,
  useGetMappedChargerProfilesQuery,
  useLazyGetMappedChargerProfilesQuery,
  useGetChargerLogsReportQuery,
  useLazyGetChargerLogsReportQuery,
  useGetChargerLogEntriesQuery,
  useLazyGetChargerLogEntriesQuery,
  useGetChargerFaultsQuery,
  useLazyGetChargerFaultsQuery,
  useGetChargerConnectorsQuery,
  useLazyGetChargerConnectorsQuery,
  useGetCapabilitySetQuery,
  useLazyGetCapabilitySetQuery,
  useCmsUtilizationGetUtilizationQuery,
  useLazyCmsUtilizationGetUtilizationQuery,
  useGetChargersTableDataQuery,
  useLazyGetChargersTableDataQuery,
  useGetSummaryDataQuery,
  useLazyGetSummaryDataQuery,
  useCmsTimespanGetHistoricalStatusesQuery,
  useLazyCmsTimespanGetHistoricalStatusesQuery,
  useGetEnergyOverTimeQuery,
  useLazyGetEnergyOverTimeQuery,
  useCmsChargersGetChargerStatusQuery,
  useLazyCmsChargersGetChargerStatusQuery,
  useCmsOcppLogsGetStatusOfOcppLogsRequestQuery,
  useLazyCmsOcppLogsGetStatusOfOcppLogsRequestQuery,
  useCmsMeterDataIntervalsQuery,
  useLazyCmsMeterDataIntervalsQuery,
  useGetLatestStatusSummaryQuery,
  useLazyGetLatestStatusSummaryQuery,
  useCmsChargerFaultsGetFaultsQuery,
  useLazyCmsChargerFaultsGetFaultsQuery,
  useGetBaselineSeriesQuery,
  useLazyGetBaselineSeriesQuery,
  useGetBaselineDailyQuery,
  useLazyGetBaselineDailyQuery,
  useGetBaselineDailyCyclesQuery,
  useLazyGetBaselineDailyCyclesQuery,
  useGetProfileHistoriesQuery,
  useLazyGetProfileHistoriesQuery,
  useGetManufacturersQuery,
  useLazyGetManufacturersQuery,
  useGetManufacturerMakeModelsQuery,
  useLazyGetManufacturerMakeModelsQuery,
  useGetDiagnosticsStatusQuery,
  useLazyGetDiagnosticsStatusQuery,
  useCancelDiagnosticsRequestMutation,
  useGetDiagnosticsAuditQuery,
  useLazyGetDiagnosticsAuditQuery,
  useClearAllConnectorProfilesMutation
} = injectedRtkApi
